import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import UserProjects from "../Static Files/UserProjects.json";
import NumberToPersianWord from "number_to_persian_word";
import GetPrice from "../Functions/GetPrice";
import getPriceBasket from "../Functions/getPriceBasket";
import { useDispatch, useSelector } from "react-redux";
import authHeader from "../Services/auth-header";
import { refreshToken } from "../Services/auth.service";
import { CartUpdatedTrue, ShowLogin2Modal } from "../Actions/types";
import Select from "react-dropdown-select";
import CustomControlFiles from "../Components/CustomControlFiles";
import Modal from "react-bootstrap/Modal";
import GetUserProjectData from "../Functions/GetUserProjectData";
import { convertToPersian } from "../Functions/TextTransform";
import { Accordion, AccordionContext, useAccordionButton } from "react-bootstrap";
import { IoDocumentTextOutline } from "react-icons/io5";
import { HiOutlinePhotograph } from "react-icons/hi";
import {
  NumToFa,
  CapitalizeAllWords,
  capitalizeWordsText,
  capitalizeIfEnglish,
} from "../Functions/TextTransform";
import ShowMoreLineLimited from "../Components/ShowMoreLineLimited";
import {
  DkMultiFabricAccordion,
  mergeDkFabricCartObj,
  resolveDkMonoFabricLabel,
} from "../Components/DkSideCartFabricDisplay";
import {
  formatCombinedOutsideMountLabel,
  normalizeOutsideMountSubType,
} from "../Components/draperyUi";
import { useMediaQuery } from "react-responsive";
import GetMeasurementArray from "../Functions/GetMeasurementArray";
import {
  imgUrl,
  baseURLAddProject,
  baseURLZipCode,
  baseURLFreeShipping,
  baseURLGetCart,
  baseURLDeleteFile,
  baseURLDeleteBasketProject,
  baseAddCountProject,
  baseURLEditProject,
  baseURLAddProduct,
  baseURLSaveForLaterBasketProject,
  baseURLChangeZipcode,
} from "../config/api";

/** DK (0326): show Control Type before Control Position in customize details. */
function getDkBasketDetailOrder(sewingModelId, tempObj, userProjects) {
  if (sewingModelId !== "0326" || tempObj?.order === undefined || tempObj.order < 0) {
    return tempObj?.order;
  }
  const controlTypeObj = userProjects.find((o) => o.cart === "ControlType");
  const controlPositionObj = userProjects.find((o) => o.cart === "ControlPosition");
  if (!controlTypeObj || !controlPositionObj) {
    return tempObj.order;
  }
  const field = tempObj.cart || tempObj.apiLabel;
  if (field === "ControlPosition") {
    return controlTypeObj.order;
  }
  if (field === "ControlType") {
    return controlPositionObj.order;
  }
  return tempObj.order;
}

function buildCartHardwareLabel({
  hardwareValue,
  railDesignFa,
  railDesignEn,
  railColorFa,
  railColorEn,
  batonOption,
  controlPosition,
  pageLanguage,
  t,
}) {
  if (!hardwareValue || hardwareValue === "None") {
    return "";
  }

  if (railDesignEn === "Motorized Track") {
    const design = pageLanguage === "fa" ? railDesignFa : railDesignEn;
    return [t(hardwareValue.toString()), design].filter(Boolean).join(" / ");
  }

  const design = pageLanguage === "fa" ? railDesignFa : railDesignEn;
  const color = pageLanguage === "fa" ? railColorFa : railColorEn;
  let batonOrControl = "";
  if (batonOption && batonOption !== "None") {
    batonOrControl = t(batonOption);
  } else if (controlPosition) {
    batonOrControl = t(controlPosition);
  }

  return [t(hardwareValue.toString()), design, color, batonOrControl]
    .filter((part) => part !== undefined && part !== null && String(part).trim() !== "")
    .join(" / ");
}

function isBasketItemUnavailable(item) {
  if (!item) return false;
  if (item.IsAvailable === false || item.NotAvailable === true || item.HasUnavailableComponent === true) {
    return true;
  }
  if (item.StockQty != null && Number(item.StockQty) === 0) return true;
  const sewing = item.SewingOrder;
  if (sewing) {
    if (
      sewing.IsAvailable === false ||
      sewing.NotAvailable === true ||
      sewing.HasUnavailableComponent === true
    ) {
      return true;
    }
    if (sewing.StockQty != null && Number(sewing.StockQty) === 0) return true;
  }
  const preorder = sewing?.PreorderText || item.PreorderText;
  if (preorder?.HasUnavailableComponent === true || preorder?.IsAvailable === false) {
    return true;
  }
  return false;
}

function hasBasketItemPriceChanged(item) {
  if (!item) return false;
  if (item.PriceChanged === true) return true;
  const oldPrice = item.OldPrice ?? item.PreviousPrice;
  if (oldPrice == null) return false;
  const current =
    item.UnitPrice ?? item.PayableAmount ?? item.Price ?? item.SewingOrder?.Price ?? null;
  if (current == null) return false;
  return Number(oldPrice) !== Number(current);
}

function Basket() {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const { swatchOnly } = useParams();
  const [pageLanguage, setPageLanguage] = useState(
    location.pathname
      .split("")
      .slice(1, 3)
      .join("")
  );
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 923px)" });
  const { isLoggedIn, showLogin2, sideCartPrice, SideDiscountedPrice } = useSelector(
    (state) => state.auth
  );
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const firstRender = useRef(true);
  const [firstFetch, setFirstFetch] = useState(true);
  const [noShipping, setNoShipping] = useState(false);
  const [subTotalPrice, setSubTotalPrice] = useState(0);
  const [installPrice, setInstallPrice] = useState(0);
  const [transportPrice, setTransportPrice] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);
  const [freeShipPrice, setFreeShipPrice] = useState(0);
  const [cart, setCart] = useState({});
  const [drapery, setDrapery] = useState([]);
  const [draperyCount, setDraperyCount] = useState(0);
  const [product, setProduct] = useState([]);
  const [productCount, setProductCount] = useState(0);
  const [draperyProduct, setDraperyProduct] = useState([]);
  const [draperyProductList, setDraperyProductList] = useState([]);
  const [draperyProductCount, setDraperyProductCount] = useState(0);
  const [swatches, setSwatches] = useState([]);
  const [swatchesList, setSwatchesList] = useState([]);
  const [swatchesTotalPrice, setSwatchesTotalPrice] = useState(0);
  const [swatchesCount, setSwatchesCount] = useState(0);
  const [cartChanged, setCartChanged] = useState(0);
  const [objCartDetailId, setObjCartDetailId] = useState(null);
  const draperyRef = useRef({});
  const [projectDataPrice, setProjectDataPrice] = useState(null);
  const [loginAwaiting, setLoginAwaiting] = useState({});
  const [zipcodeText, setZipcodeText] = useState("");
  const [zipcodeText2, setZipcodeText2] = useState("");
  const [show, setShow] = useState(false);
  const [zoomModalHeader, setZoomModalHeader] = useState([]);
  const [zoomModalBody, setZoomModalBody] = useState([]);
  const [files, setFiles] = useState({});
  const [cartVersion, setCartVersion] = useState(0);
  const [modals, setModals] = useState({});

  const [zipcodeId, setZipcodeId] = useState(-1);
  const [zipcodeAll, setZipcodeAll] = useState("");
  const [originalZipcode, setOriginalZipcode] = useState("");
  const [hasInstall, setHasInstall] = useState(null);
  const [zipcodeButton, setZipcodeButton] = useState(false);
  const [editUnderConstructionId, setEditUnderConstructionId] = useState(null);
  const editUnderConstructionTimeoutRef = useRef(null);

  function showEditUnderConstructionMessage(sewingOrderId) {
    if (editUnderConstructionTimeoutRef.current) {
      clearTimeout(editUnderConstructionTimeoutRef.current);
    }
    setEditUnderConstructionId(sewingOrderId);
    editUnderConstructionTimeoutRef.current = setTimeout(() => {
      setEditUnderConstructionId(null);
      editUnderConstructionTimeoutRef.current = null;
    }, 5000);
  }

  useEffect(() => {
    return () => {
      if (editUnderConstructionTimeoutRef.current) {
        clearTimeout(editUnderConstructionTimeoutRef.current);
      }
    };
  }, []);

  function modalHandleClose(modalName) {
    let tempModals = JSON.parse(JSON.stringify(modals));
    tempModals[modalName] = false;
    setModals(tempModals);
  }

  function modalHandleShow(modalName) {
    let tempModals = JSON.parse(JSON.stringify(modals));

    tempModals[modalName] = true;
    setModals(tempModals);
  }

  function ContextAwareToggleViewDetails({
    eventKey,
    callback,
    textOnHide,
    textOnShow,
    textOnHide2,
    textOnShow2,
    type,
  }) {
    const { activeEventKey } = useContext(AccordionContext);

    const decoratedOnClick = useAccordionButton(eventKey, () => callback && callback(eventKey));

    const isCurrentEventKey = activeEventKey === eventKey;

    return (
      <>
        {type === 2 && (
          <>
            <div className="dropdown_button_container_left">
              <h3 className="dk_curtain_preview_item_details 1">
                {isCurrentEventKey ? textOnShow2 : textOnHide2}
              </h3>
            </div>
            <div className="dropdown_button_container_right">
              <button
                className="basket_item_title_dropdown_btn"
                aria-expanded={`${isCurrentEventKey}`}
                type="button"
                onClick={decoratedOnClick}
              >
                <h4 className="dk_curtain_preview_item_details 2">
                  {isCurrentEventKey ? textOnShow : textOnHide}
                </h4>
              </button>
            </div>
          </>
        )}
        {(type === undefined || type === 1) && (
          <button
            className="basket_item_title_dropdown_btn"
            aria-expanded={`${isCurrentEventKey}`}
            type="button"
            onClick={decoratedOnClick}
          >
            <h4 className="dk_curtain_preview_item_details 3">
              {isCurrentEventKey ? textOnShow : textOnHide}
            </h4>
          </button>
        )}
      </>
    );
  }

  function removeZipcode(refIndex) {
    if (isLoggedIn) {
      let temp = JSON.parse(JSON.stringify(cart))["CartDetails"];
      let tempProjectContainer = temp.find((opt) => opt["CartDetailId"] === refIndex);
      if (Object.keys(tempProjectContainer).length !== 0) {
        let tempProject = tempProjectContainer["SewingOrder"];
        tempProject["Count"] = tempProject["WindowCount"];
        tempProject["PreorderText"]["InstallAmount"] = 0;
        tempProject["PreorderText"]["TransportationAmount"] = 0;
        tempProject["PreorderText"]["ZipCode"] = "";
        tempProject["PreorderText"]["NeedInstall"] = false;
        tempProject["InstallAmount"] = 0;
        tempProject["TransportationAmount"] = 0;
        tempProject["ZipCode"] = "";
        tempProject["NeedInstall"] = false;
        editBasketProject(tempProject);
      }
    } else {
      let tempObj = JSON.parse(JSON.stringify(drapery[refIndex]));
      tempObj["PreorderText"]["InstallAmount"] = 0;
      tempObj["PreorderText"]["TransportationAmount"] = 0;
      tempObj["PreorderText"]["ZipCode"] = "";
      tempObj["InstallAmount"] = 0;
      tempObj["TransportationAmount"] = 0;
      tempObj["ZipCode"] = "";
      tempObj["NeedInstall"] = false;

      if (localStorage.getItem("cart") !== null) {
        let cartObj = JSON.parse(localStorage.getItem("cart"));
        if (cartObj["drapery"] === undefined) cartObj["drapery"] = [];
        cartObj["drapery"][refIndex] = tempObj;
        localStorage.setItem("cart", JSON.stringify(cartObj));
        setCartChanged(cartChanged + 1);
      } else {
        let newCartObj = {};
        let newCartArr = [];
        newCartArr[0] = tempObj;
        newCartObj["drapery"] = newCartArr;
        newCartObj["product"] = [];
        newCartObj["swatches"] = [];
        localStorage.setItem("cart", JSON.stringify(newCartObj));
        setCartChanged(cartChanged + 1);
      }
    }
  }

  function getCartItemIds(item) {
    if (!item) return [];
    return [
      item.ProductId,
      item.productId,
      item.fabricItemId,
      item.FabricId,
      item.FabricId2,
      item.product && item.product.ProductId,
      item.product && item.product.productId,
    ].filter((id) => id !== undefined && id !== null);
  }

  function cartItemMatchesId(item, refIndex) {
    const targetId = String(refIndex);
    if (targetId.includes("_")) {
      const [fabricId, sewingModelId] = targetId.split("_");
      return (
        String(item.FabricId) === fabricId && String(item.SewingModelId) === sewingModelId
      );
    }
    return getCartItemIds(item).some((id) => String(id) === targetId);
  }

  function getGuestCartRemoveId(obj1) {
    if (obj1["fabricItemId"]) return obj1["fabricItemId"];
    if (obj1["ProductId"]) return obj1["ProductId"];
    if (obj1["FabricId2"]) return obj1["FabricId2"];
    if (obj1["FabricId"] && obj1["SewingModelId"]) {
      return `${obj1["FabricId"]}_${obj1["SewingModelId"]}`;
    }
    return obj1["FabricId"];
  }

  function setBasketNumber(refIndex, numValue, type, minusPlus, ItemLength) {
    console.log(`refIndex`, refIndex);
    if (isLoggedIn) {
      let temp = JSON.parse(JSON.stringify(cart))["CartDetails"];

      let tempProjectContainer = temp.find((opt) => opt["CartDetailId"] === refIndex);

      if (Object.keys(tempProjectContainer).length !== 0) {
        let tempProject = {};
        if (tempProjectContainer["TypeId"] === 6403) {
          tempProject = tempProjectContainer["SewingOrder"];

          tempProject["Count"] = tempProject["WindowCount"];
        } else {
          tempProject = tempProjectContainer;
        }

        if (tempProject["ProductGroupId"] === "100702") {
          if (type === 1 && minusPlus !== undefined) {
            if (tempProject["Count"] + minusPlus > 50) return;
          } else if (type === 1 && numValue > 50) {
            numValue = 50;
          }
        }

        if (type === 1) {
          if (minusPlus !== undefined) {
            addProduct(tempProject["ProductId"], minusPlus, ItemLength);
          } else {
            if (parseInt(numValue) > 10) {
              addProduct(tempProject["ProductId"], 10, ItemLength);
            } else if (parseInt(numValue) <= 0) {
              deleteBasketProject(refIndex);
            } else {
              addProduct(
                tempProject["ProductId"],
                parseInt(numValue) - parseInt(tempProject["Count"], ItemLength)
              );
            }
          }
        } else {
          if (minusPlus !== undefined) {
            if (tempProject["Count"] + minusPlus <= 0 || tempProject["Count"] + minusPlus > 10)
              setBasketNumber(refIndex, tempProject["Count"] + minusPlus, type);
            else {
              tempProject["Count"] = tempProject["Count"] + minusPlus;
              tempProject["WindowCount"] = tempProject["Count"];
              console.log("255");
              editBasketProject(tempProject, minusPlus, refIndex);
            }
          } else {
            let oldCount = tempProject["Count"];
            if (numValue === "") {
              tempProject["Count"] = 1;
              let countChange = 1 - oldCount;
              console.log("263");
              editBasketProject(tempProject, countChange);
            } else if (!isNaN(numValue) || numValue === 10 || numValue === "10") {
              if (parseInt(numValue) > 10) {
                tempProject["Count"] = 10;
                let countChange = 10 - oldCount;
                console.log("269");
                editBasketProject(tempProject, countChange);
              } else if (parseInt(numValue) <= 0) {
                deleteBasketProject(refIndex);
              } else {
                tempProject["Count"] = parseInt(numValue);
                let countChange = parseInt(numValue) - oldCount;
                console.log("276");
                editBasketProject(tempProject, countChange);
              }
            }
          }
        }
      }
    } else {
      let temp = [];
      let typeString = "";
      let cartObj = {};

      if (type === 0 || type === 1) {
        if (localStorage.getItem("cart") !== null) {
          cartObj = JSON.parse(localStorage.getItem("cart"));
          temp = cartObj["drapery"];
          typeString = "drapery";
          const isInDrapery =
            Array.isArray(temp) && temp.some((item) => cartItemMatchesId(item, refIndex));
          if (!isInDrapery) {
            const productList = cartObj["product"];
            if (
              Array.isArray(productList) &&
              productList.some((item) => cartItemMatchesId(item, refIndex))
            ) {
              temp = productList;
              typeString = "product";
            }
          }
        } else {
          setCart({});
        }
      } else if (type === 5) {
        if (localStorage.getItem("cart") !== null) {
          cartObj = JSON.parse(localStorage.getItem("cart"));
          const cartKeys = ["drapery", "product"];
          let removed = false;

          for (let i = 0; i < cartKeys.length; i++) {
            const key = cartKeys[i];
            const list = cartObj[key];
            if (!Array.isArray(list) || list.length === 0) continue;

            const productIndex = list.findIndex((item) => cartItemMatchesId(item, refIndex));
            if (productIndex !== -1) {
              list.splice(productIndex, 1);
              cartObj[key] = list;
              removed = true;
              break;
            }
          }

          if (removed) {
            localStorage.setItem("cart", JSON.stringify(cartObj));
            setCartChanged(cartChanged + 1);
          }
        }
        return;
      } else {
        if (localStorage.getItem("cart") !== null) {
          cartObj = JSON.parse(localStorage.getItem("cart"));
          temp = cartObj["swatches"];
          typeString = "swatches";
        } else {
          setCart({});
        }
      }

      if (Array.isArray(temp) && temp.length > 0) {
        let product = temp.find((item) => cartItemMatchesId(item, refIndex));

        if (product) {
          if (minusPlus !== undefined) {
            let newCount = product.Count + minusPlus;
            let maxCount = product.ProductGroupId === "100702" ? 50 : 10;
            if (newCount >= 1 && newCount <= maxCount) {
              product.Count = newCount;
              product.WindowCount = newCount;

              cartObj[typeString] = temp;
              localStorage.setItem("cart", JSON.stringify(cartObj));
              setCartChanged(cartChanged + 1);
            }
          } else if (!isNaN(numValue)) {
            let newCount = parseInt(numValue);
            let maxCount = product.ProductGroupId === "100702" ? 50 : 10;
            if (newCount <= 0) {
              const productIndex = temp.findIndex((item) => cartItemMatchesId(item, refIndex));
              if (productIndex !== -1) {
                temp.splice(productIndex, 1);
                cartObj[typeString] = temp;
                localStorage.setItem("cart", JSON.stringify(cartObj));
                setCartChanged(cartChanged + 1);
              }
            } else {
              if (newCount > maxCount) {
                product.Count = maxCount;
              } else {
                product.Count = newCount;
              }

              product.WindowCount = product.Count;

              cartObj[typeString] = temp;
              localStorage.setItem("cart", JSON.stringify(cartObj));
              setCartChanged(cartChanged + 1);
            }
          }
        }
      }
    }
  }

  function editBasketProject(projectObj, countChange = 1, refIndex) {
    if (projectObj["TypeId"] && projectObj["TypeId"] === 6401) {
    } else {
      projectObj["WindowCount"] = projectObj["Count"];
      projectObj["PreorderText"]["WindowCount"] = projectObj["Count"];
      projectObj["PreorderText"]["Count"] = projectObj["Count"];
    }
    if (isLoggedIn) {
      if (draperyRef.current[refIndex]) {
        draperyRef.current[refIndex].classList.add("is_loading");
      }
      axios
        .post(baseAddCountProject, null, {
          headers: authHeader(),
          params: {
            sewingOrderId: projectObj["SewingOrderId"],
            count: countChange,
          },
        })
        .then((response) => {
          if (draperyRef.current[refIndex]) {
            draperyRef.current[refIndex].classList.remove("is_loading");
          }
          setCart(response.data ? response.data : {});
        })
        .catch((err) => {
          if (draperyRef.current[refIndex]) {
            draperyRef.current[refIndex].classList.remove("is_loading");
          }
          console.log(err);
          if (err.response && err.response.status === 401) {
            refreshToken().then((response2) => {
              if (response2 !== false) {
                console.log("390");
                editBasketProject(projectObj, countChange);
              } else {
                navigate("/" + pageLanguage);
              }
            });
          }
        });
    } else {
      axios
        .post(baseURLEditProject, projectObj, {
          headers: authHeader(),
        })
        .then((response) => {
          getCart();
        })
        .catch((err) => {
          console.log(err);
          if (err.response && err.response.status === 401) {
            refreshToken().then((response2) => {
              if (response2 !== false) {
                console.log("411");
                editBasketProject(projectObj);
              } else {
                navigate("/" + pageLanguage);
              }
            });
          }
        });
    }
  }

  function addProduct(productId, count, ItemLength) {
    if (isLoggedIn) {
      const params = {
        productId: productId,
        count: count,
      };

      if (ItemLength !== null && ItemLength !== undefined) {
        params.len = ItemLength;
      }

      axios
        .post(
          baseURLAddProduct,
          {},
          {
            headers: authHeader(),
            params: params,
          }
        )
        .then((response) => {
          console.log(`response.data`, response.data);
          setCart(response.data ? response.data : {});
        })
        .catch((err) => {
          console.log(err);
          if (err.response && err.response.status === 401) {
            refreshToken().then((response2) => {
              if (response2 !== false) {
                addProduct(productId, count, ItemLength); // فراخوانی مجدد تابع با ItemLength
              } else {
                addProduct(productId, count, ItemLength);
              }
            });
          }
        });
    }
  }

  function deleteBasketProject(refIndex) {
    if (draperyRef.current[refIndex]) {
      draperyRef.current[refIndex].classList.add("is_loading");
    }
    axios
      .post(
        baseURLDeleteBasketProject + "/" + refIndex,
        {},
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        if (draperyRef.current[refIndex]) {
          draperyRef.current[refIndex].classList.remove("is_loading");
        }

        setCart(response.data ? response.data : {});
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          refreshToken().then((response2) => {
            if (response2 !== false) {
              deleteBasketProject(refIndex);
            } else {
              navigate("/" + pageLanguage);
            }
          });
        } else {
          if (draperyRef.current[refIndex]) {
            draperyRef.current[refIndex].classList.remove("is_loading");
          }
        }
      });
  }

  function saveForLaterBasketProject(refIndex, projectObject) {
    if (isLoggedIn) {
      draperyRef.current[refIndex].classList.add("is_loading");
      axios
        .post(
          baseURLSaveForLaterBasketProject + "/" + refIndex,
          {},
          {
            headers: authHeader(),
          }
        )
        .then((response) => {
          if (draperyRef.current[refIndex]) {
            draperyRef.current[refIndex].classList.remove("is_loading");
          }
          console.log(`response.data`, response.data);
          setCart(response.data ? response.data : {});
        })
        .catch((err) => {
          console.log(err);
          if (err.response && err.response.status === 401) {
            refreshToken().then((response2) => {
              if (response2 !== false) {
                saveForLaterBasketProject(refIndex);
              } else {
                navigate("/" + pageLanguage);
              }
            });
          } else {
            if (draperyRef.current[refIndex]) {
              draperyRef.current[refIndex].classList.remove("is_loading");
            }
          }
        });
    } else {
      dispatch({
        type: ShowLogin2Modal,
      });
      if (localStorage.getItem("cart") !== null) {
        let cartObj = JSON.parse(localStorage.getItem("cart"));
        let temp = cartObj["drapery"];
        temp.splice(refIndex, 1);
        cartObj["drapery"] = temp;
        localStorage.setItem("cart", JSON.stringify(cartObj));
        setLoginAwaiting(projectObject);
      } else {
      }
    }
  }

  function copyItem(indexOrObj, pageId, PageType) {
    if (isLoggedIn) {
      let tempObj = JSON.parse(JSON.stringify(indexOrObj));
      delete tempObj["SewingOrderId"];
      delete tempObj["IsCompleted"];
      delete tempObj["WindowName"];
      delete tempObj["WindowDescription"];
      delete tempObj["RoomNameEn"];
      delete tempObj["RoomNameFa"];
      tempObj["Count"] = 1;
      tempObj["WindowCount"] = 1;

      delete tempObj["PreorderText"]["IsCompleted"];
      delete tempObj["PreorderText"]["WindowName"];
      delete tempObj["PreorderText"]["WindowDescription"];
      delete tempObj["PreorderText"]["RoomNameEn"];
      delete tempObj["PreorderText"]["RoomNameFa"];
      tempObj["PreorderText"]["Count"] = 1;
      tempObj["PreorderText"]["WindowCount"] = 1;
      tempObj["SewingModelId"] = tempObj["PreorderText"]["SewingModelId"];
      // copyBagObject(indexOrObj);
      sessionStorage.setItem("cartCopy", JSON.stringify(tempObj));
      setTimeout(() => {
        navigate(
          "/" +
            pageLanguage +
            JSON.parse(JSON.stringify(UserProjects))[tempObj["PreorderText"]["SewingModelId"]][
              "route"
            ] +
            (PageType ? "/" + PageType : "") +
            "/Page-ID/" +
            pageId
        );
      }, 200);
    } else {
      let tempObj = JSON.parse(JSON.stringify(drapery[indexOrObj]));
      delete tempObj["SewingOrderId"];
      delete tempObj["IsCompleted"];
      delete tempObj["WindowName"];
      delete tempObj["WindowDescription"];
      delete tempObj["RoomNameEn"];
      delete tempObj["RoomNameFa"];
      tempObj["Count"] = 1;
      tempObj["WindowCount"] = 1;

      delete tempObj["PreorderText"]["IsCompleted"];
      delete tempObj["PreorderText"]["WindowName"];
      delete tempObj["PreorderText"]["WindowDescription"];
      delete tempObj["PreorderText"]["RoomNameEn"];
      delete tempObj["PreorderText"]["RoomNameFa"];
      tempObj["PreorderText"]["Count"] = 1;
      tempObj["PreorderText"]["WindowCount"] = 1;
      // if (localStorage.getItem("cart") !== null) {
      //     let cartObj = JSON.parse(localStorage.getItem("cart"));
      //     if (cartObj["drapery"] === undefined)
      //         cartObj["drapery"] = [];
      //     cartObj["drapery"].push(tempObj);
      //     localStorage.setItem('cart', JSON.stringify(cartObj));
      //     setCartChanged(cartChanged + 1);
      // } else {
      //     let newCartObj = {};
      //     let newCartArr = [];
      //     newCartArr[0] = tempObj;
      //     newCartObj["drapery"] = newCartArr;
      //     newCartObj["product"] = [];
      //     newCartObj["swatches"] = [];
      //     localStorage.setItem('cart', JSON.stringify(newCartObj));
      //     setCartChanged(cartChanged + 1);
      // }
      sessionStorage.setItem("cartCopy", JSON.stringify(tempObj));
      setTimeout(() => {
        navigate(
          "/" +
            pageLanguage +
            JSON.parse(JSON.stringify(UserProjects))[tempObj["PreorderText"]["SewingModelId"]][
              "route"
            ] +
            (PageType ? "/" + PageType : "") +
            "/Page-ID/" +
            pageId
        );
      }, 200);
    }
  }

  function CustomDropdownFiles({ props, state, methods, fabricItemId, obj1 }) {
    const regexp = new RegExp(state.search, "i");

    return (
      <div className={props.className}>
        <div className="select_item_container">
          {props.options
            .filter((item) => regexp.test(item[props.searchBy] || item[props.labelField]))
            .map((option) => {
              let exist = "false";
              let extensionSearch = /(?:\.([^.]+))?$/;
              let extension = extensionSearch.exec(option[props.labelField])[1].toLowerCase();
              let fileName = option[props.labelField].replace(/\.[^/.]+$/, "");

              return (
                <div
                  className="select_item uploaded_name_item"
                  item-selected={exist}
                  disabled={option.disabled}
                  key={option[props.valueField]}
                >
                  {getFileIcon(extension)}
                  <div
                    className="uploaded_name_item_text"
                    onClick={() => showFile(`${option[props.valueField]}`, extension)}
                  >
                    {fileName}
                  </div>
                  <div
                    className="uploaded_name_item_x"
                    onClick={() => {
                      console.log(`675`);
                      deleteUploaded(option[props.valueField], null, fabricItemId, obj1);
                      methods.addItem(option);
                    }}
                  >
                    X
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    );
  }

  let imageExtensionList = ["jpg", "png", "jpeg", "jiff", "gif", "webp"];
  let pdfExtensionList = ["pdf"];

  function showFile(fileUrl, extension) {
    console.log(`fileUrl`, fileUrl);
    if (imageExtensionList.indexOf(extension) > -1) {
      handleShow(fileUrl);
    } else if (pdfExtensionList.indexOf(extension) > -1) {
      const pdfWindow = window.open();
      pdfWindow.location.href = imgUrl(fileUrl);
      // pdfWindow.location.href = imgUrl(fileUrl);
    }
  }

  function deleteUploaded(fileUrl, deleteUploaded, fabricItemId, obj1) {
    if (isLoggedIn) {
      let promise2 = new Promise((resolve, reject) => {
        if (fileUrl !== "") {
          axios
            .delete(baseURLDeleteFile, {
              params: {
                url: fileUrl,
              },
              headers: authHeader(),
            })
            .then((response) => {
              resolve();
            })
            .catch((err) => {
              console.log(err);
              if (err.response && err.response.status === 401) {
                refreshToken().then((response2) => {
                  if (response2 !== false) {
                    console.log(`720`);
                    deleteUploaded(fileUrl);
                    reject();
                  } else {
                    resolve();
                  }
                });
              } else {
                resolve();
              }
            });
        } else {
          resolve();
        }
      });
      promise2.then(() => {});
    } else {
      if (obj1?.SewingOrderAttachments) {
        const index = obj1.SewingOrderAttachments.findIndex((att) => att.FileUrl === fileUrl);
        if (index !== -1) {
          obj1.SewingOrderAttachments.splice(index, 1);
          const cartData = localStorage.getItem("cart");
          if (cartData) {
            try {
              const cart = JSON.parse(cartData);
              const draperyIndex = cart.drapery.findIndex(
                (item) => item.fabricItemId === fabricItemId
              );
              if (draperyIndex !== -1) {
                cart.drapery[draperyIndex] = obj1;
                localStorage.setItem("cart", JSON.stringify(cart));
                console.log("✅ Attachment حذف و لوکال استوریج آپدیت شد.");
                setCartVersion((prev) => prev + 1);
                let promise2 = new Promise((resolve, reject) => {
                  if (fileUrl !== "") {
                    axios
                      .delete(baseURLDeleteFile, {
                        params: {
                          url: fileUrl,
                        },
                        headers: authHeader(),
                      })
                      .then((response) => {
                        resolve();
                      })
                      .catch((err) => {
                        console.log(err);
                        if (err.response && err.response.status === 401) {
                          refreshToken().then((response2) => {
                            if (response2 !== false) {
                              console.log(`720`);
                              deleteUploaded(fileUrl);
                              reject();
                            } else {
                              resolve();
                            }
                          });
                        } else {
                          resolve();
                        }
                      });
                  } else {
                    resolve();
                  }
                });
                promise2.then(() => {});
              } else {
                console.log("❌ آیتم با fabricItemId مورد نظر در لوکال استوریج یافت نشد.");
              }
            } catch (e) {
              console.error("❌ خطا در پردازش لوکال استوریج:", e);
            }
          } else {
            console.log("❌ آیتم cart در لوکال استوریج وجود ندارد.");
          }
        } else {
          console.log("⚠️ Attachment مورد نظر در obj1 یافت نشد.");
        }
      } else {
        console.log("⚠️ obj1 معتبر نیست یا خاصیت SewingOrderAttachments را ندارد.");
      }
    }
  }

  function deleteFileFromProject(obj, projectId, fabricItemId) {
    if (isLoggedIn) {
      let temp = JSON.parse(JSON.stringify(drapery));
      let tempProject = temp.find((opt) => opt["SewingOrderId"] === projectId)["SewingOrder"];
      let tempFileIndex = tempProject["SewingOrderAttachments"].findIndex(
        (opt) => opt["FileUrl"] === obj.value
      );

      tempProject["SewingOrderAttachments"].splice(tempFileIndex, 1);
      editBasketProject(tempProject);
    } else {
      let temp = JSON.parse(JSON.stringify(drapery));
      console.log(`temp`, temp);
      console.log(`fabricItemId`, fabricItemId);
      const findIndexItem = temp.find((item) => item.fabricItemId === fabricItemId);
      console.log(`findIndexItem`, findIndexItem);
    }
  }

  function handleShow(PhotoPath) {
    const tempDiv = [];
    // const tempDiv1 = [];
    tempDiv.push(
      <div key={PhotoPath} className="zoomImg">
        <div className="imageContainer">
          <object className="img-fluid intractable" data={imgUrl(PhotoPath)} />
        </div>
      </div>
    );

    setZoomModalBody(tempDiv);
    setShow(true);
  }

  function cartItemHasZipCode(item) {
    const zipCode = item && item["ZipCode"];
    return zipCode !== undefined && zipCode !== null && zipCode !== "";
  }

  function applyZipCodeToCartItem(item, newZipCode) {
    if (!cartItemHasZipCode(item)) return;
    item["ZipCode"] = newZipCode;
    if (!item["PreorderText"]) {
      item["PreorderText"] = {};
    }
    item["PreorderText"]["ZipCode"] = newZipCode;
  }

  function updateGuestCartZipCodes(cartObj, newZipCode) {
    ["drapery", "product"].forEach((key) => {
      const list = cartObj[key];
      if (!Array.isArray(list)) return;
      list.forEach((item) => applyZipCodeToCartItem(item, newZipCode));
    });
  }

  function getLoggedInSewingOrderIdsWithZipCode() {
    const cartDetails = cart["CartDetails"];
    if (!Array.isArray(cartDetails)) return [];

    return cartDetails
      .filter((item) => item["TypeId"] === 6403 && item["SewingOrder"])
      .filter((item) => cartItemHasZipCode(item["SewingOrder"]))
      .map((item) => item["SewingOrder"]["SewingOrderId"])
      .filter((id) => id !== undefined && id !== null);
  }

  function changeZipcode() {
    axios
      .post(
        baseURLZipCode,
        {},
        {
          params: {
            zipCode: zipcodeAll,
          },
        }
      )
      .then((response) => {
        if (response.data) {
          if (isLoggedIn) {
            const sewingOrderIds = getLoggedInSewingOrderIdsWithZipCode();
            const orderIdsToUpdate =
              sewingOrderIds.length > 0
                ? sewingOrderIds
                : zipcodeId !== -1
                ? [zipcodeId]
                : [];

            if (orderIdsToUpdate.length === 0) {
              setZipcodeAll("");
              setZipcodeId(-1);
              setHasInstall(null);
              return;
            }

            Promise.all(
              orderIdsToUpdate.map((sewingOrderId) =>
                axios.get(baseURLChangeZipcode + "/" + sewingOrderId, {
                  params: {
                    zipCode: zipcodeAll,
                  },
                  headers: authHeader(),
                })
              )
            )
              .then((responses) => {
                setZipcodeAll("");
                setZipcodeId(-1);
                setHasInstall(null);
                const lastResponse = responses[responses.length - 1];
                console.log(`response.data`, lastResponse?.data);
                setCart(lastResponse?.data ? lastResponse.data : {});
              })
              .catch((err) => {
                console.log(err);
                if (err.response && err.response.status === 401) {
                  refreshToken().then((response2) => {
                    if (response2 !== false) {
                      changeZipcode();
                    } else {
                      navigate("/" + pageLanguage);
                    }
                  });
                } else {
                  setZipcodeAll("");
                  setZipcodeId(-1);
                  renderDraperies();
                  setHasInstall(null);
                }
              });
          } else {
            if (localStorage.getItem("cart") !== null) {
              let cartObj = JSON.parse(localStorage.getItem("cart"));
              updateGuestCartZipCodes(cartObj, zipcodeAll);
              localStorage.setItem("cart", JSON.stringify(cartObj));
              setZipcodeAll("");
              setZipcodeId(-1);
              setHasInstall(null);
              setCartChanged(cartChanged + 1);
            } else {
              setCartChanged(cartChanged + 1);
            }
          }
        } else {
          setHasInstall(response.data);
        }
      })
      .catch((err) => {
        console.log(err);
        setHasInstall(false);
      });
  }

  const getFileIcon = (extension) => {
    switch (extension) {
      case "pdf":
      case "doc":
      case "docx":
      case "txt":
      case "xls":
      case "xlsx":
        return <IoDocumentTextOutline />;
      case "jpg":
      case "jpeg":
      case "png":
      case "gif":
      case "zip":
      case "rar":
        return <HiOutlinePhotograph />;
      default:
        return <i className="fa fa-file" />;
    }
  };

  function getCart() {
    if (isLoggedIn) {
      axios
        .get(baseURLGetCart, {
          headers: authHeader(),
        })
        .then((response) => {
          setCart(response.data ? response.data : {});
          setFirstFetch(false);
        })
        .catch((err) => {
          console.log(err);
          if (err.response && err.response.status === 401) {
            refreshToken().then((response2) => {
              if (response2 !== false) {
                getCart();
              } else {
                setFirstFetch(false);
              }
            });
          } else {
            setFirstFetch(false);
          }
        });
    } else {
      if (localStorage.getItem("cart") !== null) {
        let cartObj = JSON.parse(localStorage.getItem("cart"));
        let lang = location.pathname
          .split("")
          .slice(1, 3)
          .join("");

        setCart({
          ...JSON.parse(localStorage.getItem("cart")),
          ...{
            lang: location.pathname
              .split("")
              .slice(1, 3)
              .join(""),
          },
        });
      } else {
        setCart({});
      }
      setFirstFetch(false);
    }
    axios
      // با تغییر اقای ویسی اصلاح بشه و به حالت کامنت برگرده
      .get(baseURLFreeShipping)
      .then((response) => {
        setFreeShipPrice(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function renderDraperies() {
    let projectData = JSON.parse(JSON.stringify(UserProjects));

    if (isLoggedIn) {
      if (draperyProduct.length) {
        let tempDrapery = JSON.parse(JSON.stringify(draperyProduct));
        let tempFiles = JSON.parse(JSON.stringify(files));
        let temp = [];
        let tempNoShip = true;
        let promiseArr = [];
        tempDrapery
          .sort(function(a, b) {
            return b["CartDetailId"] - a["CartDetailId"] || b["SewingOrderId"] - a["SewingOrderId"];
          })
          .forEach((obj1, i) => {
            promiseArr[i] = new Promise((resolve, reject) => {
              if (obj1["TypeId"] === 6403) {
                let obj = obj1["SewingOrder"]["PreorderText"] || {};
                const dkFabricObj = mergeDkFabricCartObj(obj, obj1["SewingOrder"] || {});
                let UnitPriceLogin = obj1["SewingOrder"]["Price"];
                let countNumber = obj1["Count"];

                let SewingModelId = obj["SewingModelId"];
                let userProjects = projectData[obj["SewingModelId"]]
                  ? projectData[obj["SewingModelId"]]["data"]
                  : [];
                let desc = [];
                let temp1 = [];
                let temp2 = [];
                let temp3 = [];
                let temp4 = [];
                let temp5 = [];
                let projectId = obj1["SewingOrderId"];
                let defaultModelNameFa = obj["ModelNameFa"];
                let defaultModelName = obj["ModelNameEn"];
                let roomNameFa = obj["RoomNameFa"];
                let roomName = obj["RoomNameEn"];
                let WindowDescription = obj["WindowDescription"] === undefined ? "" : obj["WindowDescription"];
                let moreInfoInput = obj["moreInfoInput"] === undefined ? "" : obj["moreInfoInput"];
                let photoUrl = obj["PhotoUrl"];
                let zipcode = obj1["SewingOrder"]["ZipCode"];
                console.log(`obj`, obj);
                setZipcodeText(zipcode);
                obj["Price"] = +obj1["PayableAmount"];

                if (tempNoShip) {
                  tempNoShip = zipcode && zipcode !== "";
                }

                let InstallAmount = obj1["SewingOrder"]["InstallAmount"]
                  ? obj1["SewingOrder"]["InstallAmount"]
                  : 0;

                let uploadedFiles = obj1["SewingOrder"]["SewingOrderAttachments"];
                let tempSelectArr = [];

                if (uploadedFiles && uploadedFiles.length > 0) {
                  // let tempSelectArr = [];
                  let promiseArrFiles = [];
                  uploadedFiles.forEach((obj1, index) => {
                    promiseArrFiles[index] = new Promise((resolve, reject) => {
                      tempSelectArr.push({
                        value: obj1["FileUrl"],
                        label: obj1["UserFileName"],
                      });
                      resolve();
                    });
                  });
                  Promise.all(promiseArrFiles).then(() => {
                    tempFiles[`${projectId}`] = tempSelectArr;
                  });
                }

                let promiseArr0 = [];
                let firstMeasurements = true;

                if (SewingModelId === "0099") {
                  promiseArr0[0] = new Promise((resolve, reject) => {
                    GetUserProjectData(obj1["SewingOrder"], true)
                      .then((cartValues) => {
                        let promiseArr4 = [];
                        if (cartValues["Accessories"] !== undefined) {
                          cartValues["Accessories"].forEach((obj, index) => {
                            if (
                              obj["DesignNameFa"] !== undefined &&
                              obj["DesignNameEn"] !== undefined
                            ) {
                              promiseArr4[index] = new Promise((resolve, reject) => {
                                if (obj["DesignNameFa"] && obj["DesignNameEn"]) {
                                  temp4[index] = (
                                    <li className="cart_agree_item cart_agree_item_new" key={"acc" + index}>
                                      <h1 className="cart_agree_item_title">
                                        {pageLanguage === "fa"
                                          ? obj["DesignNameFa"]
                                          : obj["DesignNameEn"]}
                                        {" / "}
                                        {obj["ColorNameEn"] && (
                                          <>
                                            {pageLanguage === "fa"
                                              ? obj["ColorNameFa"]
                                              : obj["ColorNameEn"]}
                                          </>
                                        )}
                                      </h1>
                                      <h2 className="cart_agree_item_desc">
                                        {t("agree_Qty")}
                                        {NumToFa(obj["Qty"], pageLanguage)}
                                      </h2>
                                    </li>
                                  );
                                }
                                resolve();
                              });
                            }
                          });
                        }

                        let promiseArr3 = [];
                        Object.keys(cartValues).forEach((key, index) => {
                          promiseArr3[index] = new Promise((resolve, reject) => {
                            // console.log(`key`, key);
                            let tempObj = userProjects.find((obj) => obj["cart"] === key);
                            if (tempObj === undefined || cartValues[key] === undefined) {
                              resolve();
                            } else if (key === "IsWalled") {
                              resolve();
                            } else {
                              if (key === "WindowWidth" && tempObj["measurements"]) {
                                if (firstMeasurements) {
                                  firstMeasurements = false;
                                  if (obj["CalcWindowSize"]) {
                                    desc[tempObj["order"]] = (
                                      <div className="basket_item_title_desc basket_item_title_desc_new 1" key="basket-measurements">
                                        {/*<h3>{t("Measurements")}&nbsp;</h3>*/}
                                        <h3 className="basket_measurement_accordion_container">
                                          <Accordion>
                                            <Accordion.Item eventKey="0">
                                              <ContextAwareToggleViewDetails
                                                eventKey="0"
                                                textOnHide={
                                                  <>
                                                    {NumToFa(
                                                      obj["WindowWidth"] + t("Measurements CM"),
                                                      pageLanguage
                                                    )}
                                                    <span dir="ltr"> x </span>
                                                    {NumToFa(
                                                      obj["WindowHeight"] + t("Measurements CM"),
                                                      pageLanguage
                                                    )}
                                                  </>
                                                }
                                                textOnShow={t("Hide Details")}
                                                textOnHide2={t("Measurements")}
                                                textOnShow2={t("Measurements")}
                                                type={2}
                                              />
                                              <Accordion.Body className="basket_item_title_dropdown dk_curtain_preview_dropdown">
                                                <div className="basket_item_title_container 3">
                                                  <GetMeasurementArray
                                                    modelId={`${SewingModelId}`}
                                                    cartValues={cartValues}
                                                  />
                                                </div>
                                              </Accordion.Body>
                                            </Accordion.Item>
                                          </Accordion>
                                        </h3>
                                      </div>
                                    );
                                  } else {
                                    // تعریف لایه‌ها
                                    const fabricLayers = [
                                      {
                                        key: "drapery",
                                        title: t("Drapery"),
                                        designEn: obj?.FabricDesignEn,
                                        colorEn: obj?.FabricColorEn,
                                        designFa: obj?.FabricDesignFa,
                                        colorFa: obj?.FabricColorFa,
                                      },
                                      {
                                        key: "sheer",
                                        title: t("Sheer"),
                                        designEn: obj?.FabricDesignEn2,
                                        colorEn: obj?.FabricColorEn2,
                                        designFa: obj?.FabricDesignFa2,
                                        colorFa: obj?.FabricColorFa2,
                                      },
                                      {
                                        key: "privacy",
                                        title: t("Privacy Layer"),
                                        designEn: obj?.SheersDesignEn,
                                        colorEn: obj?.SheersColorEn,
                                        designFa: obj?.SheersDesignFa,
                                        colorFa: obj?.SheersColorFa,
                                      },
                                    ];

                                    // فقط لایه‌هایی که مقدار دارند
                                    const validLayers = fabricLayers.filter((layer) =>
                                      pageLanguage === "en" ? layer.designEn : layer.designFa
                                    );

                                    const layersCount = validLayers.length;

                                    desc[tempObj["order"]] = (
                                      <>
                                        {/* ================= Fabric / Color ================= */}
                                        {layersCount > 0 && (
                                          <div className="basket_item_title_desc basket_item_title_desc_new 131">
                                            <h3>
                                              {pageLanguage === "fa" ? "پارچه/رنگ" : "Fabric/Color"}
                                              &nbsp;
                                            </h3>

                                            <h4>
                                              {/* فقط یک لایه → متن ساده */}
                                              {layersCount === 1 && (
                                                <>
                                                  {pageLanguage === "en"
                                                    ? `${validLayers[0].designEn} / ${t(
                                                        validLayers[0].colorEn
                                                      )}`
                                                    : `${validLayers[0].designFa} / ${t(
                                                        validLayers[0].colorFa
                                                      )}`}
                                                </>
                                              )}

                                              {/* دو یا بیشتر → آکاردیون */}
                                              {layersCount >= 2 && (
                                                <div className="dk_curtain_preview_container 1">
                                                  <Accordion>
                                                    <Accordion.Item eventKey="0">
                                                      <ContextAwareToggleViewDetails
                                                        eventKey="0"
                                                        textOnHide={t("View Details")}
                                                        textOnShow={t("Hide Details")}
                                                      />

                                                      <Accordion.Body className="basket_item_title_dropdown dk_curtain_preview_dropdown">
                                                        <div className="dk_curtain_preview_detail_container">
                                                          {validLayers.map((layer) => (
                                                            <div
                                                              key={layer.key}
                                                              className="dk_curtain_preview_detail"
                                                            >
                                                              <h2 className="sheer_h2 2">
                                                                {layer.title}:
                                                              </h2>

                                                              <h3 style={{ padding: "0 1rem" }}>
                                                                {pageLanguage === "en"
                                                                  ? `${layer.designEn} / ${t(
                                                                      layer.colorEn
                                                                    )}`
                                                                  : `${layer.designFa} / ${t(
                                                                      layer.colorFa
                                                                    )}`}
                                                              </h3>
                                                            </div>
                                                          ))}
                                                        </div>
                                                      </Accordion.Body>
                                                    </Accordion.Item>
                                                  </Accordion>
                                                </div>
                                              )}
                                            </h4>
                                          </div>
                                        )}

                                        {/* ================= Measurements ================= */}
                                        <div className="basket_item_title_desc basket_item_title_desc_new 2" key="basket-measurements">
                                          <h3>{t("Measurements")}&nbsp;</h3>
                                          <h4>
                                            {NumToFa(
                                              obj["WindowWidth"] + t("Measurements CM"),
                                              pageLanguage
                                            )}
                                            <span dir="ltr"> x </span>
                                            {NumToFa(
                                              obj["WindowHeight"] + t("Measurements CM"),
                                              pageLanguage
                                            )}
                                          </h4>
                                        </div>
                                      </>
                                    );

                                    resolve();
                                  }

                                  resolve();
                                } else {
                                  resolve();
                                }
                              } else if (key === "WindowHeight" && tempObj["measurements"]) {
                                resolve();
                              } else if (
                                (key === "PanelTypeOption" &&
                                  cartValues["PanelTypeOption"] ===
                                    "Customize Style Per Curtain") ||
                                (key === "Hardware" &&
                                  cartValues["Hardware"] ===
                                    "I Want To Customize Hardware Per Curtain")
                              ) {
                                resolve();
                              } else if (
                                tempObj["title"] !== "" &&
                                tempObj["lang"].indexOf(pageLanguage) > -1
                              ) {
                                let objLabel = "";
                                if (key === "Mount" && cartValues["Mount"] === "Outside") {
                                  const isWalledRaw = normalizeOutsideMountSubType(
                                    cartValues["IsWalled"],
                                    cartValues["installationLocation"]
                                  );
                                  const combinedLabel = formatCombinedOutsideMountLabel(
                                    isWalledRaw,
                                    pageLanguage,
                                    t
                                  );
                                  objLabel = combinedLabel
                                    ? pageLanguage === "fa"
                                      ? NumberToPersianWord.convertEnToPe(combinedLabel).toString()
                                      : combinedLabel
                                    : pageLanguage === "fa"
                                    ? NumberToPersianWord.convertEnToPe(t("Outside")).toString()
                                    : t("Outside Mount");
                                } else if (
                                  key === "ControlType" &&
                                  cartValues["ControlType"] === "Motorized"
                                ) {
                                  objLabel =
                                    pageLanguage === "fa"
                                      ? NumberToPersianWord.convertEnToPe(
                                          `${t(cartValues[key]?.toString())} / ${t(
                                            cartValues["MotorType"]?.toString()
                                          )}`
                                        )?.toString()
                                      : `${t(cartValues[key]?.toString())} / ${t(
                                          cartValues["MotorType"]?.toString()
                                        )}`;
                                } else if (
                                  key === "DraperyHardware" &&
                                  cartValues["DraperyHardware"] !== "None"
                                ) {
                                  if (cartValues["RailDesignEnA"] === "Motorized Track") {
                                    objLabel =
                                      t(cartValues[key]?.toString()) +
                                      " / " +
                                      (pageLanguage === "fa"
                                        ? cartValues["RailDesignFaA"]
                                        : cartValues["RailDesignEnA"]);
                                  } else {
                                    const railDesignA =
                                      pageLanguage === "fa"
                                        ? cartValues["RailDesignFaA"]
                                        : cartValues["RailDesignEnA"];
                                    const railColorA =
                                      pageLanguage === "fa"
                                        ? cartValues["RailColorFaA"]
                                        : cartValues["RailColorEnA"];
                                    let batonOrControlA = "";
                                    if (
                                      cartValues["BatonOptionA"] &&
                                      cartValues["BatonOptionA"] !== "None"
                                    ) {
                                      batonOrControlA = " / " + t(cartValues["BatonOptionA"]);
                                    } else if (cartValues["ControlPositionA"]) {
                                      batonOrControlA = " / " + t(cartValues["ControlPositionA"]);
                                    }
                                    objLabel =
                                      t(cartValues[key]?.toString()) +
                                      (railDesignA ? " / " + railDesignA : "") +
                                      (railColorA ? " / " + railColorA : "") +
                                      batonOrControlA;
                                  }
                                } else if (
                                  key === "SheerHardware" &&
                                  cartValues["SheerHardware"] !== "None"
                                ) {
                                  objLabel = buildCartHardwareLabel({
                                    hardwareValue: cartValues[key],
                                    railDesignFa: cartValues["RailDesignFaB"],
                                    railDesignEn: cartValues["RailDesignEnB"],
                                    railColorFa: cartValues["RailColorFaB"],
                                    railColorEn: cartValues["RailColorEnB"],
                                    batonOption: cartValues["BatonOptionB"],
                                    controlPosition: cartValues["ControlPositionB"],
                                    pageLanguage,
                                    t,
                                  });
                                } else if (
                                  key === "PrivacyLayerHardware" &&
                                  cartValues["PrivacyLayerHardware"] !== "None"
                                ) {
                                  objLabel = buildCartHardwareLabel({
                                    hardwareValue: cartValues[key],
                                    railDesignFa: cartValues["RailDesignFaC"],
                                    railDesignEn: cartValues["RailDesignEnC"],
                                    railColorFa: cartValues["RailColorFaC"],
                                    railColorEn: cartValues["RailColorEnC"],
                                    batonOption: cartValues["BatonOptionC"],
                                    controlPosition: cartValues["ControlPositionC"],
                                    pageLanguage,
                                    t,
                                  });
                                } else if (key === "HandCurtainEn" || key === "HandCurtainFa") {
                                  objLabel =
                                    t("agree_Qty") +
                                    NumToFa(cartValues["HandCurtainNum"], pageLanguage);
                                } else if (key === "HandCurtainEn2" || key === "HandCurtainFa2") {
                                  objLabel =
                                    t("agree_Qty") +
                                    NumToFa(cartValues["HandCurtainNum2"], pageLanguage);
                                } else if (tempObj["titleValue"] === null || true) {
                                  if (tempObj["titlePostfix"] === "") {
                                    objLabel =
                                      pageLanguage === "fa"
                                        ? NumberToPersianWord.convertEnToPe(
                                            `${t(cartValues[key]?.toString())}`
                                          )?.toString()
                                        : t(cartValues[key].toString());
                                  } else {
                                    objLabel =
                                      pageLanguage === "fa"
                                        ? NumberToPersianWord.convertEnToPe(
                                            `${cartValues[key]}`
                                          ).toString() + t(tempObj["titlePostfix"])
                                        : cartValues[key].toString() + t(tempObj["titlePostfix"]);
                                  }
                                } else {
                                  if (tempObj["titleValue"][cartValues[key].toString()] === null) {
                                    if (tempObj["titlePostfix"] === "") {
                                      objLabel = t(cartValues[key].toString());
                                    } else {
                                      objLabel =
                                        pageLanguage === "fa"
                                          ? NumberToPersianWord.convertEnToPe(
                                              `${cartValues[key]}`
                                            ).toString() + t(tempObj["titlePostfix"])
                                          : cartValues[key].toString() + t(tempObj["titlePostfix"]);
                                    }
                                  } else {
                                    objLabel = t(tempObj["titleValue"][cartValues[key].toString()]);
                                  }
                                }
                                if (tempObj["fabric"] === undefined) {
                                  temp5[
                                    getDkBasketDetailOrder(SewingModelId, tempObj, userProjects)
                                  ] = (
                                    <li className="cart_agree_item cart_agree_item_new" key={key}>
                                      <h1 className="cart_agree_item_title">
                                        {t(tempObj["title"])}&nbsp;
                                      </h1>
                                      <h2 className="cart_agree_item_desc">{objLabel}</h2>
                                    </li>
                                  );
                                  resolve();
                                } else if (tempObj["fabric"] === 1) {
                                  temp1[tempObj["order"]] = (
                                    <li className="cart_agree_item cart_agree_item_new" key={key}>
                                      <h1 className="cart_agree_item_title">
                                        {t(tempObj["title"])}&nbsp;
                                      </h1>
                                      <h2 className="cart_agree_item_desc">{objLabel}</h2>
                                    </li>
                                  );
                                  resolve();
                                } else if (tempObj["fabric"] === 2) {
                                  temp2[tempObj["order"]] = (
                                    <li className="cart_agree_item cart_agree_item_new" key={key}>
                                      <h1 className="cart_agree_item_title">
                                        {t(tempObj["title"])}&nbsp;
                                      </h1>
                                      <h2 className="cart_agree_item_desc">{objLabel}</h2>
                                    </li>
                                  );
                                  resolve();
                                } else if (tempObj["fabric"] === 3) {
                                  temp3[tempObj["order"]] = (
                                    <li className="cart_agree_item cart_agree_item_new" key={key}>
                                      <h1 className="cart_agree_item_title">
                                        {t(tempObj["title"])}&nbsp;
                                      </h1>
                                      <h2 className="cart_agree_item_desc">{objLabel}</h2>
                                    </li>
                                  );
                                  resolve();
                                } else {
                                  resolve();
                                }
                              } else {
                                resolve();
                              }
                            }
                          });
                        });
                        Promise.all([...promiseArr3, ...promiseArr4]).then(() => {
                          desc[40] = (
                            <div className="basket_item_title_desc basket_item_title_desc_new 3" key="basket-customize">
                              <h3 className="basket_measurement_accordion_container">
                                <Accordion>
                                  <Accordion.Item eventKey="0">
                                    <ContextAwareToggleViewDetails
                                      eventKey="0"
                                      textOnHide={t("View Details")}
                                      textOnShow={t("Hide Details")}
                                      textOnHide2={t("Customize")}
                                      textOnShow2={t("Customize")}
                                      type={2}
                                    />
                                    <Accordion.Body className="basket_item_title_dropdown dk_curtain_preview_dropdown">
                                      <div className="basket_item_title_container 4">
                                        <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_general">
                                          <h1 className="cart_agree_item_fabrics_sorted_title 1">
                                            {t("General Details")}
                                          </h1>
                                          <ul>
                                            {temp5.filter(
                                              (item) =>
                                                item !== null &&
                                                !item.props?.children?.[1]?.props?.children?.includes?.(
                                                  "Slight Puddle"
                                                ) &&
                                                !item.props?.children?.[1]?.props?.children?.includes?.(
                                                  "تا روی زمین"
                                                )
                                            )}
                                          </ul>
                                        </li>
                                        {cartValues["FabricId"] && (
                                          <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_drapery">
                                            <h1 className="cart_agree_item_fabrics_sorted_title 1">
                                              {t("Drapery")}
                                            </h1>
                                            <ul>
                                              <li className="cart_agree_item cart_agree_item_new">
                                                <h1 className="cart_agree_item_title">
                                                  {t("Fabric & Color")}
                                                  &nbsp;
                                                </h1>
                                                <h2 className="cart_agree_item_desc">
                                                  {pageLanguage === "fa"
                                                    ? cartValues["FabricDesignFa"] +
                                                      " / " +
                                                      cartValues["FabricColorFa"]
                                                    : CapitalizeAllWords(
                                                        cartValues["FabricDesignEn"] +
                                                          " / " +
                                                          cartValues["FabricColorEn"]
                                                      )}
                                                </h2>
                                              </li>
                                              {cartValues["BorderOrTrimId"] &&
                                                cartValues["borderPosition"] && (
                                                  <li className="cart_agree_item cart_agree_item_new">
                                                    <h1 className="cart_agree_item_title">
                                                      {t("Decorative Border")}
                                                      &nbsp;
                                                    </h1>
                                                    <h2 className="cart_agree_item_desc">
                                                      {pageLanguage === "fa"
                                                        ? cartValues["BorderOrTrimDesignFa"] +
                                                          " / " +
                                                          cartValues["BorderOrTrimColorFa"] +
                                                          " \n " +
                                                          t(cartValues["borderPosition"])
                                                        : CapitalizeAllWords(
                                                            cartValues["BorderOrTrimDesignEn"] +
                                                              " / " +
                                                              cartValues["BorderOrTrimColorEn"] +
                                                              " \n " +
                                                              t(cartValues["borderPosition"])
                                                          )}
                                                    </h2>
                                                  </li>
                                                )}
                                              {cartValues["BorderOrTrimId"] &&
                                                !cartValues["borderPosition"] && (
                                                  <li className="cart_agree_item cart_agree_item_new">
                                                    <h1 className="cart_agree_item_title">
                                                      {t("Decorative Trim")}
                                                      &nbsp;
                                                    </h1>
                                                    <h2 className="cart_agree_item_desc">
                                                      {pageLanguage === "fa"
                                                        ? cartValues["BorderOrTrimDesignFa"] +
                                                          " / " +
                                                          cartValues["BorderOrTrimColorFa"]
                                                        : CapitalizeAllWords(
                                                            cartValues["BorderOrTrimDesignEn"] +
                                                              " / " +
                                                              cartValues["BorderOrTrimColorEn"]
                                                          )}
                                                    </h2>
                                                  </li>
                                                )}
                                              {temp1.filter(
                                                (item) =>
                                                  item !== null &&
                                                  !item.props?.children?.[0]?.props?.children?.some(
                                                    (x) =>
                                                      x?.includes?.("Matching Tieback") ||
                                                      x?.includes?.("کمرپرده پارچه ای")
                                                  )
                                              )}
                                              {cartValues["FinishedLengthType"] &&
                                                cartValues["FinishedLengthType"] ===
                                                  "Slight Puddle" && (
                                                  <li className="cart_agree_item cart_agree_item_new">
                                                    <h1 className="cart_agree_item_title">
                                                      {t("dk_step2A")}&nbsp;
                                                    </h1>
                                                    <h2 className="cart_agree_item_desc 6">
                                                      {cartValues["FinishedLengthType"]}
                                                    </h2>
                                                  </li>
                                                )}
                                              {cartValues["HandCurtainNum"] && (
                                                <li className="cart_agree_item cart_agree_item_new">
                                                  <h1 className="cart_agree_item_title">
                                                    {t("Matching Tieback")}&nbsp;
                                                  </h1>
                                                  <h2 className="cart_agree_item_desc 6">
                                                    {t("agree_Qty") +
                                                      NumToFa(
                                                        cartValues["HandCurtainNum"],
                                                        pageLanguage
                                                      )}
                                                  </h2>
                                                </li>
                                              )}
                                            </ul>
                                          </li>
                                        )}
                                        {cartValues["FabricId2"] && (
                                          <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_sheer">
                                            <h1 className="cart_agree_item_fabrics_sorted_title 23">
                                              {t("Sheer")}
                                            </h1>
                                            <ul>
                                              <li className="cart_agree_item cart_agree_item_new">
                                                <h1 className="cart_agree_item_title">
                                                  {t("Fabric & Color")}
                                                  &nbsp;
                                                </h1>
                                                <h2 className="cart_agree_item_desc">
                                                  {pageLanguage === "fa"
                                                    ? cartValues["FabricDesignFa2"] +
                                                      " / " +
                                                      cartValues["FabricColorFa2"]
                                                    : CapitalizeAllWords(
                                                        cartValues["FabricDesignEn2"] +
                                                          " / " +
                                                          cartValues["FabricColorEn2"]
                                                      )}
                                                </h2>
                                              </li>
                                              {cartValues["BorderOrTrimId2"] &&
                                                cartValues["borderPosition2"] && (
                                                  <li className="cart_agree_item cart_agree_item_new">
                                                    <h1 className="cart_agree_item_title">
                                                      {t("Decorative Border")}
                                                      &nbsp;
                                                    </h1>
                                                    <h2 className="cart_agree_item_desc">
                                                      {pageLanguage === "fa"
                                                        ? cartValues["BorderOrTrimDesignFa2"] +
                                                          " / " +
                                                          cartValues["BorderOrTrimColorFa2"] +
                                                          " \n " +
                                                          t(cartValues["borderPosition2"])
                                                        : CapitalizeAllWords(
                                                            cartValues["BorderOrTrimDesignEn2"] +
                                                              " / " +
                                                              cartValues["BorderOrTrimColorEn2"] +
                                                              " \n " +
                                                              t(cartValues["borderPosition2"])
                                                          )}
                                                    </h2>
                                                  </li>
                                                )}
                                              {cartValues["BorderOrTrimId2"] &&
                                                !cartValues["borderPosition2"] && (
                                                  <li className="cart_agree_item cart_agree_item_new">
                                                    <h1 className="cart_agree_item_title">
                                                      {t("Decorative Trim")}
                                                      &nbsp;
                                                    </h1>
                                                    <h2 className="cart_agree_item_desc">
                                                      {pageLanguage === "fa"
                                                        ? cartValues["BorderOrTrimDesignFa2"] +
                                                          " / " +
                                                          cartValues["BorderOrTrimColorFa2"]
                                                        : CapitalizeAllWords(
                                                            cartValues["BorderOrTrimDesignEn2"] +
                                                              " / " +
                                                              cartValues["BorderOrTrimColorEn2"]
                                                          )}
                                                    </h2>
                                                  </li>
                                                )}

                                              {temp2.filter(
                                                (item) =>
                                                  item !== null &&
                                                  !item.props?.children?.[0]?.props?.children?.some(
                                                    (x) =>
                                                      x?.includes?.("Matching Tieback") ||
                                                      x?.includes?.("کمرپرده پارچه ای")
                                                  )
                                              )}
                                              {cartValues["FinishedLengthType"] &&
                                                cartValues["FinishedLengthType"] ===
                                                  "Slight Puddle" && (
                                                  <li className="cart_agree_item cart_agree_item_new">
                                                    <h1 className="cart_agree_item_title">
                                                      {t("dk_step2A")}&nbsp;
                                                    </h1>
                                                    <h2 className="cart_agree_item_desc 6">
                                                      {cartValues["PageType"] === "SheersOnly"
                                                        ? cartValues["FinishedLengthType"]
                                                        : t("Floor")}
                                                    </h2>
                                                  </li>
                                                )}
                                              {cartValues["HandCurtainNum2"] && (
                                                <li className="cart_agree_item cart_agree_item_new">
                                                  <h1 className="cart_agree_item_title">
                                                    {t("Matching Tieback")}&nbsp;
                                                  </h1>
                                                  <h2 className="cart_agree_item_desc 6">
                                                    {t("agree_Qty") +
                                                      NumToFa(
                                                        cartValues["HandCurtainNum2"],
                                                        pageLanguage
                                                      )}
                                                  </h2>
                                                </li>
                                              )}
                                            </ul>
                                          </li>
                                        )}
                                        {cartValues["PrivacyLayer"] &&
                                          cartValues["PrivacyLayer"] !== "none" &&
                                          cartValues["SheersDesignEn"] &&
                                          cartValues["SheersColorEn"] && (
                                            <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_pl">
                                              <h1 className="cart_agree_item_fabrics_sorted_title 95">
                                                {t("Privacy Layer")}
                                              </h1>
                                              <ul>
                                                <li className="cart_agree_item cart_agree_item_new">
                                                  <h1 className="cart_agree_item_title">
                                                    {t("Fabric & Color")}
                                                    &nbsp;
                                                  </h1>
                                                  <h2 className="cart_agree_item_desc">
                                                    {pageLanguage === "fa"
                                                      ? cartValues["SheersDesignFa"] +
                                                        " / " +
                                                        cartValues["SheersColorFa"]
                                                      : CapitalizeAllWords(
                                                          cartValues["SheersDesignEn"] +
                                                            " / " +
                                                            cartValues["SheersColorEn"]
                                                        )}
                                                  </h2>
                                                </li>
                                                {temp3}
                                                {cartValues["FinishedLengthType"] &&
                                                  cartValues["FinishedLengthType"] ===
                                                    "Slight Puddle" && (
                                                    <li className="cart_agree_item cart_agree_item_new">
                                                      <h1 className="cart_agree_item_title">
                                                        {t("dk_step2A")}&nbsp;
                                                      </h1>
                                                      <h2 className="cart_agree_item_desc 6">
                                                        {t("Floor")}
                                                      </h2>
                                                    </li>
                                                  )}
                                              </ul>
                                            </li>
                                          )}
                                        {!!temp4.length && (
                                          <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_acc">
                                            <h1 className="cart_agree_item_fabrics_sorted_title 1">
                                              {t("Accessories")}
                                            </h1>
                                            <ul>{temp4}</ul>
                                          </li>
                                        )}
                                        <li className="cart_agree_item cart_agree_item_new cart_agree_item_fabrics_sorted cart_agree_item_label" 
                                        style={{padding: "0.9rem 0"}}
                                        >
                                          <h1 className="cart_agree_item_title 5">
                                            {pageLanguage === "fa" ? "نام اتاق" : "Room Label"}
                                            &nbsp;
                                          </h1>
                                          <h2 className="cart_agree_item_desc">
                                            {pageLanguage === "fa"
                                              ? roomNameFa +
                                                (cartValues["WindowDescription"] === "" ? "" : " / " + WindowDescription)
                                              : roomName +
                                                (cartValues["WindowDescription"] ? "" : " / " + WindowDescription)}
                                          </h2>
                                        </li>
                                        {moreInfoInput !== "" && (
                                          <li className="basket_item_title_desc basket_item_title_desc_new 4" style={{marginTop: "0.8rem"}}>
                                            <h1 className="cart_agree_item_title">
                                              {t("Order Notes")}&nbsp;
                                            </h1>
                                            <ShowMoreLineLimited
                                              moreInfoInput={moreInfoInput}
                                              lines={3}
                                            />
                                          </li>
                                        )}
                                      </div>
                                    </Accordion.Body>
                                  </Accordion.Item>
                                </Accordion>
                              </h3>
                            </div>
                          );
                          resolve();
                        });
                      })
                      .catch((err) => {
                        console.log(err);
                        resolve();
                      });
                  });
                } else if (SewingModelId === "0321") {
                  promiseArr0[0] = new Promise((resolve, reject) => {
                    GetUserProjectData(obj1["SewingOrder"], true)
                      .then((cartValues) => {
                        if (cartValues["Hardware"] === "Same Hardware For All Curtains") {
                          cartValues["MotorChannelsA"] = cartValues["MotorChannelsB"];
                          cartValues["MotorPositionA"] = cartValues["MotorPositionB"];
                        }

                        let promiseArr4 = [];
                        if (cartValues["Accessories"] !== undefined) {
                          cartValues["Accessories"].forEach((obj, index) => {
                            if (
                              obj["DesignNameFa"] !== undefined &&
                              obj["DesignNameEn"] !== undefined
                            ) {
                              promiseArr4[index] = new Promise((resolve, reject) => {
                                if (obj["DesignNameFa"] && obj["DesignNameEn"]) {
                                  temp4[index] = (
                                    <li className="cart_agree_item cart_agree_item_new" key={"acc" + index}>
                                      <h1 className="cart_agree_item_title">
                                        {pageLanguage === "fa"
                                          ? obj["DesignNameFa"]
                                          : obj["DesignNameEn"]}
                                        {" / "}
                                        {obj["ColorNameEn"] && (
                                          <>
                                            {pageLanguage === "fa"
                                              ? obj["ColorNameFa"]
                                              : obj["ColorNameEn"]}
                                          </>
                                        )}
                                      </h1>
                                      <h2 className="cart_agree_item_desc">
                                        {t("agree_Qty")}
                                        {NumToFa(obj["Qty"], pageLanguage)}
                                      </h2>
                                    </li>
                                  );
                                }
                                resolve();
                              });
                            }
                          });
                        }

                        let promiseArr3 = [];
                        Object.keys(cartValues).forEach((key, index) => {
                          promiseArr3[index] = new Promise((resolve, reject) => {
                            console.log(`key`, key);
                            let tempObj = userProjects.find((obj) => obj["cart"] === key);
                            if (tempObj === undefined || cartValues[key] === undefined) {
                              resolve();
                            } else if (key === "IsWalled") {
                              resolve();
                            } else {
                              if (key === "WindowWidth" && tempObj["measurements"]) {
                                if (firstMeasurements) {
                                  firstMeasurements = false;
                                  if (obj["CalcWindowSize"]) {
                                    desc[tempObj["order"]] = (
                                      <div className="basket_item_title_desc basket_item_title_desc_new 5" key="basket-measurements">
                                        {/*<h3>{t("Measurements")}&nbsp;</h3>*/}
                                        <h3 className="basket_measurement_accordion_container">
                                          <Accordion>
                                            <Accordion.Item eventKey="0">
                                              <ContextAwareToggleViewDetails
                                                eventKey="0"
                                                textOnHide={
                                                  <>
                                                    {NumToFa(
                                                      obj["WindowWidth"] + t("Measurements CM"),
                                                      pageLanguage
                                                    )}
                                                    <span dir="ltr"> x </span>
                                                    {NumToFa(
                                                      obj["WindowHeight"] + t("Measurements CM"),
                                                      pageLanguage
                                                    )}
                                                  </>
                                                }
                                                textOnShow={t("Hide Details")}
                                                textOnHide2={t("Measurements")}
                                                textOnShow2={t("Measurements")}
                                                type={2}
                                              />
                                              <Accordion.Body className="basket_item_title_dropdown dk_curtain_preview_dropdown">
                                                <div className="basket_item_title_container 5">
                                                  <GetMeasurementArray
                                                    modelId={`${SewingModelId}`}
                                                    cartValues={cartValues}
                                                  />
                                                </div>
                                              </Accordion.Body>
                                            </Accordion.Item>
                                          </Accordion>
                                        </h3>
                                      </div>
                                    );
                                  } else {
                                    // تعریف لایه‌ها
                                    const fabricLayers = [
                                      {
                                        key: "drapery",
                                        title: t("Drapery"),
                                        designEn: obj?.FabricDesignEn,
                                        colorEn: obj?.FabricColorEn,
                                        designFa: obj?.FabricDesignFa,
                                        colorFa: obj?.FabricColorFa,
                                      },
                                      {
                                        key: "sheer",
                                        title: t("Sheer"),
                                        designEn: obj?.FabricDesignEn2,
                                        colorEn: obj?.FabricColorEn2,
                                        designFa: obj?.FabricDesignFa2,
                                        colorFa: obj?.FabricColorFa2,
                                      },
                                      {
                                        key: "privacy",
                                        title: t("Privacy Layer"),
                                        designEn: obj?.SheersDesignEn,
                                        colorEn: obj?.SheersColorEn,
                                        designFa: obj?.SheersDesignFa,
                                        colorFa: obj?.SheersColorFa,
                                      },
                                    ];

                                    // فقط لایه‌هایی که مقدار دارند
                                    const validLayers = fabricLayers.filter((layer) =>
                                      pageLanguage === "en" ? layer.designEn : layer.designFa
                                    );

                                    const layersCount = validLayers.length;

                                    desc[tempObj["order"]] = (
                                      <>
                                        {/* ================= Fabric / Color ================= */}
                                        {layersCount > 0 && (
                                          <div className="basket_item_title_desc basket_item_title_desc_new 132">
                                            <h3>
                                              {pageLanguage === "fa" ? "پارچه/رنگ" : "Fabric/Color"}
                                              &nbsp;
                                            </h3>

                                            <h4>
                                              {/* فقط یک لایه → متن ساده */}
                                              {layersCount === 1 && (
                                                <>
                                                  {pageLanguage === "en"
                                                    ? `${validLayers[0].designEn} / ${t(
                                                        validLayers[0].colorEn
                                                      )}`
                                                    : `${validLayers[0].designFa} / ${t(
                                                        validLayers[0].colorFa
                                                      )}`}
                                                </>
                                              )}

                                              {/* دو یا بیشتر → آکاردیون */}
                                              {layersCount >= 2 && (
                                                <div className="dk_curtain_preview_container 2">
                                                  <Accordion>
                                                    <Accordion.Item eventKey="0">
                                                      <ContextAwareToggleViewDetails
                                                        eventKey="0"
                                                        textOnHide={t("View Details")}
                                                        textOnShow={t("Hide Details")}
                                                      />

                                                      <Accordion.Body className="basket_item_title_dropdown dk_curtain_preview_dropdown">
                                                        <div className="dk_curtain_preview_detail_container">
                                                          {validLayers.map((layer) => (
                                                            <div
                                                              key={layer.key}
                                                              className="dk_curtain_preview_detail"
                                                            >
                                                              <h2 className="sheer_h2 3">
                                                                {layer.title}:
                                                              </h2>
                                                              <h3 style={{ padding: "0 1rem" }}>
                                                                {pageLanguage === "en"
                                                                  ? `${layer.designEn} / ${t(
                                                                      layer.colorEn
                                                                    )}`
                                                                  : `${layer.designFa} / ${t(
                                                                      layer.colorFa
                                                                    )}`}
                                                              </h3>
                                                            </div>
                                                          ))}
                                                        </div>
                                                      </Accordion.Body>
                                                    </Accordion.Item>
                                                  </Accordion>
                                                </div>
                                              )}
                                            </h4>
                                          </div>
                                        )}

                                        {/* ================= Measurements ================= */}
                                        <div className="basket_item_title_desc basket_item_title_desc_new 6" key="basket-measurements">
                                          <h3>{t("Measurements")}&nbsp;</h3>
                                          <h4>
                                            {NumToFa(
                                              obj["WindowWidth"] + t("Measurements CM"),
                                              pageLanguage
                                            )}
                                            <span dir="ltr"> x </span>
                                            {NumToFa(
                                              obj["WindowHeight"] + t("Measurements CM"),
                                              pageLanguage
                                            )}
                                          </h4>
                                        </div>
                                      </>
                                    );
                                    resolve();
                                  }
                                  resolve();
                                } else {
                                  resolve();
                                }
                              } else if (key === "WindowHeight" && tempObj["measurements"]) {
                                resolve();
                              } else if (
                                (key === "PanelTypeOption" &&
                                  cartValues["PanelTypeOption"] ===
                                    "Customize Style Per Curtain") ||
                                (key === "Hardware" &&
                                  cartValues["Hardware"] ===
                                    "I Want To Customize Hardware Per Curtain")
                              ) {
                                resolve();
                              } else if (
                                tempObj["title"] !== "" &&
                                tempObj["lang"].indexOf(pageLanguage) > -1
                              ) {
                                let objLabel = "";
                                if (key === "Mount" && cartValues["Mount"] === "Outside") {
                                  const isWalledRaw = normalizeOutsideMountSubType(
                                    cartValues["IsWalled"],
                                    cartValues["installationLocation"]
                                  );
                                  const combinedLabel = formatCombinedOutsideMountLabel(
                                    isWalledRaw,
                                    pageLanguage,
                                    t
                                  );
                                  objLabel = combinedLabel
                                    ? pageLanguage === "fa"
                                      ? NumberToPersianWord.convertEnToPe(combinedLabel).toString()
                                      : combinedLabel
                                    : pageLanguage === "fa"
                                    ? NumberToPersianWord.convertEnToPe(t("Outside")).toString()
                                    : t("Outside Mount");
                                } else if (
                                  key === "ControlType" &&
                                  cartValues["ControlType"] === "Motorized"
                                ) {
                                  objLabel =
                                    pageLanguage === "fa"
                                      ? NumberToPersianWord.convertEnToPe(
                                          `${t(cartValues[key]?.toString())} / ${t(
                                            cartValues["MotorType"]?.toString()
                                          )}`
                                        )?.toString()
                                      : `${t(cartValues[key]?.toString())} / ${t(
                                          cartValues["MotorType"]?.toString()
                                        )}`;
                                } else if (
                                  key === "DraperyHardware" &&
                                  cartValues["DraperyHardware"] !== "None"
                                ) {
                                  objLabel = buildCartHardwareLabel({
                                    hardwareValue: cartValues[key],
                                    railDesignFa: cartValues["RailDesignFaA"],
                                    railDesignEn: cartValues["RailDesignEnA"],
                                    railColorFa: cartValues["RailColorFaA"],
                                    railColorEn: cartValues["RailColorEnA"],
                                    batonOption: cartValues["BatonOptionA"],
                                    controlPosition:
                                      cartValues["ControlPositionA"] ||
                                      cartValues["ControlPositionB"],
                                    pageLanguage,
                                    t,
                                  });
                                } else if (
                                  key === "SheerHardware" &&
                                  cartValues["SheerHardware"] !== "None"
                                ) {
                                  objLabel = buildCartHardwareLabel({
                                    hardwareValue: cartValues[key],
                                    railDesignFa: cartValues["RailDesignFaB"],
                                    railDesignEn: cartValues["RailDesignEnB"],
                                    railColorFa: cartValues["RailColorFaB"],
                                    railColorEn: cartValues["RailColorEnB"],
                                    batonOption: cartValues["BatonOptionB"],
                                    controlPosition: cartValues["ControlPositionB"],
                                    pageLanguage,
                                    t,
                                  });
                                } else if (
                                  key === "PrivacyLayerHardware" &&
                                  cartValues["PrivacyLayerHardware"] !== "None"
                                ) {
                                  objLabel = buildCartHardwareLabel({
                                    hardwareValue: cartValues[key],
                                    railDesignFa: cartValues["RailDesignFaC"],
                                    railDesignEn: cartValues["RailDesignEnC"],
                                    railColorFa: cartValues["RailColorFaC"],
                                    railColorEn: cartValues["RailColorEnC"],
                                    batonOption: cartValues["BatonOptionC"],
                                    controlPosition: cartValues["ControlPositionC"],
                                    pageLanguage,
                                    t,
                                  });
                                } else if (key === "HandCurtainEn" || key === "HandCurtainFa") {
                                  objLabel =
                                    t("agree_Qty") +
                                    NumToFa(cartValues["HandCurtainNum"], pageLanguage);
                                } else if (key === "HandCurtainEn2" || key === "HandCurtainFa2") {
                                  objLabel =
                                    t("agree_Qty") +
                                    NumToFa(cartValues["HandCurtainNum2"], pageLanguage);
                                } else if (tempObj["titleValue"] === null || true) {
                                  if (tempObj["titlePostfix"] === "") {
                                    objLabel =
                                      pageLanguage === "fa"
                                        ? NumberToPersianWord.convertEnToPe(
                                            `${t(cartValues[key]?.toString())}`
                                          )?.toString()
                                        : t(cartValues[key].toString());
                                  } else {
                                    objLabel =
                                      pageLanguage === "fa"
                                        ? NumberToPersianWord.convertEnToPe(
                                            `${cartValues[key]}`
                                          ).toString() + t(tempObj["titlePostfix"])
                                        : cartValues[key].toString() + t(tempObj["titlePostfix"]);
                                  }
                                } else {
                                  if (tempObj["titleValue"][cartValues[key].toString()] === null) {
                                    if (tempObj["titlePostfix"] === "") {
                                      objLabel = t(cartValues[key].toString());
                                    } else {
                                      objLabel =
                                        pageLanguage === "fa"
                                          ? NumberToPersianWord.convertEnToPe(
                                              `${cartValues[key]}`
                                            ).toString() + t(tempObj["titlePostfix"])
                                          : cartValues[key].toString() + t(tempObj["titlePostfix"]);
                                    }
                                  } else {
                                    objLabel = t(tempObj["titleValue"][cartValues[key].toString()]);
                                  }
                                }
                                if (tempObj["fabric"] === undefined) {
                                  temp5[
                                    getDkBasketDetailOrder(SewingModelId, tempObj, userProjects)
                                  ] = (
                                    <li className="cart_agree_item cart_agree_item_new" key={key}>
                                      <h1 className="cart_agree_item_title">
                                        {t(tempObj["title"])}&nbsp;
                                      </h1>
                                      <h2 className="cart_agree_item_desc">{objLabel}</h2>
                                    </li>
                                  );
                                  resolve();
                                } else if (tempObj["fabric"] === 1) {
                                  temp1[tempObj["order"]] = (
                                    <li className="cart_agree_item cart_agree_item_new" key={key}>
                                      <h1 className="cart_agree_item_title">
                                        {t(tempObj["title"])}&nbsp;
                                      </h1>
                                      <h2 className="cart_agree_item_desc">{objLabel}</h2>
                                    </li>
                                  );
                                  resolve();
                                } else if (tempObj["fabric"] === 2) {
                                  temp2[tempObj["order"]] = (
                                    <li className="cart_agree_item cart_agree_item_new" key={key}>
                                      <h1 className="cart_agree_item_title">
                                        {t(tempObj["title"])}&nbsp;
                                      </h1>
                                      <h2 className="cart_agree_item_desc">{objLabel}</h2>
                                    </li>
                                  );
                                  resolve();
                                } else if (tempObj["fabric"] === 3) {
                                  temp3[tempObj["order"]] = (
                                    <li className="cart_agree_item cart_agree_item_new" key={key}>
                                      <h1 className="cart_agree_item_title">
                                        {t(tempObj["title"])}&nbsp;
                                      </h1>
                                      <h2 className="cart_agree_item_desc">{objLabel}</h2>
                                    </li>
                                  );
                                  resolve();
                                } else {
                                  resolve();
                                }
                              } else {
                                resolve();
                              }
                            }
                          });
                        });
                        Promise.all([...promiseArr3, ...promiseArr4]).then(() => {
                          desc[40] = (
                            <div className="basket_item_title_desc basket_item_title_desc_new 7" key="basket-customize">
                              <h3 className="basket_measurement_accordion_container">
                                <Accordion>
                                  <Accordion.Item eventKey="0">
                                    <ContextAwareToggleViewDetails
                                      eventKey="0"
                                      textOnHide={t("View Details")}
                                      textOnShow={t("Hide Details")}
                                      textOnHide2={t("Customize")}
                                      textOnShow2={t("Customize")}
                                      type={2}
                                    />
                                    <Accordion.Body className="basket_item_title_dropdown dk_curtain_preview_dropdown">
                                      <div className="basket_item_title_container 6">
                                        <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_general">
                                          <h1 className="cart_agree_item_fabrics_sorted_title 2">
                                            {t("General Details")}
                                          </h1>
                                          <ul>
                                            {temp5.filter(
                                              (item) =>
                                                item !== null &&
                                                !item.props?.children?.[1]?.props?.children?.includes?.(
                                                  "Slight Puddle"
                                                ) &&
                                                !item.props?.children?.[1]?.props?.children?.includes?.(
                                                  "تا روی زمین"
                                                )
                                            )}
                                          </ul>
                                        </li>

                                        {cartValues["FabricId"] && (
                                          <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_drapery">
                                            <h1 className="cart_agree_item_fabrics_sorted_title 11">
                                              {t("Drapery")}
                                            </h1>
                                            <ul>
                                              <li className="cart_agree_item cart_agree_item_new">
                                                <h1 className="cart_agree_item_title">
                                                  {t("Fabric & Color")}
                                                  &nbsp;
                                                </h1>
                                                <h2 className="cart_agree_item_desc">
                                                  {pageLanguage === "fa"
                                                    ? cartValues["FabricDesignFa"] +
                                                      " / " +
                                                      cartValues["FabricColorFa"]
                                                    : CapitalizeAllWords(
                                                        cartValues["FabricDesignEn"] +
                                                          " / " +
                                                          cartValues["FabricColorEn"]
                                                      )}
                                                </h2>
                                              </li>
                                              {cartValues["BorderOrTrimId"] &&
                                                cartValues["borderPosition"] && (
                                                  <li className="cart_agree_item cart_agree_item_new">
                                                    <h1 className="cart_agree_item_title">
                                                      {t("Decorative Border")}
                                                      &nbsp;
                                                    </h1>
                                                    <h2 className="cart_agree_item_desc">
                                                      {pageLanguage === "fa"
                                                        ? cartValues["BorderOrTrimDesignFa"] +
                                                          " / " +
                                                          cartValues["BorderOrTrimColorFa"] +
                                                          " \n " +
                                                          t(cartValues["borderPosition"])
                                                        : CapitalizeAllWords(
                                                            cartValues["BorderOrTrimDesignEn"] +
                                                              " / " +
                                                              cartValues["BorderOrTrimColorEn"] +
                                                              " \n " +
                                                              t(cartValues["borderPosition"])
                                                          )}
                                                    </h2>
                                                  </li>
                                                )}
                                              {cartValues["BorderOrTrimId"] &&
                                                !cartValues["borderPosition"] && (
                                                  <li className="cart_agree_item cart_agree_item_new 22">
                                                    <h1 className="cart_agree_item_title">
                                                      {t("Decorative Trim")}
                                                      &nbsp;
                                                    </h1>
                                                    <h2 className="cart_agree_item_desc">
                                                      {pageLanguage === "fa"
                                                        ? cartValues["BorderOrTrimDesignFa"] +
                                                          " / " +
                                                          cartValues["BorderOrTrimColorFa"]
                                                        : CapitalizeAllWords(
                                                            cartValues["BorderOrTrimDesignEn"] +
                                                              " / " +
                                                              cartValues["BorderOrTrimColorEn"]
                                                          )}
                                                    </h2>
                                                  </li>
                                                )}
                                              {temp1.filter(
                                                (item) =>
                                                  item !== null &&
                                                  !item.props?.children?.[0]?.props?.children?.some(
                                                    (x) =>
                                                      x?.includes?.("Matching Tieback") ||
                                                      x?.includes?.("کمرپرده پارچه ای")
                                                  )
                                              )}

                                              {cartValues["RailDesignEnA"] === "Motorized Track" &&
                                                cartValues["Hardware"] !==
                                                  "I Have My Own Hardware" && (
                                                  <>
                                                    {cartValues["RemoteNameA"] &&
                                                      cartValues["RemoteNameA"] !== "" && (
                                                        <>
                                                          {cartValues["MotorPositionA"]?.length >
                                                            0 && (
                                                            <li className="cart_agree_item cart_agree_item_new">
                                                              <h1 className="cart_agree_item_title">
                                                                {t("Motor Position")}&nbsp;
                                                              </h1>
                                                              <h2 className="cart_agree_item_desc 6">
                                                                {cartValues["MotorPositionA"][0]?.[
                                                                  "label"
                                                                ]
                                                                  ? t(
                                                                      cartValues[
                                                                        "MotorPositionA"
                                                                      ][0]?.["label"]
                                                                    )
                                                                  : t(cartValues["MotorPositionA"])}
                                                              </h2>
                                                            </li>
                                                          )}
                                                          <li className="cart_agree_item cart_agree_item_new">
                                                            <h1 className="cart_agree_item_title">
                                                              {t("Remote Name")}&nbsp;
                                                            </h1>
                                                            <h2 className="cart_agree_item_desc 6">
                                                              {cartValues["RemoteNameA"]}
                                                            </h2>
                                                          </li>
                                                          <li className="cart_agree_item cart_agree_item_new">
                                                            <h1 className="cart_agree_item_title">
                                                              {t("Motor Channels")}&nbsp;
                                                            </h1>
                                                            <h2 className="cart_agree_item_desc 6">
                                                              {cartValues["MotorChannelsA"]?.join(
                                                                ", "
                                                              )}
                                                            </h2>
                                                          </li>
                                                        </>
                                                      )}
                                                  </>
                                                )}

                                              {cartValues["FinishedLengthType"] &&
                                                cartValues["FinishedLengthType"] ===
                                                  "Slight Puddle" && (
                                                  <li className="cart_agree_item cart_agree_item_new">
                                                    <h1 className="cart_agree_item_title">
                                                      {t("dk_step2A")}&nbsp;
                                                    </h1>
                                                    <h2 className="cart_agree_item_desc 6">
                                                      {cartValues["FinishedLengthType"]}
                                                    </h2>
                                                  </li>
                                                )}
                                              {cartValues["HandCurtainNum"] && (
                                                <li className="cart_agree_item cart_agree_item_new">
                                                  <h1 className="cart_agree_item_title">
                                                    {t("Matching Tieback")}&nbsp;
                                                  </h1>
                                                  <h2 className="cart_agree_item_desc 6">
                                                    {t("agree_Qty") +
                                                      NumToFa(
                                                        cartValues["HandCurtainNum"],
                                                        pageLanguage
                                                      )}
                                                  </h2>
                                                </li>
                                              )}
                                            </ul>
                                          </li>
                                        )}

                                        {cartValues["FabricId2"] && (
                                          <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_sheer">
                                            <h1 className="cart_agree_item_fabrics_sorted_title 22">
                                              {t("Sheer")}
                                            </h1>
                                            <ul>
                                              <li className="cart_agree_item cart_agree_item_new">
                                                <h1 className="cart_agree_item_title">
                                                  {t("Fabric & Color")}
                                                  &nbsp;
                                                </h1>
                                                <h2 className="cart_agree_item_desc">
                                                  {pageLanguage === "fa"
                                                    ? cartValues["FabricDesignFa2"] +
                                                      " / " +
                                                      cartValues["FabricColorFa2"]
                                                    : CapitalizeAllWords(
                                                        cartValues["FabricDesignEn2"] +
                                                          " / " +
                                                          cartValues["FabricColorEn2"]
                                                      )}
                                                </h2>
                                              </li>
                                              {cartValues["BorderOrTrimId2"] &&
                                                cartValues["borderPosition2"] && (
                                                  <li className="cart_agree_item cart_agree_item_new">
                                                    <h1 className="cart_agree_item_title">
                                                      {t("Decorative Border")}
                                                      &nbsp;
                                                    </h1>
                                                    <h2 className="cart_agree_item_desc">
                                                      {pageLanguage === "fa"
                                                        ? cartValues["BorderOrTrimDesignFa2"] +
                                                          " / " +
                                                          cartValues["BorderOrTrimColorFa2"] +
                                                          " \n " +
                                                          t(cartValues["borderPosition2"])
                                                        : CapitalizeAllWords(
                                                            cartValues["BorderOrTrimDesignEn2"] +
                                                              " / " +
                                                              cartValues["BorderOrTrimColorEn2"] +
                                                              " \n " +
                                                              t(cartValues["borderPosition2"])
                                                          )}
                                                    </h2>
                                                  </li>
                                                )}
                                              {cartValues["BorderOrTrimId2"] &&
                                                !cartValues["borderPosition2"] && (
                                                  <li className="cart_agree_item cart_agree_item_new">
                                                    <h1 className="cart_agree_item_title">
                                                      {t("Decorative Trim")}
                                                      &nbsp;
                                                    </h1>
                                                    <h2 className="cart_agree_item_desc">
                                                      {pageLanguage === "fa"
                                                        ? cartValues["BorderOrTrimDesignFa2"] +
                                                          " / " +
                                                          cartValues["BorderOrTrimColorFa2"]
                                                        : CapitalizeAllWords(
                                                            cartValues["BorderOrTrimDesignEn2"] +
                                                              " / " +
                                                              cartValues["BorderOrTrimColorEn2"]
                                                          )}
                                                    </h2>
                                                  </li>
                                                )}

                                              {cartValues["SheerHardware"] !== "None"
                                                ? temp2.filter(
                                                    (item) =>
                                                      item !== null &&
                                                      !item.props?.children?.[0]?.props?.children?.some(
                                                        (x) =>
                                                          x?.includes?.("Matching Tieback") ||
                                                          x?.includes?.("کمرپرده پارچه ای")
                                                      )
                                                  )
                                                : temp2.filter(
                                                    (item) =>
                                                      item !== null &&
                                                      !item.props?.children?.[0]?.props?.children?.some(
                                                        (x) =>
                                                          x?.includes?.("Matching Tieback") ||
                                                          x?.includes?.("کمرپرده پارچه ای") ||
                                                          x?.includes?.("Motor Position") ||
                                                          x?.includes?.("Motor Channels")
                                                      )
                                                  )}

                                              {cartValues["FinishedLengthType"] &&
                                                cartValues["FinishedLengthType"] ===
                                                  "Slight Puddle" && (
                                                  <li className="cart_agree_item cart_agree_item_new">
                                                    <h1 className="cart_agree_item_title">
                                                      {t("dk_step2A")}&nbsp;
                                                    </h1>
                                                    <h2 className="cart_agree_item_desc 6">
                                                      {cartValues["PageType"] === "SheersOnly"
                                                        ? cartValues["FinishedLengthType"]
                                                        : t("Floor")}
                                                    </h2>
                                                  </li>
                                                )}
                                              {cartValues["HandCurtainNum2"] && (
                                                <li className="cart_agree_item cart_agree_item_new">
                                                  <h1 className="cart_agree_item_title">
                                                    {t("Matching Tieback")}&nbsp;
                                                  </h1>
                                                  <h2 className="cart_agree_item_desc 6">
                                                    {t("agree_Qty") +
                                                      NumToFa(
                                                        cartValues["HandCurtainNum2"],
                                                        pageLanguage
                                                      )}
                                                  </h2>
                                                </li>
                                              )}
                                            </ul>
                                          </li>
                                        )}
                                        {cartValues["PrivacyLayer"] &&
                                          cartValues["PrivacyLayer"] !== "none" &&
                                          cartValues["SheersDesignEn"] &&
                                          cartValues["SheersColorEn"] && (
                                            <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_pl">
                                              <h1 className="cart_agree_item_fabrics_sorted_title 94">
                                                {t("Privacy Layer")}
                                              </h1>
                                              <ul>
                                                <li className="cart_agree_item cart_agree_item_new">
                                                  <h1 className="cart_agree_item_title">
                                                    {t("Fabric & Color")}
                                                    &nbsp;
                                                  </h1>
                                                  <h2 className="cart_agree_item_desc">
                                                    {pageLanguage === "fa"
                                                      ? cartValues["SheersDesignFa"] +
                                                        " / " +
                                                        cartValues["SheersColorFa"]
                                                      : CapitalizeAllWords(
                                                          cartValues["SheersDesignEn"] +
                                                            " / " +
                                                            cartValues["SheersColorEn"]
                                                        )}
                                                  </h2>
                                                </li>
                                                {temp3}
                                                {cartValues["FinishedLengthType"] &&
                                                  cartValues["FinishedLengthType"] ===
                                                    "Slight Puddle" && (
                                                    <li className="cart_agree_item cart_agree_item_new">
                                                      <h1 className="cart_agree_item_title">
                                                        {t("dk_step2A")}&nbsp;
                                                      </h1>
                                                      <h2 className="cart_agree_item_desc 6">
                                                        {t("Floor")}
                                                      </h2>
                                                    </li>
                                                  )}
                                              </ul>
                                            </li>
                                          )}
                                        {!!temp4.length && (
                                          <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_acc">
                                            <h1 className="cart_agree_item_fabrics_sorted_title 2">
                                              {t("Accessories")}
                                            </h1>
                                            <ul>{temp4}</ul>
                                          </li>
                                        )}
                                        <li className="cart_agree_item cart_agree_item_new cart_agree_item_fabrics_sorted cart_agree_item_label"
                                         style={{padding: "0.9rem 0"}}
                                        >
                                          <h1 className="cart_agree_item_title 6">
                                            {pageLanguage === "fa" ? "نام اتاق" : "Room Label"}
                                            &nbsp;
                                          </h1>
                                          <h2 className="cart_agree_item_desc">
                                            {pageLanguage === "fa"
                                              ? roomNameFa +
                                                (cartValues["WindowDescription"] ? "" : " / " + WindowDescription)
                                              : roomName +
                                                (cartValues["WindowDescription"] === "" ? "" : " / " + WindowDescription)}
                                          </h2>
                                        </li>
                                        {moreInfoInput !== "" && (
                                          <li className="basket_item_title_desc basket_item_title_desc_new 8" style={{marginTop: "0.8rem"}}>
                                            <h1 className="cart_agree_item_title">
                                              {t("Order Notes")}&nbsp;
                                            </h1>
                                            <ShowMoreLineLimited
                                              moreInfoInput={moreInfoInput}
                                              lines={3}
                                            />
                                          </li>
                                        )}
                                      </div>
                                    </Accordion.Body>
                                  </Accordion.Item>
                                </Accordion>
                              </h3>
                            </div>
                          );
                          resolve();
                        });
                      })
                      .catch((err) => {
                        console.log(err);
                        resolve();
                      });
                  });
                } else {
                  promiseArr0[0] = new Promise((resolve, reject) => {
                    let promiseArr3 = [];
                    Object.keys(obj).forEach((key, i) => {
                      promiseArr3[i] = new Promise((resolve, reject) => {
                        let tempObj = userProjects.find((obj) => obj["apiLabel"] === key);
                        if (tempObj === undefined || obj[key] === undefined) {
                          resolve();
                        } else if (key === "IsWalled") {
                          resolve();
                        } else if (
                          tempObj["displayWhen"] &&
                          !Object.keys(tempObj["displayWhen"]).every(
                            (conditionKey) =>
                              obj[conditionKey] === tempObj["displayWhen"][conditionKey]
                          )
                        ) {
                          resolve();
                        } else if (
                          tempObj["apiLabel"] === "WindowWidth" &&
                          tempObj["measurements"]
                        ) {
                          if (firstMeasurements) {
                            firstMeasurements = false;
                            if (obj["CalcWindowSize"]) {
                              GetUserProjectData(obj1["SewingOrder"], true)
                                .then((temp) => {
                                  desc[tempObj["order"]] = (
                                    <div className="basket_item_title_desc basket_item_title_desc_new 9" key="basket-measurements">
                                      <h3 className="basket_measurement_accordion_container">
                                        <Accordion>
                                          <Accordion.Item eventKey="0">
                                            <ContextAwareToggleViewDetails
                                              eventKey="0"
                                              textOnHide={
                                                <>
                                                  {NumToFa(
                                                    obj["WindowWidth"] + t("Measurements CM"),
                                                    pageLanguage
                                                  )}
                                                  <span dir="ltr"> x </span>
                                                  {NumToFa(
                                                    obj["WindowHeight"] + t("Measurements CM"),
                                                    pageLanguage
                                                  )}
                                                </>
                                              }
                                              textOnShow={t("Hide Details")}
                                              textOnHide2={t("Measurements")}
                                              textOnShow2={t("Measurements")}
                                              type={2}
                                            />
                                            <Accordion.Body className="basket_item_title_dropdown dk_curtain_preview_dropdown">
                                              <div className="basket_item_title_container 7">
                                                <GetMeasurementArray
                                                  modelId={`${SewingModelId}`}
                                                  cartValues={temp}
                                                />
                                              </div>
                                            </Accordion.Body>
                                          </Accordion.Item>
                                        </Accordion>
                                      </h3>
                                    </div>
                                  );
                                  resolve();
                                })
                                .catch((err) => {
                                  console.log(err);
                                  resolve();
                                });
                            } else {
                              desc[tempObj["order"]] = (
                                <div className="basket_item_title_desc basket_item_title_desc_new 10" key="basket-measurements">
                                  <h3>{t("Measurements")}&nbsp;</h3>
                                  <h4>
                                    {NumToFa(
                                      obj["WindowWidth"] + t("Measurements CM"),
                                      pageLanguage
                                    )}
                                    <span dir="ltr"> x </span>
                                    {NumToFa(
                                      obj["WindowHeight"] + t("Measurements CM"),
                                      pageLanguage
                                    )}
                                  </h4>
                                </div>
                              );
                              resolve();
                            }
                          } else {
                            resolve();
                          }
                        } else if (
                          tempObj["apiLabel"] === "WindowHeight" &&
                          tempObj["measurements"]
                        ) {
                          resolve();
                        } else {
                          if (
                            tempObj["title"] !== "" &&
                            tempObj["lang"].indexOf(pageLanguage) > -1
                          ) {
                            let objLabel = "";
                            let apiValue =
                              obj[tempObj["apiLabel"]] === null
                                ? "null"
                                : obj[tempObj["apiLabel"]].toString();
                            if (
                              tempObj["apiLabel"] === "MountPositionId" &&
                              Number(obj.MountPositionId) === 4802
                            ) {
                              const isWalledRaw = normalizeOutsideMountSubType(
                                obj.IsWalled,
                                obj.installationLocation
                              );
                              objLabel =
                                formatCombinedOutsideMountLabel(isWalledRaw, pageLanguage, t) ||
                                t("Outside Mount");
                            } else if (
                              tempObj["apiLabel"] === "ControlType" &&
                              obj["ControlType"] === "Motorized"
                            ) {
                              const keyValue = obj[key] != null ? obj[key].toString() : "";
                              const motorTypeValue =
                                obj["MotorType"] != null ? obj["MotorType"].toString() : "";
                              objLabel =
                                pageLanguage === "fa"
                                  ? NumberToPersianWord.convertEnToPe(
                                      `${t(keyValue)} / ${t(motorTypeValue)}`
                                    ).toString()
                                  : `${t(keyValue)} / ${t(motorTypeValue)}`;
                            } else if (tempObj["titleValue"] === null) {
                              if (tempObj["titlePostfix"] === "") {
                                objLabel =
                                  pageLanguage === "fa"
                                    ? NumberToPersianWord.convertEnToPe(
                                        `${t(apiValue.toString())}`
                                      ).toString()
                                    : t(apiValue.toString());
                              } else {
                                objLabel =
                                  pageLanguage === "fa"
                                    ? NumberToPersianWord.convertEnToPe(`${apiValue}`).toString() +
                                      t(tempObj["titlePostfix"])
                                    : apiValue.toString() + t(tempObj["titlePostfix"]);
                              }
                            } else {
                              if (tempObj["titleValue"][apiValue.toString()] === null) {
                                if (tempObj["titlePostfix"] === "") {
                                  objLabel = t(apiValue.toString());
                                } else {
                                  objLabel =
                                    pageLanguage === "fa"
                                      ? NumberToPersianWord.convertEnToPe(
                                          `${apiValue}`
                                        ).toString() + t(tempObj["titlePostfix"])
                                      : apiValue.toString() + t(tempObj["titlePostfix"]);
                                }
                              } else {
                                objLabel = t(tempObj["titleValue"][apiValue.toString()]);
                              }
                            }
                            temp5[getDkBasketDetailOrder(SewingModelId, tempObj, userProjects)] = (
                              <li className="cart_agree_item cart_agree_item_new" key={key}>
                                <h1 className="cart_agree_item_title">
                                  {t(tempObj["title"])}&nbsp;
                                </h1>
                                <h2 className="cart_agree_item_desc">{objLabel}</h2>
                              </li>
                            );

                            resolve();
                          } else {
                            resolve();
                          }
                        }
                      });
                    });
                    Promise.all(promiseArr3).then(() => {
                      desc[40] = (
                        <div className="basket_item_title_desc basket_item_title_desc_new 11" key="basket-customize">
                          {/*<h3>{t("Measurements")}&nbsp;</h3>*/}
                          <h3 className="basket_measurement_accordion_container">
                            <Accordion>
                              <Accordion.Item eventKey="0">
                                <ContextAwareToggleViewDetails
                                  eventKey="0"
                                  textOnHide={t("View Details")}
                                  textOnShow={t("Hide Details")}
                                  textOnHide2={t("Customize")}
                                  textOnShow2={t("Customize")}
                                  type={2}
                                />
                                <Accordion.Body className="basket_item_title_dropdown dk_curtain_preview_dropdown">
                                  <div className="basket_item_title_container 8">
                                    <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_general">
                                      <h1 className="cart_agree_item_fabrics_sorted_title 31">
                                        {t("General Details")}
                                      </h1>
                                      <ul>
                                        {obj["BorderOrTrimDesignEn"] &&
                                          obj["BorderOrTrimDesignEn"] !== "" && (
                                            <li className="cart_agree_item cart_agree_item_new 12">
                                              <h1 className="cart_agree_item_title">
                                                {t("Decorative Border")}&nbsp;
                                              </h1>
                                              <h2 className="cart_agree_item_desc">
                                                {pageLanguage === "fa"
                                                  ? obj["BorderOrTrimDesignFa"] +
                                                    " / " +
                                                    obj["BorderOrTrimColorFa"]
                                                  : CapitalizeAllWords(
                                                      obj["BorderOrTrimDesignEn"] +
                                                        " / " +
                                                        obj["BorderOrTrimColorEn"]
                                                    )}
                                                <p>{t(obj["borderPosition"])}</p>
                                              </h2>
                                            </li>
                                          )}
                                        {temp5}
                                      </ul>
                                    </li>
                                    <li className="cart_agree_item cart_agree_item_new cart_agree_item_fabrics_sorted cart_agree_item_label"
                                     style={{padding: "0.9rem 0"}}
                                    >
                                      <h1 className="cart_agree_item_title">
                                        {pageLanguage === "fa" ? "نام اتاق" : "Room Label"}
                                        &nbsp;
                                      </h1>
                                      <h2 className="cart_agree_item_desc 1">
                                        {pageLanguage === "fa"
                                          ? roomNameFa +
                                            (obj["WindowDescription"] === "" ? "" : " / " + obj["WindowDescription"])
                                          : roomName +
                                            (obj["WindowDescription"] === "" ? "" : " / " + obj["WindowDescription"])}
                                      </h2>
                                    </li>
                                    {moreInfoInput !== "" && (
                                      <li className="basket_item_title_desc basket_item_title_desc_new 12" style={{marginTop: "0.8rem"}}>
                                        <h1 className="cart_agree_item_title">
                                          {t("Order Notes")}&nbsp;
                                        </h1>
                                        <ShowMoreLineLimited
                                          moreInfoInput={moreInfoInput}
                                          lines={3}
                                        />
                                      </li>
                                    )}
                                  </div>
                                </Accordion.Body>
                              </Accordion.Item>
                            </Accordion>
                          </h3>
                        </div>
                      );
                      resolve();
                    });
                  });
                }

                Promise.all(promiseArr0).then(() => {
                  temp[i] = (
                    <li
                      className="drapery_basket_item 1"
                      key={i}
                      ref={(ref) => (draperyRef.current[obj1["CartDetailId"]] = ref)}
                    >
                      <span className="basket_item_title">
                        <div className="basket_item_image_container 1">
                          <img src={imgUrl(photoUrl)} alt="" className="basket_item_img" />
                        </div>
                        <div className="basket_item_title_container 9">
                          {(isBasketItemUnavailable(obj1) || hasBasketItemPriceChanged(obj1)) && (
                            <div className="basket_item_status_alerts">
                              {isBasketItemUnavailable(obj1) && (
                                <div className="basket_item_availability_alert">
                                  <p className="basket_item_availability_alert_text">
                                    {t("basket_item_unavailable")}
                                  </p>
                                  <div className="basket_item_availability_alert_actions">
                                    <button
                                      type="button"
                                      className="btn basket_desc_button"
                                      onClick={() => setBasketNumber(obj1["CartDetailId"], 0, 0)}
                                    >
                                      {t("REMOVE")}
                                    </button>
                                    {obj1["SewingOrder"]["PreorderText"]["SewingModelId"] ===
                                      "0321" ||
                                    obj1["SewingOrder"]["PreorderText"]["SewingModelId"] ===
                                      "0099" ? (
                                      <button
                                        type="button"
                                        className="btn basket_desc_button"
                                        onClick={() =>
                                          showEditUnderConstructionMessage(obj1["SewingOrderId"])
                                        }
                                      >
                                        {t("EDIT")}
                                      </button>
                                    ) : (
                                      <Link
                                        className="btn basket_desc_button"
                                        to={
                                          "/" +
                                          pageLanguage +
                                          JSON.parse(JSON.stringify(UserProjects))[
                                            obj1["SewingOrder"]["PreorderText"]["SewingModelId"]
                                          ]["route"] +
                                          (obj["PageType"] ? "/" + obj["PageType"] : "") +
                                          "/Bag-Projects/" +
                                          obj1["SewingOrderId"] +
                                          "/Page-ID/" +
                                          obj["PageId"]
                                        }
                                      >
                                        {t("EDIT")}
                                      </Link>
                                    )}
                                  </div>
                                </div>
                              )}
                              {hasBasketItemPriceChanged(obj1) && (
                                <div className="basket_item_price_change_alert">
                                  <p className="basket_item_price_change_alert_text">
                                    {t("basket_item_price_changed")}
                                  </p>
                                </div>
                              )}
                            </div>
                          )}
                          <div className="basket_item_title_name desktop_only 1">
                            {pageLanguage === "fa"
                              ? convertToPersian(defaultModelNameFa) + " سفارشی "
                              : "Custom " + defaultModelName}
                            <h5>
                              {/* &nbsp; */}
                              {pageLanguage === "fa"
                                ? obj["RoomNameFa"] +
                                  (!obj["WindowDescription"] ? "" : " / " + obj["WindowDescription"])
                                : obj["RoomNameEn"] +
                                  (!obj["WindowDescription"] ? "" : " / " + obj["WindowDescription"])}
                            </h5>
                          </div>
                          <div className="basket_item_title_name mobile_only">
                            <span className="basket_item_title_mob_container">
                              <h5>
                                <h4>
                                  {pageLanguage === "fa"
                                    ? convertToPersian(defaultModelNameFa) + " سفارشی "
                                    : "Custom " + defaultModelName}
                                  &nbsp;&nbsp;
                                </h4>
                                {pageLanguage === "fa"
                                  ? obj["RoomNameFa"] +
                                    (!obj["WindowName"] ? "" : " / " + obj["WindowName"])
                                  : obj["RoomNameEn"] +
                                    (!obj["WindowName"] ? "" : " / " + obj["WindowName"])}
                              </h5>
                            </span>
                            <span className="basket_item_title_mob_price_container">
                              {GetPrice(obj["Price"], pageLanguage, t("TOMANS"), isTabletOrMobile)}
                            </span>
                          </div>
                          {SewingModelId === "0326" && (
                            <div className="basket_item_title_desc basket_item_title_desc_new 133">
                              <h3>
                                {pageLanguage === "fa" ? "پارچه/رنگ" : "Fabric/Color"}
                                &nbsp;
                              </h3>
                              <h4>
                                {obj["statusFabricItem"] === "mono" ? (
                                  resolveDkMonoFabricLabel(dkFabricObj, pageLanguage, t)
                                ) : (
                                  <DkMultiFabricAccordion
                                    obj={dkFabricObj}
                                    pageLanguage={pageLanguage}
                                    t={t}
                                    containerClassName="dk_curtain_preview_container 3"
                                    ToggleComponent={ContextAwareToggleViewDetails}
                                  />
                                )}
                              </h4>
                            </div>
                          )}
                          {SewingModelId === "0325" && (
                            <>
                              <div className="basket_item_title_desc basket_item_title_desc_new 14">
                                <h3>{t("dualRoller_step1")}&nbsp;</h3>
                                <h4>
                                  {pageLanguage === "fa"
                                    ? obj["FabricDesignFa"] + " / " + obj["FabricColorFa"]
                                    : obj["FabricDesignEn"] + " / " + obj["FabricColorEn"]}
                                </h4>
                              </div>
                              <div className="basket_item_title_desc basket_item_title_desc_new 15">
                                <h3>{t("dualRoller_step2")}&nbsp;</h3>
                                <h4>
                                  {pageLanguage === "fa"
                                    ? obj["FabricDesignFa2"] + " / " + obj["FabricColorFa2"]
                                    : obj["FabricDesignEn2"] + " / " + obj["FabricColorEn2"]}
                                </h4>
                              </div>
                            </>
                          )}

                          {(SewingModelId === "0303" ||
                            SewingModelId === "0324" ||
                            SewingModelId === "0097" ||
                            SewingModelId === "0327" ||
                            SewingModelId === "0328") && (
                            <>
                              {obj["FabricId"] && (
                                <div className="basket_item_title_desc basket_item_title_desc_new 16">
                                  <h3>{t("Fabric & Color")}&nbsp;</h3>
                                  <h4>
                                    {pageLanguage === "fa"
                                      ? obj["FabricDesignFa"] + " / " + obj["FabricColorFa"]
                                      : CapitalizeAllWords(
                                          obj["FabricDesignEn"] + " / " + obj["FabricColorEn"]
                                        )}
                                  </h4>
                                </div>
                              )}
                            </>
                          )}
                          {desc}

                          <div className="basket_item_qty_mob_container mobile_only">
                            <div className="basket_item_qty_numbers">
                              <button
                                type="text"
                                className="basket_qty_minus"
                                onClick={() => setBasketNumber(obj1["CartDetailId"], 0, 0, -1)}
                              >
                                <img
                                  src={require("../Images/public/minus.svg").default}
                                  alt=""
                                  className="qty_math_icon"
                                />
                              </button>
                              <input
                                type="text"
                                className="basket_qty_num 1"
                                value={
                                  pageLanguage === "fa"
                                    ? NumberToPersianWord.convertEnToPe(`${obj["WindowCount"]}`)
                                    : obj["WindowCount"]
                                }
                                onChange={(e) =>
                                  setBasketNumber(
                                    obj1["CartDetailId"],
                                    NumberToPersianWord.convertPeToEn(`${e.target.value}`),
                                    0
                                  )
                                }
                                readOnly
                              />
                              <button
                                type="text"
                                className="basket_qty_plus"
                                onClick={() => setBasketNumber(obj1["CartDetailId"], 0, 0, 1)}
                              >
                                <img
                                  src={require("../Images/public/plus.svg").default}
                                  alt=""
                                  className="qty_math_icon"
                                />
                              </button>
                            </div>
                            <div className="basket_item_qty_mob_price">
                              {GetPrice(
                                obj["Price"] * obj["WindowCount"],
                                pageLanguage,
                                t("TOMANS"),
                                isTabletOrMobile
                              )}
                            </div>
                          </div>
                          {zipcode && zipcode !== "" && (
                            <div className="basket_zipcode_container 1">
                              <div className="basket_zipcode_left">
                                <h1 className="basket_zipcode_title">
                                  {t("basket_zipcode_text1")}
                                </h1>
                                {(zipcodeId === -1 || zipcodeId !== obj1["SewingOrderId"]) && (
                                  <div className="basket_zipcode_change_container">
                                    <h2 className="basket_zipcode_title2">
                                      {t("basket_zipcode_text3")}
                                      {pageLanguage === "fa"
                                        ? NumberToPersianWord.convertEnToPe(`${zipcode}`)
                                        : zipcode}
                                      &nbsp;|&nbsp;
                                    </h2>
                                    <h2
                                      className="basket_zipcode_title3 text_underline"
                                      onClick={() => {
                                        setOriginalZipcode(zipcode);
                                        setZipcodeAll("");
                                        setZipcodeId(obj1["SewingOrderId"]);
                                      }}
                                    >
                                      {t("Change")}
                                    </h2>
                                  </div>
                                )}
                              </div>
                              <div className="basket_zipcode_right">
                                <h2 className="basket_zipcode_price 1">
                                  {GetPrice(
                                    InstallAmount,
                                    pageLanguage,
                                    t("TOMANS"),
                                    isTabletOrMobile
                                  )}
                                </h2>
                              </div>
                              <div className="box100">
                                {zipcodeId === obj1["SewingOrderId"] && (
                                  <>
                                    <div className="basket_zipcode_change_input_container">
                                      <input
                                        className="zipcode_input form-control"
                                        type="text"
                                        name="zipcode_input"
                                        defaultValue={zipcodeAll}
                                        placeholder={t("Enter Zip Code")}
                                        onChange={(e) => {
                                          setZipcodeAll(e.target.value.replace(/\D+/g, ""));
                                        }}
                                        onKeyDown={(e) => {
                                          if (e.key === "Enter") {
                                            setZipcodeButton(true);
                                          }
                                        }}
                                      />
                                      <button
                                        className="zipcode_input_button white_btn 1"
                                        onClick={() => {
                                          setZipcodeButton(true);
                                        }}
                                      >
                                        {t("Update")}
                                      </button>
                                    </div>
                                    <p className="change_zipcode_text">
                                      {t("change_zipcode_text")}
                                    </p>
                                  </>
                                )}
                                {zipcodeId === obj1["SewingOrderId"] && hasInstall === false && (
                                  <h3 className="basket_zipcode_err">{t("basket_zipcode_err")}</h3>
                                )}
                                <button
                                  className="basket_zipcode_btn text_underline 1"
                                  onClick={() => removeZipcode(obj1["CartDetailId"])}
                                >
                                  {t("Remove")}
                                </button>
                              </div>
                            </div>
                          )}
                          <div className="basket_item_delivery_section">
                            <div className="basket_item_delivery_avail">
                              <h2 className="basket_item_delivery_desc 1">
                                {zipcode && zipcode !== ""
                                  ? t("AVAILABILITY_desc")
                                  : t("AVAILABILITY_desc2")}
                              </h2>
                            </div>
                            <div className="basket_item_delivery_return">
                              <h2 className="basket_item_delivery_desc 2">{t("RETURNS_desc")}</h2>
                            </div>
                          </div>
                          <div className="basket_item_desc_button 1">
                            {obj1["SewingOrder"]["PreorderText"]["SewingModelId"] === "0321" ||
                            obj1["SewingOrder"]["PreorderText"]["SewingModelId"] === "0099" ? (
                              <div className="basket_edit_action_wrapper">
                                <button
                                  type="button"
                                  className="btn basket_desc_button"
                                  onClick={() =>
                                    showEditUnderConstructionMessage(obj1["SewingOrderId"])
                                  }
                                >
                                  {t("EDIT")}
                                </button>
                                {String(editUnderConstructionId) ===
                                  String(obj1["SewingOrderId"]) && (
                                  <span className="basket_edit_under_construction_msg">
                                    {pageLanguage === "fa"
                                      ? "صفحه در حال ساخت می باشد."
                                      : "This page is under construction."}
                                  </span>
                                )}
                              </div>
                            ) : (
                              <Link
                                className="btn basket_desc_button"
                                to={
                                  "/" +
                                  pageLanguage +
                                  JSON.parse(JSON.stringify(UserProjects))[
                                    obj1["SewingOrder"]["PreorderText"]["SewingModelId"]
                                  ]["route"] +
                                  (obj["PageType"] ? "/" + obj["PageType"] : "") +
                                  "/Bag-Projects/" +
                                  obj1["SewingOrderId"] +
                                  "/Page-ID/" +
                                  obj["PageId"]
                                }
                              >
                                {t("EDIT")}
                              </Link>
                            )}
                            <button
                              className="btn basket_desc_button"
                              onClick={() =>
                                copyItem(obj1["SewingOrder"], obj["PageId"], obj["PageType"])
                              }
                            >
                              {t("Add Similar")}
                            </button>
                            <button
                              className="btn basket_desc_button"
                              onClick={() => setBasketNumber(obj1["CartDetailId"], 0, 0)}
                            >
                              {t("REMOVE")}
                            </button>
                            <button
                              className="btn basket_desc_button"
                              onClick={() => saveForLaterBasketProject(obj1["CartDetailId"])}
                            >
                              {t("SAVE TO MY ACCOUNT")}
                            </button>
                          </div>
                        </div>
                      </span>

                      <span className="basket_item_price desktop_only 1">
                        {getPriceBasket(UnitPriceLogin, pageLanguage, t("T"), isTabletOrMobile)}
                      </span>
                      <span className="basket_item_qty desktop_only">
                        <div className="basket_item_qty_numbers">
                          <button
                            type="text"
                            className="basket_qty_minus"
                            onClick={() => setBasketNumber(obj1["CartDetailId"], 0, 0, -1)}
                          >
                            <img
                              src={require("../Images/public/minus.svg").default}
                              alt=""
                              className="qty_math_icon"
                            />
                          </button>
                          <input
                            type="text"
                            className="basket_qty_num 2"
                            value={
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${countNumber}`)
                                : countNumber
                            }
                            onChange={(e) =>
                              setBasketNumber(
                                obj1["CartDetailId"],
                                NumberToPersianWord.convertPeToEn(`${e.target.value}`),
                                0
                              )
                            }
                            readOnly
                          />
                          <button
                            type="text"
                            className="basket_qty_plus"
                            onClick={() => {
                              setBasketNumber(obj1["CartDetailId"], 0, 0, 1);
                            }}
                          >
                            <img
                              src={require("../Images/public/plus.svg").default}
                              alt=""
                              className="qty_math_icon"
                            />
                          </button>
                        </div>
                      </span>
                      <span className="basket_item_total desktop_only 1">
                        {getPriceBasket(
                          UnitPriceLogin * countNumber,
                          pageLanguage,
                          t("T"),
                          isTabletOrMobile
                        )}
                      </span>
                      <span
                        className={
                          uploadedFiles && uploadedFiles.length > 0
                            ? "basket_item_visible1"
                            : "basket_item_hidden1"
                        }
                      >
                        {uploadedFiles && uploadedFiles.length > 0 && (
                          <div className="select_container">
                            <Select
                              className="select"
                              placeholder={t("UPLOADED IMAGES/PDF")}
                              portal={document.body}
                              dropdownPosition="bottom"
                              dropdownHandle={false}
                              dropdownGap={0}
                              dropdownRenderer={({ props, state, methods }) => (
                                <CustomDropdownFiles
                                  props={props}
                                  state={state}
                                  methods={methods}
                                />
                              )}
                              contentRenderer={({ props, state, methods }) => (
                                <CustomControlFiles props={props} state={state} methods={methods} />
                              )}
                              onChange={(selected) => {
                                if (selected[0] !== undefined) {
                                  deleteFileFromProject(selected[0], projectId);
                                  console.log("3296");
                                }
                              }}
                              options={tempSelectArr}
                            />
                          </div>
                        )}
                      </span>
                    </li>
                  );
                  resolve();
                });
              } else {
                let SewingModelId = obj1["SewingModelId"];
                let fabricDesignFa = obj1["SewingModelName"];
                let fabricDesign = obj1["SewingModelEnName"];
                let defaultModelNameFa = obj1["ProductName"];
                let defaultModelName = obj1["ProductEnName"];
                let fabricColorFa = obj1["ColorName"];
                let fabricColor = obj1["ColorEnName"];
                let fabricSizeFa = obj1["ProductSizeName"];
                let fabricSize = obj1["ProductSizeEnName"];
                let DiscountedPrice = obj1["DiscountedPrice"];
                let Amount = obj1["UnitPrice"];
                let lining = pageLanguage === "fa" ? obj1.LiningTypeName : obj1.LiningTypeEnName;
                let ControlPosition = obj1["ControlPosition"] ? t("Right") : t("Left");
                let photoUrl = obj1["PhotoUrl"];
                let zipcode = "";
                let price = obj1["PayableAmount"];
                let InstallAmount = obj1["InstallAmount"];
                let count = obj1["Count"];
                let UnitId = obj1["UnitId"];
                let ProductGroupId = obj1["ProductGroupId"];
                let length = obj1["ItemLength"];
                let CartDetailId = obj1["CartDetailId"];
                let UnitMeasureId = obj1["UnitMeasureId"];

                setObjCartDetailId(CartDetailId);

                temp[i] = (
                  <li
                    className="drapery_basket_item 2"
                    key={i}
                    ref={(ref) => (draperyRef.current[obj1["CartDetailId"]] = ref)}
                  >
                    <span className="basket_item_title">
                      <div className="basket_item_image_container 2">
                        <img src={imgUrl(photoUrl)} alt="" className="basket_item_img" />
                        <span style={{ color: "#ca6667" }}>
                          {pageLanguage === "fa" ? obj1["DiscountName"] : obj1["DiscountEnName"]}
                        </span>
                      </div>
                      <div className="basket_item_title_container 10">
                        {(isBasketItemUnavailable(obj1) || hasBasketItemPriceChanged(obj1)) && (
                          <div className="basket_item_status_alerts">
                            {isBasketItemUnavailable(obj1) && (
                              <div className="basket_item_availability_alert">
                                <p className="basket_item_availability_alert_text">
                                  {t("basket_item_unavailable")}
                                </p>
                                <div className="basket_item_availability_alert_actions">
                                  <button
                                    type="button"
                                    className="btn basket_desc_button"
                                    onClick={() => setBasketNumber(obj1["CartDetailId"], 0, 1)}
                                  >
                                    {t("REMOVE")}
                                  </button>
                                  <Link
                                    className="btn basket_desc_button"
                                    to={
                                      "/" +
                                      pageLanguage +
                                      "/Product/" +
                                      (obj1["ProductGroupId"] || obj1["CatId"] || "")
                                    }
                                  >
                                    {t("SEE SIMILAR ITEMS")}
                                  </Link>
                                </div>
                              </div>
                            )}
                            {hasBasketItemPriceChanged(obj1) && (
                              <div className="basket_item_price_change_alert">
                                <p className="basket_item_price_change_alert_text">
                                  {t("basket_item_price_changed")}
                                </p>
                              </div>
                            )}
                          </div>
                        )}
                        <div className="basket_item_title_name desktop_only 2">
                          {pageLanguage === "fa"
                            ? convertToPersian(defaultModelNameFa)
                            : defaultModelName}{" "}
                          {pageLanguage === "fa" ? fabricDesignFa : fabricDesign}
                          {obj1["ProductGroupId"] === "10" && t("Fabric By The Meter_bg")}
                        </div>
                        <div className="basket_item_title_name mobile_only">
                          <span className="basket_item_title_mob_container">
                            <h5>
                              <h4>
                                {pageLanguage === "fa"
                                  ? convertToPersian(defaultModelNameFa)
                                  : defaultModelName}
                                &nbsp;&nbsp;
                                {pageLanguage === "fa" ? fabricDesignFa : fabricDesign}
                              </h4>
                            </h5>
                          </span>
                          <span className="basket_item_title_mob_price_container">
                            {GetPrice(price, pageLanguage, t("TOMANS"), isTabletOrMobile)}
                          </span>
                        </div>
                        <div className="basket_item_title_desc basket_item_title_desc_new 17">
                          <h3>{pageLanguage === "fa" ? "رنگ" : "Color"}&nbsp;</h3>
                          <h4>
                            {pageLanguage === "fa"
                              ? fabricColorFa
                              : capitalizeWordsText(fabricColor)}
                          </h4>
                        </div>
                        {obj1["Diameter"] && obj1["ProductGroupId"] !== "10" && (
                          <div className="basket_item_title_desc basket_item_title_desc_new 18">
                            <h3>{t("Diameter")}</h3>
                            <h4>
                              {pageLanguage === "fa"
                                ? `${t("MM")} ${NumberToPersianWord.convertEnToPe(
                                    obj1["Diameter"]
                                  )}`
                                : `${obj1["Diameter"]} ${t("MM")}`}
                            </h4>
                          </div>
                        )}
                        {UnitId !== 1 &&
                          ProductGroupId !== "100607" &&
                          obj1["ProductGroupId"] !== "10" &&
                          obj1["ProductGroupId"] !== "100605" &&
                          obj1["ProductGroupId"] !== "100603" &&
                          obj1["ProductGroupId"] !== "100606" &&
                          obj1["ProductGroupId"] !== "100608" &&
                          obj1["ProductGroupId"] !== "100701" &&
                          obj1["ProductGroupId"] !== "100702" && (
                            <div className="basket_item_title_desc basket_item_title_desc_new 19">
                              <h3>{pageLanguage === "fa" ? "سایز" : "Size"}&nbsp;</h3>
                              <h4>{pageLanguage === "fa" ? convertToPersian(fabricSizeFa) : fabricSize}</h4>
                            </div>
                          )}
                        {ProductGroupId === "100605" && (
                          <div className="basket_item_title_desc basket_item_title_desc_new 20">
                            <h3>{pageLanguage === "fa" ? "طول" : "Length"}&nbsp;</h3>
                            <h4>
                              {pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${t("CM")} ${length}`)
                                : `${length} ${t("CM")}`}
                            </h4>
                          </div>
                        )}

                        {UnitId !== 1 &&
                          obj1["HasLining"] !== undefined &&
                          SewingModelId !== "0303" &&
                          ProductGroupId !== "500204" &&
                          ProductGroupId !== "100607" &&
                          ProductGroupId !== "300301" &&
                          ProductGroupId !== "100605" &&
                          SewingModelId !== "0324" &&
                          SewingModelId !== "0325" &&
                          obj1["ProductGroupId"] !== "10" &&
                          obj1["ProductGroupId"] !== "100603" &&
                          obj1["ProductGroupId"] !== "100606" &&
                          obj1["ProductGroupId"] !== "100608" &&
                          obj1["ProductGroupId"] !== "100701" &&
                          obj1["ProductGroupId"] !== "100702" &&
                          obj1["ProductGroupId"] !== "300302" &&
                          obj1["ProductGroupId"] !== "300303" &&
                          obj1["ProductGroupId"] !== "300304" && (
                            <div className="basket_item_title_desc basket_item_title_desc_new 21">
                              <h3>
                                {pageLanguage === "fa" ? "آستردوزی پارچه" : "Lining"}
                                &nbsp;
                              </h3>
                              <h4>{lining}</h4>
                            </div>
                          )}
                        {UnitId !== 1 &&
                          obj1["ControlPosition"] !== undefined &&
                          (SewingModelId === "0325" ||
                            SewingModelId === "0324" ||
                            SewingModelId === "0303" ||
                            SewingModelId === "0327" ||
                            SewingModelId === "0328") && (
                            <div className="basket_item_title_desc basket_item_title_desc_new 22">
                              <h3>
                                {pageLanguage === "fa" ? "محل زنجیر" : "Control Position"}
                                &nbsp;
                              </h3>
                              <h4>{ControlPosition}</h4>
                            </div>
                          )}
                        <div className="basket_item_qty_mob_container mobile_only">
                          <div className="basket_item_qty_numbers">
                            <button
                              type="text"
                              className="basket_qty_minus"
                              onClick={() => setBasketNumber(obj1["CartDetailId"], 0, 1, -1)}
                            >
                              <img
                                src={require("../Images/public/minus.svg").default}
                                alt=""
                                className="qty_math_icon"
                              />
                            </button>
                            <input
                              type="text"
                              className="basket_qty_num 3"
                              value={
                                pageLanguage === "fa"
                                  ? NumberToPersianWord.convertEnToPe(`${count}`)
                                  : count
                              }
                              onChange={(e) =>
                                setBasketNumber(
                                  obj1["CartDetailId"],
                                  NumberToPersianWord.convertPeToEn(`${e.target.value}`),
                                  1
                                )
                              }
                              readOnly
                            />
                            <button
                              type="text"
                              className="basket_qty_plus"
                              onClick={() => setBasketNumber(obj1["CartDetailId"], 0, 1, 1)}
                            >
                              <img
                                src={require("../Images/public/plus.svg").default}
                                alt=""
                                className="qty_math_icon"
                              />
                            </button>
                          </div>
                          <div className="basket_item_qty_mob_price">
                            {GetPrice(price * count, pageLanguage, t("TOMANS"), isTabletOrMobile)}
                          </div>
                        </div>

                        {zipcode && zipcode !== "" && (
                          <div className="basket_zipcode_container 2">
                            <div className="basket_zipcode_left">
                              <h1 className="basket_zipcode_title">{t("basket_zipcode_text1")}</h1>
                              {(zipcodeId === -1 || zipcodeId !== obj1["SewingOrderId"]) && (
                                <div className="basket_zipcode_change_container">
                                  <h2 className="basket_zipcode_title2">
                                    {t("basket_zipcode_text3")}
                                    {pageLanguage === "fa"
                                      ? NumberToPersianWord.convertEnToPe(`${zipcode}`)
                                      : zipcode}
                                    &nbsp;|&nbsp;
                                  </h2>
                                  <h2
                                    className="basket_zipcode_title3 text_underline"
                                    onClick={() => {
                                      setOriginalZipcode(zipcode);
                                      setZipcodeAll("");
                                      setZipcodeId(obj1["SewingOrderId"]);
                                    }}
                                  >
                                    {t("Change")}
                                  </h2>
                                </div>
                              )}
                            </div>
                            <div className="basket_zipcode_right">
                              <h2 className="basket_zipcode_price 2">
                                {GetPrice(
                                  InstallAmount,
                                  pageLanguage,
                                  t("TOMANS"),
                                  isTabletOrMobile
                                )}
                              </h2>
                            </div>
                            <div className="box100">
                              {zipcodeId === obj1["SewingOrderId"] && (
                                <>
                                  <div className="basket_zipcode_change_input_container">
                                    <input
                                      className="zipcode_input form-control"
                                      type="text"
                                      name="zipcode_input"
                                      defaultValue={zipcodeAll}
                                      placeholder={t("Enter Zip Code")}
                                      onChange={(e) => {
                                        setZipcodeAll(e.target.value.replace(/\D+/g, ""));
                                      }}
                                      onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                          setZipcodeButton(true);
                                        }
                                      }}
                                    />
                                    <button
                                      className="zipcode_input_button white_btn 2"
                                      onClick={() => {
                                        setZipcodeButton(true);
                                      }}
                                    >
                                      {t("Update")}
                                    </button>
                                  </div>
                                  <p className="change_zipcode_text">{t("change_zipcode_text")}</p>
                                </>
                              )}
                              {zipcodeId === obj1["SewingOrderId"] && hasInstall === false && (
                                <h3 className="basket_zipcode_err">{t("basket_zipcode_err")}</h3>
                              )}
                              <button
                                className="basket_zipcode_btn text_underline 2"
                                onClick={() => removeZipcode(obj1["CartDetailId"])}
                              >
                                {t("Remove")}
                              </button>
                            </div>
                          </div>
                        )}
                        <div className="basket_item_desc_button 2">
                          <button
                            className="btn basket_desc_button"
                            onClick={() => setBasketNumber(obj1["CartDetailId"], 0, 1)}
                          >
                            {t("REMOVE")}
                          </button>
                        </div>
                      </div>
                    </span>

                    <div
                      className="basket_item_price desktop_only 2"
                      style={{
                        padding: "0.9rem 0",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                      }}
                    >
                      <p
                        style={{
                          textDecoration: DiscountedPrice < Amount ? "line-through" : "none",
                        }}
                      >
                        {getPriceBasket(Amount, pageLanguage, t("T"), isTabletOrMobile)}
                      </p>
                      {DiscountedPrice < Amount && (
                        <p style={{ color: "#ca6667" }}>
                          {GetPrice(DiscountedPrice, pageLanguage, t("T"), isTabletOrMobile)}
                        </p>
                      )}
                      {obj1["DiscountPercent"] != null && obj1["DiscountPercent"] > 0 && (
                        <p
                          style={{
                            color: "#ca6667",
                            paddingRight: "3.4rem",
                            marginTop: "0.8rem",
                          }}
                        >
                          {i18n.language === "en" ? (
                            <>{obj1["DiscountPercent"]}% off</>
                          ) : (
                            <>
                              {new Intl.NumberFormat("fa-IR").format(obj1["DiscountPercent"])} %
                              تخفیف
                            </>
                          )}
                        </p>
                      )}
                    </div>
                    <span className="basket_item_qty desktop_only">
                      <div className="basket_item_qty_numbers">
                        <button
                          type="text"
                          className="basket_qty_minus"
                          onClick={() => {
                            if (UnitMeasureId === 61) {
                              setBasketNumber(obj1["CartDetailId"], 0, 1, -0.5, obj1["ItemLength"]);
                            } else {
                              setBasketNumber(obj1["CartDetailId"], 0, 1, -1, obj1["ItemLength"]);
                            }
                          }}
                        >
                          <img
                            src={require("../Images/public/minus.svg").default}
                            alt=""
                            className="qty_math_icon"
                          />
                        </button>
                        <input
                          type="text"
                          className="basket_qty_num 4"
                          value={
                            pageLanguage === "fa"
                              ? NumberToPersianWord.convertEnToPe(`${count}`)
                              : count
                          }
                          onChange={(e) => {
                            setBasketNumber(
                              obj1["CartDetailId"],
                              NumberToPersianWord.convertPeToEn(`${e.target.value}`),
                              1
                            );
                          }}
                          readOnly
                        />
                        <button
                          type="text"
                          className="basket_qty_plus"
                          onClick={() => {
                            if (UnitMeasureId === 61) {
                              setBasketNumber(obj1["CartDetailId"], 0, 1, 0.5, obj1["ItemLength"]);
                            } else {
                              setBasketNumber(obj1["CartDetailId"], 0, 1, 1, obj1["ItemLength"]);
                            }
                          }}
                        >
                          <img
                            src={require("../Images/public/plus.svg").default}
                            alt=""
                            className="qty_math_icon"
                          />
                        </button>
                      </div>
                    </span>

                    <span className="basket_item_total desktop_only 2">
                      {getPriceBasket(
                        DiscountedPrice * count,
                        pageLanguage,
                        t("T"),
                        isTabletOrMobile
                      )}
                    </span>
                  </li>
                );
                resolve();
              }
            });
          });
        Promise.all(promiseArr).then(() => {
          setDraperyProductList(temp);
          setFiles(tempFiles);
          setNoShipping(tempNoShip);
        });
      } else {
        setDraperyProductList([]);
        setSubTotalPrice(0);
        setInstallPrice(0);
        setTransportPrice(0);
        setTotalPrice(0);
        setNoShipping(true);
      }
    } else {
      if (draperyProduct.length) {
        let tempDrapery = JSON.parse(JSON.stringify(draperyProduct));

        let temp = [];
        let delArr = [];

        const totalPrice = draperyProduct.reduce((acc, product) => {
          const priceToUse = product.DiscountedPrice ?? product.Price;
          return acc + product.Count * priceToUse;
        }, 0);

        setProjectDataPrice(totalPrice);

        let draperiesTotalPrice = 0;
        let productsTotalPrice = 0;
        let draperiesTotalInstall = 0;
        let draperiesTotalTransport = 0;
        let promiseArr = [];
        let tempNoShip = true;

        tempDrapery.forEach((obj, index) => {
          promiseArr[index] = new Promise((resolve, reject) => {
            if (obj["ProductId"]) {
              resolve(obj["Price"]);
            } else {
              resolve({ data: obj });
            }
          });
        });

        tempDrapery = tempDrapery.filter((_, index) => !delArr.includes(index));
        Promise.all(promiseArr)
          .then(function(values) {
            let tempDraperiesTotalTransport = values.find(function(el) {
              return (
                el["data"] &&
                el["data"]["TransportationAmount"] &&
                el["data"]["TransportationAmount"] > 0
              );
            });
            if (
              tempDraperiesTotalTransport &&
              tempDraperiesTotalTransport["data"] &&
              tempDraperiesTotalTransport["data"]["TransportationAmount"]
            ) {
              draperiesTotalTransport = tempDraperiesTotalTransport["data"]["TransportationAmount"];
            } else {
              draperiesTotalTransport = 0;
            }

            let promiseArr = [];
            tempDrapery?.forEach((obj1, index) => {
              let fabricItemId = obj1["fabricItemId"];
              promiseArr[index] = new Promise((resolve, reject) => {
                let bagLength = tempDrapery.length;

                if (obj1["ProductId"]) {
                  let SewingModelId = obj1["SewingModelId"];
                  let projectId = obj1["ProductId"];
                  console.log(`obj1`, obj1);
                  let fabricDesignFa = obj1["SewingModelName"];
                  let fabricDesign = obj1["SewingModelEnName"];
                  let defaultModelNameFa = obj1["ProductName"];
                  let defaultModelName = obj1["ProductENName"];
                  let fabricColorFa = obj1["ColorName"];
                  let fabricColor = obj1["ColorEnName"];
                  let fabricSizeFa = obj1["ProductSizeName"];
                  let fabricSize = obj1["ProductSizeEnName"];
                  let lining = pageLanguage === "fa" ? obj1.LiningTypeName : obj1.LiningTypeEnName;
                  let ControlPosition = obj1["ControlPosition"] ? t("Right") : t("Left");
                  let photoUrl = obj1["PhotoUrl"];
                  let zipcode = "";
                  let price = obj1["Price"];
                  let InstallAmount = obj1["InstallAmount"];
                  let count = obj1["Count"];
                  let DiscountedPrice = obj1["DiscountedPrice"];

                  productsTotalPrice += count * DiscountedPrice;

                  temp[bagLength - index - 1] = (
                    <li
                      className="drapery_basket_item 3"
                      key={index}
                      ref={(ref) => (draperyRef.current[obj1["CartDetailId"]] = ref)}
                    >
                      <span className="basket_item_title">
                        <div className="basket_item_image_container 3">
                          <img src={imgUrl(photoUrl)} alt="" className="basket_item_img" />
                          <span style={{ color: "#ca6667" }}>
                            {pageLanguage === "fa" ? obj1["DiscountName"] : obj1["DiscountEnName"]}
                          </span>
                        </div>
                        <div className="basket_item_title_container 11">
                          {(isBasketItemUnavailable(obj1) || hasBasketItemPriceChanged(obj1)) && (
                            <div className="basket_item_status_alerts">
                              {isBasketItemUnavailable(obj1) && (
                                <div className="basket_item_availability_alert">
                                  <p className="basket_item_availability_alert_text">
                                    {t("basket_item_unavailable")}
                                  </p>
                                  <div className="basket_item_availability_alert_actions">
                                    <button
                                      type="button"
                                      className="btn basket_desc_button"
                                      onClick={() => setBasketNumber(obj1["CartDetailId"], 0, 0)}
                                    >
                                      {t("REMOVE")}
                                    </button>
                                    <Link
                                      className="btn basket_desc_button"
                                      to={
                                        "/" +
                                        pageLanguage +
                                        "/Product/" +
                                        (obj1["ProductGroupId"] || obj1["CatId"] || "")
                                      }
                                    >
                                      {t("SEE SIMILAR ITEMS")}
                                    </Link>
                                  </div>
                                </div>
                              )}
                              {hasBasketItemPriceChanged(obj1) && (
                                <div className="basket_item_price_change_alert">
                                  <p className="basket_item_price_change_alert_text">
                                    {t("basket_item_price_changed")}
                                  </p>
                                </div>
                              )}
                            </div>
                          )}
                          <div className="basket_item_title_name desktop_only 3">
                            {pageLanguage === "fa"
                              ? convertToPersian(defaultModelNameFa)
                              : capitalizeWordsText(defaultModelName)}{" "}
                            {pageLanguage === "fa"
                              ? fabricDesignFa
                              : capitalizeWordsText(fabricDesign)}
                            {obj1["ProductGroupId"] === "10" && t("Fabric By The Meter_bg")}
                          </div>
                          <div className="basket_item_title_name mobile_only">
                            <span className="basket_item_title_mob_container">
                              <h5>
                                <h4>
                                  {pageLanguage === "fa"
                                    ? convertToPersian(defaultModelNameFa)
                                    : defaultModelName}
                                  &nbsp;&nbsp;
                                </h4>
                                {pageLanguage === "fa" ? fabricDesignFa : fabricDesign}
                              </h5>
                            </span>
                            <span className="basket_item_title_mob_price_container">
                              {GetPrice(price, pageLanguage, t("TOMANS"), isTabletOrMobile)}
                            </span>
                          </div>
                          <div className="basket_item_title_desc basket_item_title_desc_new 23">
                            <h3>{pageLanguage === "fa" ? "رنگ" : "Color"}&nbsp;</h3>
                            <h4>
                              {pageLanguage === "fa"
                                ? fabricColorFa
                                : capitalizeWordsText(fabricColor)}
                            </h4>
                          </div>
                         
                          {!["10","100603","100607","100605","100608","100606","100701","100702"].includes(obj1.ProductGroupId) && (
                            <div className="basket_item_title_desc basket_item_title_desc_new 24">
                               <h3>
                             {pageLanguage === "fa" ? "سایز" : "Size"}&nbsp;
                             </h3>
                               <h4>
                          {pageLanguage === "fa"? convertToPersian(fabricSizeFa): CapitalizeAllWords(fabricSize)}
                          </h4>
                           </div>
                          )}
                          {obj1["Diameter"] && obj1["ProductGroupId"] !== "10" && (
                            <div className="basket_item_title_desc basket_item_title_desc_new 25">
                              <h3>{t("Diameter")}</h3>
                              <h4>
                                {pageLanguage === "fa"
                                  ? `${t("MM")} ${NumberToPersianWord.convertEnToPe(
                                      obj1["Diameter"]
                                    )}`
                                  : `${obj1["Diameter"]} ${t("MM")}`}
                              </h4>
                            </div>
                          )}
                          {obj1["len"] && (
                            <div className="basket_item_title_desc basket_item_title_desc_new 26">
                              <h3>{i18n.language === "en" ? "LENGTH" : "طول"}</h3>
                              <h4>
                                {pageLanguage === "fa"
                                  ? `${t("CM")} ${NumberToPersianWord.convertEnToPe(obj1["len"])}`
                                  : `${obj1["len"]} ${t("CM")}`}
                              </h4>
                            </div>
                          )}

                          {!["0303", "0324", "0325"].includes(SewingModelId) &&
                            !["10","100603","100605","100606","100607","100608","500204","300301","100701","100702","300302","300303","300304"].includes(obj1.ProductGroupId) && (
                              <div className="basket_item_title_desc basket_item_title_desc_new 27">
                                <h3>{pageLanguage === "fa" ? "آستردوزی پارچه" : "Lining"}&nbsp;</h3>
                                <h4>{lining}</h4>
                              </div>
                            )}

                          {["0303", "0328", "0325", "0326", "0324", "0327", "0097"].includes(SewingModelId) && (
                            <div className="basket_item_title_desc basket_item_title_desc_new 28">
                              <h3>
                                {pageLanguage === "fa" ? "محل زنجیر" : "Control Position"}&nbsp;
                              </h3>
                              <h4>{ControlPosition}</h4>
                            </div>
                          )}
                          <div className="basket_item_qty_mob_container mobile_only">
                            <div className="basket_item_qty_numbers">
                              <button
                                type="text"
                                className="basket_qty_minus"
                                onClick={() => setBasketNumber(obj1["CartDetailId"], 0, 0, -1)}
                              >
                                <img
                                  src={require("../Images/public/minus.svg").default}
                                  alt=""
                                  className="qty_math_icon"
                                />
                              </button>
                              <input
                                type="text"
                                className="basket_qty_num 5"
                                value={
                                  pageLanguage === "fa"
                                    ? NumberToPersianWord.convertEnToPe(`${count}`)
                                    : count
                                }
                                onChange={(e) =>
                                  setBasketNumber(
                                    obj1["CartDetailId"],
                                    NumberToPersianWord.convertPeToEn(`${e.target.value}`),
                                    0
                                  )
                                }
                                readOnly
                              />
                              <button
                                type="text"
                                className="basket_qty_plus"
                                onClick={() => setBasketNumber(obj1["CartDetailId"], 0, 0, 1)}
                              >
                                <img
                                  src={require("../Images/public/plus.svg").default}
                                  alt=""
                                  className="qty_math_icon"
                                />
                              </button>
                            </div>
                            <div className="basket_item_qty_mob_price">
                              {GetPrice(price * count, pageLanguage, t("TOMANS"), isTabletOrMobile)}
                            </div>
                          </div>

                          {zipcode && zipcode !== "" && (
                            <div className="basket_zipcode_container 3">
                              <div className="basket_zipcode_left">
                                <h1 className="basket_zipcode_title">
                                  {t("basket_zipcode_text1")}
                                </h1>
                                {(zipcodeId === -1 || zipcodeId !== obj1["SewingOrderId"]) && (
                                  <div className="basket_zipcode_change_container">
                                    <h2 className="basket_zipcode_title2">
                                      {t("basket_zipcode_text3")}
                                      {pageLanguage === "fa"
                                        ? NumberToPersianWord.convertEnToPe(`${zipcode}`)
                                        : zipcode}
                                      &nbsp;|&nbsp;
                                    </h2>
                                    <h2
                                      className="basket_zipcode_title3 text_underline"
                                      onClick={() => {
                                        setOriginalZipcode(zipcode);
                                        setZipcodeAll("");
                                        setZipcodeId(obj1["SewingOrderId"]);
                                      }}
                                    >
                                      {t("Change")}
                                    </h2>
                                  </div>
                                )}
                              </div>
                              <div className="basket_zipcode_right">
                                <h2 className="basket_zipcode_price 3">
                                  {GetPrice(
                                    InstallAmount,
                                    pageLanguage,
                                    t("TOMANS"),
                                    isTabletOrMobile
                                  )}
                                </h2>
                              </div>
                              <div className="box100">
                                {zipcodeId === obj1["SewingOrderId"] && (
                                  <>
                                    <div className="basket_zipcode_change_input_container">
                                      <input
                                        className="zipcode_input form-control"
                                        type="text"
                                        name="zipcode_input"
                                        defaultValue={zipcodeAll}
                                        placeholder={t("Enter Zip Code")}
                                        onChange={(e) => {
                                          setZipcodeAll(e.target.value.replace(/\D+/g, ""));
                                        }}
                                        onKeyDown={(e) => {
                                          if (e.key === "Enter") {
                                            setZipcodeButton(true);
                                          }
                                        }}
                                      />
                                      <button
                                        className="zipcode_input_button white_btn 3"
                                        onClick={() => {
                                          setZipcodeButton(true);
                                        }}
                                      >
                                        {t("Update")}
                                      </button>
                                    </div>
                                    <p className="change_zipcode_text">
                                      {t("change_zipcode_text")}
                                    </p>
                                  </>
                                )}
                                {zipcodeId === obj1["SewingOrderId"] && hasInstall === false && (
                                  <h3 className="basket_zipcode_err">{t("basket_zipcode_err")}</h3>
                                )}
                                <button
                                  className="basket_zipcode_btn text_underline 3"
                                  onClick={() => removeZipcode(obj1["CartDetailId"])}
                                >
                                  {t("Remove")}
                                </button>
                              </div>
                            </div>
                          )}
                          <div className="basket_item_desc_button 3">
                            <button
                              className="btn basket_desc_button"
                              onClick={() => setBasketNumber(obj1["CartDetailId"] ? obj1["CartDetailId"] : obj1["ProductId"], 0, 0)}
                            >
                              {t("REMOVE")}
                            </button>
                          </div>
                        </div>
                      </span>

                      <div
                        className="basket_item_price desktop_only 3"
                        style={{
                          padding: "0.9rem 0",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "flex-start",
                          alignItems: "flex-start",
                        }}
                      >
                        <p
                          style={{
                            textDecoration: DiscountedPrice < price ? "line-through" : "none",
                          }}
                        >
                          {getPriceBasket(price, pageLanguage, t("T"), isTabletOrMobile)}
                        </p>
                        {DiscountedPrice < price && (
                          <p style={{ color: "#ca6667" }}>
                            {getPriceBasket(DiscountedPrice, pageLanguage, t("T"), isTabletOrMobile)}
                          </p>
                        )}
                        {obj1["DiscountPercent"] != null && obj1["DiscountPercent"] > 0 && (
                          <p
                            style={{
                              color: "#ca6667",
                              paddingRight: "3.4rem",
                              marginTop: "0.8rem",
                            }}
                          >
                            {i18n.language === "en" ? (
                              <>{obj1["DiscountPercent"]}% off</>
                            ) : (
                              <>
                                {new Intl.NumberFormat("fa-IR").format(obj1["DiscountPercent"])} %
                                تخفیف
                              </>
                            )}
                          </p>
                        )}
                      </div>
                      <span className="basket_item_qty desktop_only">
                        <div className="basket_item_qty_numbers">
                          <button
                            type="text"
                            className="basket_qty_minus"
                            onClick={() => {
                              if (
                                obj1["ProductGroupId"] === "10" ||
                                obj1["ProductGroupId"] === "100702"
                              ) {
                                setBasketNumber(projectId, 0, 0, -0.5);
                              } else {
                                setBasketNumber(projectId, 0, 0, -1);
                              }
                            }}
                          >
                            <img
                              src={require("../Images/public/minus.svg").default}
                              alt=""
                              className="qty_math_icon"
                            />
                          </button>
                          <input
                            type="text"
                            className="basket_qty_num 6"
                            value={
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${count}`)
                                : count
                            }
                            onChange={(e) =>
                              setBasketNumber(
                                obj1["CartDetailId"],
                                NumberToPersianWord.convertPeToEn(`${e.target.value}`),
                                0
                              )
                            }
                            readOnly
                          />
                          <button
                            type="text"
                            className="basket_qty_plus"
                            onClick={() => {
                              if (
                                obj1["ProductGroupId"] === "10" ||
                                obj1["ProductGroupId"] === "100702"
                              ) {
                                setBasketNumber(projectId, 0, 0, 0.5);
                              } else {
                                setBasketNumber(projectId, 0, 0, 1);
                              }
                            }}
                          >
                            <img
                              src={require("../Images/public/plus.svg").default}
                              alt=""
                              className="qty_math_icon"
                            />
                          </button>
                        </div>
                      </span>
                      <span className="basket_item_total desktop_only 3">
                        {getPriceBasket(
                          DiscountedPrice * count,
                          pageLanguage,
                          t("T"),
                          isTabletOrMobile
                        )}
                      </span>
                    </li>
                  );
                  resolve();
                } else {
                  if (
                    values[index] === undefined ||
                    values[index].data === undefined ||
                    values[index].data["Price"] === 0
                  ) {
                    // localStorage.removeItem("cart");
                    resolve();
                  } else {
                    let obj = obj1["PreorderText"] || {};
                    const dkFabricObj = mergeDkFabricCartObj(obj, obj1);
                    let projectId = obj1["ProductId"];
                    let SewingModelId = obj["SewingModelId"];
                    let tempFiles = JSON.parse(JSON.stringify(files));
                    let userProjects = projectData[obj["SewingModelId"]]
                      ? projectData[obj["SewingModelId"]]["data"]
                      : [];
                    let uploadedFiles = obj1["SewingOrderAttachments"];
                    let tempSelectArr = [];

                    if (uploadedFiles && uploadedFiles.length > 0) {
                      // let tempSelectArr = [];
                      let promiseArrFiles = [];
                      uploadedFiles.forEach((obj1, index) => {
                        promiseArrFiles[index] = new Promise((resolve, reject) => {
                          tempSelectArr.push({
                            value: obj1["FileUrl"],
                            label: obj1["UserFileName"],
                          });
                          resolve();
                        });
                      });
                      Promise.all(promiseArrFiles).then(() => {
                        tempFiles[`${projectId}`] = tempSelectArr;
                      });
                    }
                    let desc = [];
                    let temp1 = [];
                    let temp2 = [];
                    let temp3 = [];
                    let temp4 = [];
                    let temp5 = [];
                    let defaultModelNameFa = obj["ModelNameFa"];
                    let defaultModelName = obj["ModelNameEn"];
                    let roomNameFa = obj["RoomNameFa"];
                    let roomName = obj["RoomNameEn"];
                    let WindowDescription  = obj["WindowDescription"] === undefined ? "" : obj["WindowDescription"];
                    let moreInfoInput =
                      obj["moreInfoInput"] === undefined ? "" : obj["moreInfoInput"];
                    let photoUrl = obj["PhotoUrl"];
                    let zipcode = obj1["ZipCode"];
                    setZipcodeText2(zipcode);
                    obj["Price"] = values[index].data["Price"] / obj1["WindowCount"];

                    obj["InstallAmount"] = values[index].data["InstallAmount"]
                      ? values[index].data["InstallAmount"]
                      : 0;
                    obj["TransportationAmount"] = values[index].data["TransportationAmount"]
                      ? values[index].data["TransportationAmount"]
                      : 0;
                    draperiesTotalPrice += values[index].data["Price"];
                    const installAmount = values[index].data["InstallAmount"];
                    const windowCount = obj1["WindowCount"];

                    const totalForThisProduct = installAmount * windowCount;
                    draperiesTotalInstall += totalForThisProduct;
                    if (tempNoShip) {
                      tempNoShip = zipcode && zipcode !== "";
                    }

                    let promiseArr0 = [];
                    let firstMeasurements = true;

                    if (SewingModelId === "0099") {
                      promiseArr0[0] = new Promise((resolve, reject) => {
                        GetUserProjectData(obj1, false)
                          .then((cartValues) => {
                            let promiseArr4 = [];
                            if (cartValues["Accessories"] !== undefined) {
                              cartValues["Accessories"].forEach((obj, index) => {
                                if (
                                  obj["DesignNameFa"] !== undefined &&
                                  obj["DesignNameEn"] !== undefined
                                ) {
                                  promiseArr4[index] = new Promise((resolve, reject) => {
                                    if (obj["DesignNameFa"] && obj["DesignNameEn"]) {
                                      temp4[index] = (
                                        <li className="cart_agree_item cart_agree_item_new" key={"acc" + index}>
                                          <h1 className="cart_agree_item_title">
                                            {pageLanguage === "fa"
                                              ? obj["DesignNameFa"]
                                              : obj["DesignNameEn"]}
                                            {" / "}
                                            {obj["ColorNameEn"] && (
                                              <>
                                                {pageLanguage === "fa"
                                                  ? obj["ColorNameFa"]
                                                  : obj["ColorNameEn"]}
                                              </>
                                            )}
                                          </h1>
                                          <h2 className="cart_agree_item_desc">
                                            {t("agree_Qty")}
                                            {NumToFa(obj["Qty"], pageLanguage)}
                                          </h2>
                                        </li>
                                      );
                                    }
                                    resolve();
                                  });
                                }
                              });
                            }

                            let promiseArr3 = [];
                            Object.keys(cartValues).forEach((key, index) => {
                              promiseArr3[index] = new Promise((resolve, reject) => {
                                // console.log(`key`, key);
                                let tempObj = userProjects.find((obj) => obj["cart"] === key);
                                if (tempObj === undefined || cartValues[key] === undefined) {
                                  resolve();
                                } else if (key === "IsWalled") {
                                  resolve();
                                } else {
                                  if (key === "WindowWidth" && tempObj["measurements"]) {
                                    if (firstMeasurements) {
                                      firstMeasurements = false;
                                      if (obj["CalcWindowSize"]) {
                                        desc[tempObj["order"]] = (
                                          <div className="basket_item_title_desc basket_item_title_desc_new 29" key="basket-measurements">
                                            {/*<h3>{t("Measurements")}&nbsp;</h3>*/}
                                            <h3 className="basket_measurement_accordion_container">
                                              <Accordion>
                                                <Accordion.Item eventKey="0">
                                                  <ContextAwareToggleViewDetails
                                                    eventKey="0"
                                                    textOnHide={
                                                      <>
                                                        {NumToFa(
                                                          obj["WindowWidth"] + t("Measurements CM"),
                                                          pageLanguage
                                                        )}
                                                        <span dir="ltr"> x </span>
                                                        {NumToFa(
                                                          obj["WindowHeight"] +
                                                            t("Measurements CM"),
                                                          pageLanguage
                                                        )}
                                                      </>
                                                    }
                                                    textOnShow={t("Hide Details")}
                                                    textOnHide2={t("Measurements")}
                                                    textOnShow2={t("Measurements")}
                                                    type={2}
                                                  />
                                                  <Accordion.Body className="basket_item_title_dropdown dk_curtain_preview_dropdown">
                                                    <div className="basket_item_title_container 12">
                                                      <GetMeasurementArray
                                                        modelId={`${SewingModelId}`}
                                                        cartValues={cartValues}
                                                      />
                                                    </div>
                                                  </Accordion.Body>
                                                </Accordion.Item>
                                              </Accordion>
                                            </h3>
                                          </div>
                                        );
                                      } else {
                                        // تعریف لایه‌ها
                                        const fabricLayers = [
                                          {
                                            key: "drapery",
                                            title: t("Drapery"),
                                            designEn: obj1?.FabricDesignEn,
                                            colorEn: obj1?.FabricColorEn,
                                            designFa: obj1?.FabricDesignFa,
                                            colorFa: obj1?.FabricColorFa,
                                          },
                                          {
                                            key: "sheer",
                                            title: t("Sheer"),
                                            designEn: obj1?.FabricDesignEn2,
                                            colorEn: obj1?.FabricColorEn2,
                                            designFa: obj1?.FabricDesignFa2,
                                            colorFa: obj1?.FabricColorFa2,
                                          },
                                          {
                                            key: "privacy",
                                            title: t("Privacy Layer"),
                                            designEn: obj1?.SheersDesignEn,
                                            colorEn: obj1?.SheersColorEn,
                                            designFa: obj1?.SheersDesignFa,
                                            colorFa: obj1?.SheersColorFa,
                                          },
                                        ];

                                        // فقط لایه‌های دارای مقدار
                                        const validLayers = fabricLayers.filter((layer) =>
                                          pageLanguage === "en" ? layer.designEn : layer.designFa
                                        );

                                        const layersCount = validLayers.length;

                                        desc[tempObj["order"]] = (
                                          <>
                                            {/* Fabric / Color */}
                                            {layersCount > 0 && (
                                              <div className="basket_item_title_desc basket_item_title_desc_new 134">
                                                <h3>
                                                  {pageLanguage === "fa"
                                                    ? "پارچه/رنگ"
                                                    : "Fabric/Color"}
                                                  &nbsp;
                                                </h3>

                                                <h4>
                                                  {/* فقط یک لایه */}
                                                  {layersCount === 1 && (
                                                    <>
                                                      {pageLanguage === "en"
                                                        ? `${validLayers[0].designEn} / ${t(
                                                            validLayers[0].colorEn
                                                          )}`
                                                        : `${validLayers[0].designFa} / ${t(
                                                            validLayers[0].colorFa
                                                          )}`}
                                                    </>
                                                  )}

                                                  {/* دو یا بیشتر → آکاردیون */}
                                                  {layersCount >= 2 && (
                                                    <div className="dk_curtain_preview_container 4">
                                                      <Accordion>
                                                        <Accordion.Item eventKey="0">
                                                          <ContextAwareToggleViewDetails
                                                            eventKey="0"
                                                            textOnHide={t("View Details")}
                                                            textOnShow={t("Hide Details")}
                                                          />

                                                          <Accordion.Body className="basket_item_title_dropdown dk_curtain_preview_dropdown">
                                                            <div className="dk_curtain_preview_detail_container">
                                                              {validLayers.map((layer) => (
                                                                <div
                                                                  className="dk_curtain_preview_detail"
                                                                  key={layer.key}
                                                                >
                                                                  <h2 className="sheer_h2 4">
                                                                    {layer.title}:
                                                                  </h2>

                                                                  <h3 style={{ padding: "0 1rem" }}>
                                                                    {pageLanguage === "en"
                                                                      ? `${layer.designEn} / ${t(
                                                                          layer.colorEn
                                                                        )}`
                                                                      : `${layer.designFa} / ${t(
                                                                          layer.colorFa
                                                                        )}`}
                                                                  </h3>
                                                                </div>
                                                              ))}
                                                            </div>
                                                          </Accordion.Body>
                                                        </Accordion.Item>
                                                      </Accordion>
                                                    </div>
                                                  )}
                                                </h4>
                                              </div>
                                            )}

                                            {/* Measurements */}
                                            <div className="basket_item_title_desc basket_item_title_desc_new 30" key="basket-measurements">
                                              <h3>{t("Measurements")}&nbsp;</h3>
                                              <h4>
                                                {NumToFa(
                                                  obj["WindowWidth"] + t("Measurements CM"),
                                                  pageLanguage
                                                )}
                                                <span dir="ltr"> x </span>
                                                {NumToFa(
                                                  obj["WindowHeight"] + t("Measurements CM"),
                                                  pageLanguage
                                                )}
                                              </h4>
                                            </div>
                                          </>
                                        );

                                        resolve();
                                      }

                                      resolve();
                                    } else {
                                      resolve();
                                    }
                                  } else if (key === "WindowHeight" && tempObj["measurements"]) {
                                    resolve();
                                  } else if (
                                    (key === "PanelTypeOption" &&
                                      cartValues["PanelTypeOption"] ===
                                        "Customize Style Per Curtain") ||
                                    (key === "Hardware" &&
                                      cartValues["Hardware"] ===
                                        "I Want To Customize Hardware Per Curtain")
                                  ) {
                                    resolve();
                                  } else if (
                                    tempObj["title"] !== "" &&
                                    tempObj["lang"].indexOf(pageLanguage) > -1
                                  ) {
                                    let objLabel = "";
                                    if (key === "Mount" && cartValues["Mount"] === "Outside") {
                                      const isWalledRaw = normalizeOutsideMountSubType(
                                        cartValues["IsWalled"],
                                        cartValues["installationLocation"]
                                      );
                                      const combinedLabel = formatCombinedOutsideMountLabel(
                                        isWalledRaw,
                                        pageLanguage,
                                        t
                                      );
                                      objLabel = combinedLabel
                                        ? pageLanguage === "fa"
                                          ? NumberToPersianWord.convertEnToPe(
                                              combinedLabel
                                            ).toString()
                                          : combinedLabel
                                        : pageLanguage === "fa"
                                        ? NumberToPersianWord.convertEnToPe(t("Outside")).toString()
                                        : t("Outside Mount");
                                    } else if (
                                      key === "ControlType" &&
                                      cartValues["ControlType"] === "Motorized"
                                    ) {
                                      objLabel =
                                        pageLanguage === "fa"
                                          ? NumberToPersianWord.convertEnToPe(
                                              `${t(cartValues[key].toString())} / ${t(
                                                cartValues["MotorType"].toString()
                                              )}`
                                            ).toString()
                                          : `${t(cartValues[key].toString())} / ${t(
                                              cartValues["MotorType"].toString()
                                            )}`;
                                    }
                                   
                                    else if (
                                      key === "DraperyHardware" &&
                                      cartValues["DraperyHardware"] !== "None"
                                    ) {
                                      if (cartValues["RailDesignEnA"] === "Motorized Track") {
                                        objLabel =
                                          t(cartValues[key]?.toString()) +
                                          " / " +
                                          (pageLanguage === "fa"
                                            ? cartValues["RailDesignFaA"]
                                            : cartValues["RailDesignEnA"]);
                                      } else {
                                        const railDesignAGuest =
                                          pageLanguage === "fa"
                                            ? cartValues["RailDesignFaA"]
                                            : cartValues["RailDesignEnA"];
                                        const railColorAGuest =
                                          pageLanguage === "fa"
                                            ? cartValues["RailColorFaA"]
                                            : cartValues["RailColorEnA"];
                                        let batonOrControlAGuest = "";
                                        if (
                                          cartValues["BatonOptionA"] &&
                                          cartValues["BatonOptionA"] !== "None"
                                        ) {
                                          batonOrControlAGuest =
                                            " / " + t(cartValues["BatonOptionA"]);
                                        } else if (cartValues["ControlPositionA"]) {
                                          batonOrControlAGuest =
                                            " / " + t(cartValues["ControlPositionA"]);
                                        }
                                        objLabel =
                                          t(cartValues[key]?.toString()) +
                                          (railDesignAGuest ? " / " + railDesignAGuest : "") +
                                          (railColorAGuest ? " / " + railColorAGuest : "") +
                                          batonOrControlAGuest;
                                      }
                                    } else if (
                                      key === "SheerHardware" &&
                                      cartValues["SheerHardware"] !== "None"
                                    ) {
                                      objLabel = buildCartHardwareLabel({
                                        hardwareValue: cartValues[key],
                                        railDesignFa: cartValues["RailDesignFaB"],
                                        railDesignEn: cartValues["RailDesignEnB"],
                                        railColorFa: cartValues["RailColorFaB"],
                                        railColorEn: cartValues["RailColorEnB"],
                                        batonOption: cartValues["BatonOptionB"],
                                        controlPosition: cartValues["ControlPositionB"],
                                        pageLanguage,
                                        t,
                                      });
                                    } else if (
                                      key === "PrivacyLayerHardware" &&
                                      cartValues["PrivacyLayerHardware"] !== "None"
                                    ) {
                                      objLabel = buildCartHardwareLabel({
                                        hardwareValue: cartValues[key],
                                        railDesignFa: cartValues["RailDesignFaC"],
                                        railDesignEn: cartValues["RailDesignEnC"],
                                        railColorFa: cartValues["RailColorFaC"],
                                        railColorEn: cartValues["RailColorEnC"],
                                        batonOption: cartValues["BatonOptionC"],
                                        controlPosition: cartValues["ControlPositionC"],
                                        pageLanguage,
                                        t,
                                      });
                                    } else if (key === "HandCurtainEn" || key === "HandCurtainFa") {
                                      objLabel =
                                        t("agree_Qty") +
                                        NumToFa(cartValues["HandCurtainNum"], pageLanguage);
                                    } else if (
                                      key === "HandCurtainEn2" ||
                                      key === "HandCurtainFa2"
                                    ) {
                                      objLabel =
                                        t("agree_Qty") +
                                        NumToFa(cartValues["HandCurtainNum2"], pageLanguage);
                                    } else if (tempObj["titleValue"] === null || true) {
                                      if (tempObj["titlePostfix"] === "") {
                                        let rawValue = t(cartValues[key]?.toString());
                                        if (/^[\d,]+$/.test(rawValue)) {
                                          rawValue = rawValue.split(",").join(", ");
                                        }
                                        objLabel =
                                          pageLanguage === "fa"
                                            ? NumberToPersianWord.convertEnToPe(
                                                `${t(cartValues[key].toString())}`
                                              ).toString()
                                            : rawValue;
                                      } else {
                                        objLabel =
                                          pageLanguage === "fa"
                                            ? NumberToPersianWord.convertEnToPe(
                                                `${cartValues[key]}`
                                              ).toString() + t(tempObj["titlePostfix"])
                                            : cartValues[key].toString() +
                                              t(tempObj["titlePostfix"]);
                                      }
                                    } else {
                                      if (
                                        tempObj["titleValue"][cartValues[key].toString()] === null
                                      ) {
                                        if (tempObj["titlePostfix"] === "") {
                                          objLabel = t(cartValues[key].toString());
                                        } else {
                                          objLabel =
                                            pageLanguage === "fa"
                                              ? NumberToPersianWord.convertEnToPe(
                                                  `${cartValues[key]}`
                                                ).toString() + t(tempObj["titlePostfix"])
                                              : cartValues[key].toString() +
                                                t(tempObj["titlePostfix"]);
                                        }
                                      } else {
                                        objLabel = t(
                                          tempObj["titleValue"][cartValues[key].toString()]
                                        );
                                      }
                                    }

                                    if (tempObj["fabric"] === undefined) {
                                      const shouldDisplayTitle = !(
                                        obj1["CalcWindowSize"] === false &&
                                        tempObj["title"] === "Finished Length Type"
                                      );

                                      if (shouldDisplayTitle) {
                                        temp5[
                                          getDkBasketDetailOrder(
                                            SewingModelId,
                                            tempObj,
                                            userProjects
                                          )
                                        ] = (
                                          <li className="cart_agree_item cart_agree_item_new" key={key}>
                                            <h1 className="cart_agree_item_title">
                                              {t(tempObj["title"])}&nbsp;
                                            </h1>
                                            <h2 className="cart_agree_item_desc">{objLabel}</h2>
                                          </li>
                                        );
                                      }
                                      resolve();
                                    } else if (tempObj["fabric"] === 1) {
                                      temp1[tempObj["order"]] = (
                                        <li className="cart_agree_item cart_agree_item_new" key={key}>
                                          <h1 className="cart_agree_item_title">
                                            {t(tempObj["title"])}&nbsp;
                                          </h1>
                                          <h2 className="cart_agree_item_desc">{objLabel}</h2>
                                        </li>
                                      );
                                      resolve();
                                    } else if (tempObj["fabric"] === 2) {
                                      temp2[tempObj["order"]] = (
                                        <li className="cart_agree_item cart_agree_item_new" key={key}>
                                          <h1 className="cart_agree_item_title">
                                            {t(tempObj["title"])}&nbsp;
                                          </h1>
                                          <h2 className="cart_agree_item_desc">{objLabel}</h2>
                                        </li>
                                      );
                                      resolve();
                                    } else if (tempObj["fabric"] === 3) {
                                      temp3[tempObj["order"]] = (
                                        <li className="cart_agree_item cart_agree_item_new" key={key}>
                                          <h1 className="cart_agree_item_title">
                                            {t(tempObj["title"])}&nbsp;
                                          </h1>
                                          <h2 className="cart_agree_item_desc">{objLabel}</h2>
                                        </li>
                                      );
                                      resolve();
                                    } else {
                                      resolve();
                                    }
                                  } else {
                                    resolve();
                                  }
                                }
                              });
                            });
                            Promise.all([...promiseArr3, ...promiseArr4]).then(() => {
                              desc[40] = (
                                <div className="basket_item_title_desc basket_item_title_desc_new 31" key="basket-customize">
                                  {/*<h3>{t("Measurements")}&nbsp;</h3>*/}
                                  <h3 className="basket_measurement_accordion_container">
                                    <Accordion>
                                      <Accordion.Item eventKey="0">
                                        <ContextAwareToggleViewDetails
                                          eventKey="0"
                                          textOnHide={t("View Details")}
                                          textOnShow={t("Hide Details")}
                                          textOnHide2={t("Customize")}
                                          textOnShow2={t("Customize")}
                                          type={2}
                                        />
                                        <Accordion.Body className="basket_item_title_dropdown dk_curtain_preview_dropdown">
                                          <div className="basket_item_title_container 13">
                                            <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_general">
                                              <h1 className="cart_agree_item_fabrics_sorted_title 41">
                                                {t("General Details")}
                                              </h1>
                                              <ul>
                                                {cartValues["PageType"] === "DraperyOnly" ? (
                                                  <>{temp5}</>
                                                ) : (
                                                  <>
                                                    {temp5.filter(
                                                      (item) =>
                                                        item !== null &&
                                                        !item.props?.children?.[1]?.props?.children?.includes?.(
                                                          "Slight Puddle"
                                                        ) &&
                                                        !item.props?.children?.[1]?.props?.children?.includes?.(
                                                          "تا روی زمین"
                                                        )
                                                    )}
                                                  </>
                                                )}
                                              </ul>
                                            </li>
                                            {cartValues["FabricId"] && (
                                              <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_drapery">
                                                <h1 className="cart_agree_item_fabrics_sorted_title 2">
                                                  {t("Drapery")}
                                                </h1>
                                                <ul>
                                                  <li className="cart_agree_item cart_agree_item_new">
                                                    <h1 className="cart_agree_item_title">
                                                      {t("Fabric & Color")}
                                                      &nbsp;
                                                    </h1>
                                                    <h2 className="cart_agree_item_desc">
                                                      {pageLanguage === "fa"
                                                        ? cartValues["FabricDesignFa"] +
                                                          " / " +
                                                          cartValues["FabricColorFa"]
                                                        : CapitalizeAllWords(
                                                            cartValues["FabricDesignEn"] +
                                                              " / " +
                                                              cartValues["FabricColorEn"]
                                                          )}
                                                    </h2>
                                                  </li>
                                                  {cartValues["BorderOrTrimId"] &&
                                                    cartValues["borderPosition"] && (
                                                      <li className="cart_agree_item cart_agree_item_new">
                                                        <h1 className="cart_agree_item_title">
                                                          {t("Decorative Border")}
                                                          &nbsp;
                                                        </h1>
                                                        <h2 className="cart_agree_item_desc">
                                                          {pageLanguage === "fa"
                                                            ? cartValues["BorderOrTrimDesignFa"] +
                                                              " / " +
                                                              cartValues["BorderOrTrimColorFa"] +
                                                              " \n " +
                                                              t(cartValues["borderPosition"])
                                                            : CapitalizeAllWords(
                                                                cartValues["BorderOrTrimDesignEn"] +
                                                                  " / " +
                                                                  cartValues[
                                                                    "BorderOrTrimColorEn"
                                                                  ] +
                                                                  " \n " +
                                                                  t(cartValues["borderPosition"])
                                                              )}
                                                        </h2>
                                                      </li>
                                                    )}
                                                  {cartValues["BorderOrTrimId"] &&
                                                    !cartValues["borderPosition"] && (
                                                      <li className="cart_agree_item cart_agree_item_new">
                                                        <h1 className="cart_agree_item_title">
                                                          {t("Decorative Trim")}
                                                          &nbsp;
                                                        </h1>
                                                        <h2 className="cart_agree_item_desc">
                                                          {pageLanguage === "fa"
                                                            ? cartValues["BorderOrTrimDesignFa"] +
                                                              " / " +
                                                              cartValues["BorderOrTrimColorFa"]
                                                            : CapitalizeAllWords(
                                                                cartValues["BorderOrTrimDesignEn"] +
                                                                  " / " +
                                                                  cartValues["BorderOrTrimColorEn"]
                                                              )}
                                                        </h2>
                                                      </li>
                                                    )}
                                                  {temp1.filter(
                                                    (item) =>
                                                      item !== null &&
                                                      !item.props?.children?.[0]?.props?.children?.some(
                                                        (x) =>
                                                          x?.includes?.("Matching Tieback") ||
                                                          x?.includes?.("کمرپرده پارچه ای")
                                                      )
                                                  )}
                                                </ul>
                                             
                                                {(cartValues["PageType"] ?? "") !== "DraperyOnly" &&
                                                  cartValues["FinishedLengthType"] ===
                                                    "Slight Puddle" && (
                                                    <li className="cart_agree_item cart_agree_item_new">
                                                      <h1 className="cart_agree_item_title">
                                                        {t("dk_step2A")}&nbsp;
                                                      </h1>
                                                      <h2 className="cart_agree_item_desc 6">
                                                        {cartValues["FinishedLengthType"]}
                                                      </h2>
                                                    </li>
                                                  )}
                                                {cartValues["HandCurtainNum"] && (
                                                  <li className="cart_agree_item cart_agree_item_new">
                                                    <h1 className="cart_agree_item_title">
                                                      {t("Matching Tieback")}&nbsp;
                                                    </h1>
                                                    <h2 className="cart_agree_item_desc 6">
                                                      {t("agree_Qty") +
                                                        NumToFa(
                                                          cartValues["HandCurtainNum"],
                                                          pageLanguage
                                                        )}
                                                    </h2>
                                                  </li>
                                                )}
                                              </li>
                                            )}
                                            {cartValues["FabricId2"] && (
                                              <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_sheer">
                                                <h1 className="cart_agree_item_fabrics_sorted_title 90">
                                                  {t("Sheer")}
                                                </h1>
                                                <ul>
                                                  <li className="cart_agree_item cart_agree_item_new">
                                                    <h1 className="cart_agree_item_title">
                                                      {t("Fabric & Color")}
                                                      &nbsp;
                                                    </h1>
                                                    <h2 className="cart_agree_item_desc">
                                                      {pageLanguage === "fa"
                                                        ? cartValues["FabricDesignFa2"] +
                                                          " / " +
                                                          cartValues["FabricColorFa2"]
                                                        : CapitalizeAllWords(
                                                            cartValues["FabricDesignEn2"] +
                                                              " / " +
                                                              cartValues["FabricColorEn2"]
                                                          )}
                                                    </h2>
                                                  </li>
                                                  {cartValues["BorderOrTrimId2"] &&
                                                    cartValues["borderPosition2"] && (
                                                      <li className="cart_agree_item cart_agree_item_new">
                                                        <h1 className="cart_agree_item_title">
                                                          {t("Decorative Border")}
                                                          &nbsp;
                                                        </h1>
                                                        <h2 className="cart_agree_item_desc">
                                                          {pageLanguage === "fa"
                                                            ? cartValues["BorderOrTrimDesignFa2"] +
                                                              " / " +
                                                              cartValues["BorderOrTrimColorFa2"] +
                                                              " \n " +
                                                              t(cartValues["borderPosition2"])
                                                            : CapitalizeAllWords(
                                                                cartValues[
                                                                  "BorderOrTrimDesignEn2"
                                                                ] +
                                                                  " / " +
                                                                  cartValues[
                                                                    "BorderOrTrimColorEn2"
                                                                  ] +
                                                                  " \n " +
                                                                  t(cartValues["borderPosition2"])
                                                              )}
                                                        </h2>
                                                      </li>
                                                    )}
                                                  {cartValues["BorderOrTrimId2"] &&
                                                    !cartValues["borderPosition2"] && (
                                                      <li className="cart_agree_item cart_agree_item_new">
                                                        <h1 className="cart_agree_item_title">
                                                          {t("Decorative Trim")}
                                                          &nbsp;
                                                        </h1>
                                                        <h2 className="cart_agree_item_desc">
                                                          {pageLanguage === "fa"
                                                            ? cartValues["BorderOrTrimDesignFa2"] +
                                                              " / " +
                                                              cartValues["BorderOrTrimColorFa2"]
                                                            : CapitalizeAllWords(
                                                                cartValues[
                                                                  "BorderOrTrimDesignEn2"
                                                                ] +
                                                                  " / " +
                                                                  cartValues["BorderOrTrimColorEn2"]
                                                              )}
                                                        </h2>
                                                      </li>
                                                    )}

                                                  {temp2.filter(
                                                    (item) =>
                                                      item !== null &&
                                                      !item.props?.children?.[0]?.props?.children?.some(
                                                        (x) =>
                                                          x?.includes?.("Matching Tieback") ||
                                                          x?.includes?.("کمرپرده پارچه ای")
                                                      )
                                                  )}
                                                </ul>
                                                {cartValues["FinishedLengthType"] &&
                                                  cartValues["FinishedLengthType"] ===
                                                    "Slight Puddle" && (
                                                    <li className="cart_agree_item cart_agree_item_new">
                                                      <h1 className="cart_agree_item_title">
                                                        {t("dk_step2A")}&nbsp;
                                                      </h1>
                                                      <h2 className="cart_agree_item_desc 6">
                                                        {cartValues["PageType"] === "SheersOnly"
                                                          ? cartValues["FinishedLengthType"]
                                                          : t("Floor")}
                                                      </h2>
                                                    </li>
                                                  )}
                                                {cartValues["HandCurtainNum2"] && (
                                                  <li className="cart_agree_item cart_agree_item_new">
                                                    <h1 className="cart_agree_item_title">
                                                      {t("Matching Tieback")}&nbsp;
                                                    </h1>
                                                    <h2 className="cart_agree_item_desc 6">
                                                      {t("agree_Qty") +
                                                        NumToFa(
                                                          cartValues["HandCurtainNum2"],
                                                          pageLanguage
                                                        )}
                                                    </h2>
                                                  </li>
                                                )}
                                              </li>
                                            )}
                                            {cartValues["PrivacyLayer"] &&
                                              cartValues["PrivacyLayer"] !== "none" &&
                                              cartValues["SheersDesignEn"] &&
                                              cartValues["SheersColorEn"] && (
                                                <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_pl">
                                                  <h1 className="cart_agree_item_fabrics_sorted_title 99">
                                                    {t("Privacy Layer")}
                                                  </h1>
                                                  <ul>
                                                    <li className="cart_agree_item cart_agree_item_new">
                                                      <h1 className="cart_agree_item_title">
                                                        {t("Fabric & Color")}
                                                        &nbsp;
                                                      </h1>
                                                      <h2 className="cart_agree_item_desc">
                                                        {pageLanguage === "fa"
                                                          ? cartValues["SheersDesignFa"] +
                                                            " / " +
                                                            cartValues["SheersColorFa"]
                                                          : CapitalizeAllWords(
                                                              cartValues["SheersDesignEn"] +
                                                                " / " +
                                                                cartValues["SheersColorEn"]
                                                            )}
                                                      </h2>
                                                    </li>
                                                    {temp3}
                                                    {cartValues["FinishedLengthType"] &&
                                                      cartValues["FinishedLengthType"] ===
                                                        "Slight Puddle" && (
                                                        <li className="cart_agree_item cart_agree_item_new">
                                                          <h1 className="cart_agree_item_title">
                                                            {t("dk_step2A")}&nbsp;
                                                          </h1>
                                                          <h2 className="cart_agree_item_desc 6">
                                                            {t("Floor")}
                                                          </h2>
                                                        </li>
                                                      )}
                                                  </ul>
                                                </li>
                                              )}
                                            {!!temp4.length && (
                                              <li className="cart_agree_item cart_agree_item_new cart_agree_item_fabrics_sorted cart_agree_item_acc">
                                                <h1 className="cart_agree_item_fabrics_sorted_title 3">
                                                  {t("Accessories")}
                                                </h1>
                                                <ul>{temp4}</ul>
                                              </li>
                                            )}
                                      
                                            <li className="cart_agree_item cart_agree_item_new cart_agree_item_fabrics_sorted cart_agree_item_label"
                                             style={{padding: "0.9rem 0"}}
                                            >
                                              <h1 className="cart_agree_item_title 2">
                                                {pageLanguage === "fa" ? "نام اتاق" : "Room Label"}
                                                &nbsp;
                                              </h1>
                                              <h2 className="cart_agree_item_desc">
                                                {pageLanguage === "fa"
                                                  ? roomNameFa +
                                                    (WindowDescription === "" ? "" : " / " + WindowDescription)
                                                  : roomName +
                                                    (WindowDescription === "" ? "" : " / " + WindowDescription)}
                                              </h2>
                                            </li>
                                            {moreInfoInput !== "" && (
                                              <li className="basket_item_title_desc basket_item_title_desc_new 32" style={{marginTop: "0.8rem"}}>
                                                <h1 className="cart_agree_item_title">
                                                  {t("Order Notes")}&nbsp;
                                                </h1>
                                                <ShowMoreLineLimited
                                                  moreInfoInput={moreInfoInput}
                                                  lines={3}
                                                />
                                              </li>
                                            )}
                                          </div>
                                        </Accordion.Body>
                                      </Accordion.Item>
                                    </Accordion>
                                  </h3>
                                </div>
                              );
                              resolve();
                            });
                          })
                          .catch((err) => {
                            console.log(err);
                            resolve();
                          });
                      });
                    } else if (SewingModelId === "0321") {
                      promiseArr0[0] = new Promise((resolve, reject) => {
                        GetUserProjectData(obj1, false)
                          .then((cartValues) => {
                            if (cartValues["Hardware"] === "Same Hardware For All Curtains") {
                              cartValues["MotorChannelsA"] = cartValues["MotorChannelsB"];
                              cartValues["MotorPositionA"] = cartValues["MotorPositionB"];
                            }

                            let promiseArr4 = [];
                            if (cartValues["Accessories"] !== undefined) {
                              cartValues["Accessories"].forEach((obj, index) => {
                                if (
                                  obj["DesignNameFa"] !== undefined &&
                                  obj["DesignNameEn"] !== undefined
                                ) {
                                  promiseArr4[index] = new Promise((resolve, reject) => {
                                    if (obj["DesignNameFa"] && obj["DesignNameEn"]) {
                                      temp4[index] = (
                                        <li className="cart_agree_item cart_agree_item_new" key={"acc" + index}>
                                          <h1 className="cart_agree_item_title">
                                            {pageLanguage === "fa"
                                              ? obj["DesignNameFa"]
                                              : obj["DesignNameEn"]}
                                            {" / "}
                                            {obj["ColorNameEn"] && (
                                              <>
                                                {pageLanguage === "fa"
                                                  ? obj["ColorNameFa"]
                                                  : obj["ColorNameEn"]}
                                              </>
                                            )}
                                          </h1>
                                          <h2 className="cart_agree_item_desc">
                                            {t("agree_Qty")}
                                            {NumToFa(obj["Qty"], pageLanguage)}
                                          </h2>
                                        </li>
                                      );
                                    }
                                    resolve();
                                  });
                                }
                              });
                            }

                            let promiseArr3 = [];
                            Object.keys(cartValues).forEach((key, index) => {
                              promiseArr3[index] = new Promise((resolve, reject) => {
                                console.log(`key`, key);
                                let tempObj = userProjects.find((obj) => obj["cart"] === key);
                                if (tempObj === undefined || cartValues[key] === undefined) {
                                  resolve();
                                } else if (key === "IsWalled") {
                                  resolve();
                                } else {
                                  if (key === "WindowWidth" && tempObj["measurements"]) {
                                    if (firstMeasurements) {
                                      firstMeasurements = false;
                                      if (obj["CalcWindowSize"]) {
                                        desc[tempObj["order"]] = (
                                          <div className="basket_item_title_desc basket_item_title_desc_new 33" key="basket-measurements">
                                            {/*<h3>{t("Measurements")}&nbsp;</h3>*/}
                                            <h3 className="basket_measurement_accordion_container">
                                              <Accordion>
                                                <Accordion.Item eventKey="0">
                                                  <ContextAwareToggleViewDetails
                                                    eventKey="0"
                                                    textOnHide={
                                                      <>
                                                        {NumToFa(
                                                          obj["WindowWidth"] + t("Measurements CM"),
                                                          pageLanguage
                                                        )}
                                                        <span dir="ltr"> x </span>
                                                        {NumToFa(
                                                          obj["WindowHeight"] +
                                                            t("Measurements CM"),
                                                          pageLanguage
                                                        )}
                                                      </>
                                                    }
                                                    textOnShow={t("Hide Details")}
                                                    textOnHide2={t("Measurements")}
                                                    textOnShow2={t("Measurements")}
                                                    type={2}
                                                  />
                                                  <Accordion.Body className="basket_item_title_dropdown dk_curtain_preview_dropdown">
                                                    <div className="basket_item_title_container 14">
                                                      <GetMeasurementArray
                                                        modelId={`${SewingModelId}`}
                                                        cartValues={cartValues}
                                                      />
                                                    </div>
                                                  </Accordion.Body>
                                                </Accordion.Item>
                                              </Accordion>
                                            </h3>
                                          </div>
                                        );
                                      } else {
                                        // تعریف لایه‌ها
                                        const fabricLayers = [
                                          {
                                            key: "drapery",
                                            title: t("Drapery"),
                                            designEn: obj?.FabricDesignEn,
                                            colorEn: obj?.FabricColorEn,
                                            designFa: obj?.FabricDesignFa,
                                            colorFa: obj?.FabricColorFa,
                                          },
                                          {
                                            key: "sheer",
                                            title: t("Sheer"),
                                            designEn: obj?.FabricDesignEn2,
                                            colorEn: obj?.FabricColorEn2,
                                            designFa: obj?.FabricDesignFa2,
                                            colorFa: obj?.FabricColorFa2,
                                          },
                                          {
                                            key: "privacy",
                                            title: t("Privacy Layer"),
                                            designEn: obj?.SheersDesignEn,
                                            colorEn: obj?.SheersColorEn,
                                            designFa: obj?.SheersDesignFa,
                                            colorFa: obj?.SheersColorFa,
                                          },
                                        ];

                                        // فقط لایه‌هایی که مقدار دارند
                                        const validLayers = fabricLayers.filter((layer) =>
                                          pageLanguage === "en" ? layer.designEn : layer.designFa
                                        );

                                        const layersCount = validLayers.length;

                                        desc[tempObj["order"]] = (
                                          <>
                                            {/* ================= Fabric / Color ================= */}
                                            {layersCount > 0 && (
                                              <div className="basket_item_title_desc basket_item_title_desc_new 135">
                                                <h3>
                                                  {pageLanguage === "fa"
                                                    ? "پارچه/رنگ"
                                                    : "Fabric/Color"}
                                                  &nbsp;
                                                </h3>

                                                <h4>
                                                  {/* فقط یک لایه → متن ساده */}
                                                  {layersCount === 1 && (
                                                    <>
                                                      {pageLanguage === "en"
                                                        ? `${validLayers[0].designEn} / ${t(
                                                            validLayers[0].colorEn
                                                          )}`
                                                        : `${validLayers[0].designFa} / ${t(
                                                            validLayers[0].colorFa
                                                          )}`}
                                                    </>
                                                  )}

                                                  {/* دو یا بیشتر → آکاردیون */}
                                                  {layersCount >= 2 && (
                                                    <div className="dk_curtain_preview_container 5">
                                                      <Accordion>
                                                        <Accordion.Item eventKey="0">
                                                          <ContextAwareToggleViewDetails
                                                            eventKey="0"
                                                            textOnHide={t("View Details")}
                                                            textOnShow={t("Hide Details")}
                                                          />

                                                          <Accordion.Body className="basket_item_title_dropdown dk_curtain_preview_dropdown">
                                                            <div className="dk_curtain_preview_detail_container">
                                                              {validLayers.map((layer) => (
                                                                <div
                                                                  key={layer.key}
                                                                  className="dk_curtain_preview_detail"
                                                                >
                                                                  <h2 className="sheer_h2 1">
                                                                    {layer.title}:
                                                                  </h2>

                                                                  <h3 style={{ padding: "0 1rem" }}>
                                                                    {pageLanguage === "en"
                                                                      ? `${layer.designEn} / ${t(
                                                                          layer.colorEn
                                                                        )}`
                                                                      : `${layer.designFa} / ${t(
                                                                          layer.colorFa
                                                                        )}`}
                                                                  </h3>
                                                                </div>
                                                              ))}
                                                            </div>
                                                          </Accordion.Body>
                                                        </Accordion.Item>
                                                      </Accordion>
                                                    </div>
                                                  )}
                                                </h4>
                                              </div>
                                            )}

                                            {/* ================= Measurements ================= */}
                                            <div className="basket_item_title_desc basket_item_title_desc_new 34" key="basket-measurements">
                                              <h3>{t("Measurements")}&nbsp;</h3>
                                              <h4>
                                                {NumToFa(
                                                  obj["WindowWidth"] + t("Measurements CM"),
                                                  pageLanguage
                                                )}
                                                <span dir="ltr"> x </span>
                                                {NumToFa(
                                                  obj["WindowHeight"] + t("Measurements CM"),
                                                  pageLanguage
                                                )}
                                              </h4>
                                            </div>
                                          </>
                                        );
                                        resolve();
                                      }
                                      resolve();
                                    } else {
                                      resolve();
                                    }
                                  } else if (key === "WindowHeight" && tempObj["measurements"]) {
                                    resolve();
                                  } else if (
                                    (key === "PanelTypeOption" &&
                                      cartValues["PanelTypeOption"] ===
                                        "Customize Style Per Curtain") ||
                                    (key === "Hardware" &&
                                      cartValues["Hardware"] ===
                                        "I Want To Customize Hardware Per Curtain")
                                  ) {
                                    resolve();
                                  } else if (
                                    tempObj["title"] !== "" &&
                                    tempObj["lang"].indexOf(pageLanguage) > -1
                                  ) {
                                    let objLabel = "";
                                    if (key === "Mount" && cartValues["Mount"] === "Outside") {
                                      const isWalledRaw = normalizeOutsideMountSubType(
                                        cartValues["IsWalled"],
                                        cartValues["installationLocation"]
                                      );
                                      const combinedLabel = formatCombinedOutsideMountLabel(
                                        isWalledRaw,
                                        pageLanguage,
                                        t
                                      );
                                      objLabel = combinedLabel
                                        ? pageLanguage === "fa"
                                          ? NumberToPersianWord.convertEnToPe(
                                              combinedLabel
                                            ).toString()
                                          : combinedLabel
                                        : pageLanguage === "fa"
                                        ? NumberToPersianWord.convertEnToPe(t("Outside")).toString()
                                        : t("Outside Mount");
                                    } else if (
                                      key === "ControlType" &&
                                      cartValues["ControlType"] === "Motorized"
                                    ) {
                                      objLabel =
                                        pageLanguage === "fa"
                                          ? NumberToPersianWord.convertEnToPe(
                                              `${t(cartValues[key].toString())} / ${t(
                                                cartValues["MotorType"].toString()
                                              )}`
                                            ).toString()
                                          : `${t(cartValues[key].toString())} / ${t(
                                              cartValues["MotorType"].toString()
                                            )}`;
                                    } else if (
                                      key === "DraperyHardware" &&
                                      cartValues["DraperyHardware"] !== "None"
                                    ) {
                                      const RailColorFaA = cartValues["RailColorFaA"];
                                      const RailColorEnA = cartValues["RailColorEnA"];

                                      let batonValueStepA = "";

                                      if (cartValues["BatonOptionA"]) {
                                        if (cartValues["BatonOptionA"] !== "None") {
                                          batonValueStepA = " / " + t(cartValues["BatonOptionA"]);
                                        }
                                      } else {
                                        const controlPosition =
                                          cartValues["ControlPositionB"] ||
                                          cartValues["ControlPositionA"];
                                        if (controlPosition) {
                                          batonValueStepA = " / " + t(controlPosition);
                                        }
                                      }

                                      objLabel =
                                        (pageLanguage === "fa"
                                          ? cartValues["RailDesignFaA"]
                                          : cartValues["RailDesignEnA"]) +
                                        " \n " +
                                        (pageLanguage === "fa"
                                          ? RailColorFaA !== undefined
                                            ? RailColorFaA
                                            : ""
                                          : RailColorEnA !== undefined
                                          ? RailColorEnA
                                          : "") +
                                        batonValueStepA;
                                    } else if (
                                      key === "SheerHardware" &&
                                      cartValues["SheerHardware"] !== "None"
                                    ) {
                                      objLabel = buildCartHardwareLabel({
                                        hardwareValue: cartValues[key],
                                        railDesignFa: cartValues["RailDesignFaB"],
                                        railDesignEn: cartValues["RailDesignEnB"],
                                        railColorFa: cartValues["RailColorFaB"],
                                        railColorEn: cartValues["RailColorEnB"],
                                        batonOption: cartValues["BatonOptionB"],
                                        controlPosition: cartValues["ControlPositionB"],
                                        pageLanguage,
                                        t,
                                      });
                                    } else if (
                                      key === "PrivacyLayerHardware" &&
                                      cartValues["PrivacyLayerHardware"] !== "None"
                                    ) {
                                      objLabel = buildCartHardwareLabel({
                                        hardwareValue: cartValues[key],
                                        railDesignFa: cartValues["RailDesignFaC"],
                                        railDesignEn: cartValues["RailDesignEnC"],
                                        railColorFa: cartValues["RailColorFaC"],
                                        railColorEn: cartValues["RailColorEnC"],
                                        batonOption: cartValues["BatonOptionC"],
                                        controlPosition: cartValues["ControlPositionC"],
                                        pageLanguage,
                                        t,
                                      });
                                    } else if (key === "HandCurtainEn" || key === "HandCurtainFa") {
                                      objLabel =
                                        t("agree_Qty") +
                                        NumToFa(cartValues["HandCurtainNum"], pageLanguage);
                                    } else if (
                                      key === "HandCurtainEn2" ||
                                      key === "HandCurtainFa2"
                                    ) {
                                      objLabel =
                                        t("agree_Qty") +
                                        NumToFa(cartValues["HandCurtainNum2"], pageLanguage);
                                    } else if (tempObj["titleValue"] === null || true) {
                                      if (tempObj["titlePostfix"] === "") {
                                        let rawValue = t(cartValues[key]?.toString());
                                        if (/^[\d,]+$/.test(rawValue)) {
                                          rawValue = rawValue.split(",").join(", ");
                                        }
                                        objLabel =
                                          pageLanguage === "fa"
                                            ? NumberToPersianWord.convertEnToPe(
                                                `${t(cartValues[key].toString())}`
                                              ).toString()
                                            : rawValue;
                                      } else {
                                        objLabel =
                                          pageLanguage === "fa"
                                            ? NumberToPersianWord.convertEnToPe(
                                                `${cartValues[key]}`
                                              ).toString() + t(tempObj["titlePostfix"])
                                            : cartValues[key].toString() +
                                              t(tempObj["titlePostfix"]);
                                      }
                                    } else {
                                      if (
                                        tempObj["titleValue"][cartValues[key].toString()] === null
                                      ) {
                                        if (tempObj["titlePostfix"] === "") {
                                          objLabel = t(cartValues[key].toString());
                                        } else {
                                          objLabel =
                                            pageLanguage === "fa"
                                              ? NumberToPersianWord.convertEnToPe(
                                                  `${cartValues[key]}`
                                                ).toString() + t(tempObj["titlePostfix"])
                                              : cartValues[key].toString() +
                                                t(tempObj["titlePostfix"]);
                                        }
                                      } else {
                                        objLabel = t(
                                          tempObj["titleValue"][cartValues[key].toString()]
                                        );
                                      }
                                    }
                                    if (tempObj["fabric"] === undefined) {
                                      const shouldDisplayTitle = !(
                                        obj1["CalcWindowSize"] === false &&
                                        tempObj["title"] === "Finished Length Type"
                                      );

                                      if (shouldDisplayTitle) {
                                        temp5[
                                          getDkBasketDetailOrder(
                                            SewingModelId,
                                            tempObj,
                                            userProjects
                                          )
                                        ] = (
                                          <li className="cart_agree_item cart_agree_item_new" key={key}>
                                            <h1 className="cart_agree_item_title">
                                              {t(tempObj["title"])}&nbsp;
                                            </h1>
                                            <h2 className="cart_agree_item_desc">{objLabel}</h2>
                                          </li>
                                        );
                                      }
                                      resolve();
                                    } else if (tempObj["fabric"] === 1) {
                                      temp1[tempObj["order"]] = (
                                        <li className="cart_agree_item cart_agree_item_new" key={key}>
                                          <h1 className="cart_agree_item_title">
                                            {t(tempObj["title"])}&nbsp;
                                          </h1>
                                          <h2 className="cart_agree_item_desc">{objLabel}</h2>
                                        </li>
                                      );
                                      resolve();
                                    } else if (tempObj["fabric"] === 2) {
                                      temp2[tempObj["order"]] = (
                                        <li className="cart_agree_item cart_agree_item_new" key={key}>
                                          <h1 className="cart_agree_item_title">
                                            {t(tempObj["title"])}&nbsp;
                                          </h1>
                                          <h2 className="cart_agree_item_desc">{objLabel}</h2>
                                        </li>
                                      );
                                      resolve();
                                    } else if (tempObj["fabric"] === 3) {
                                      temp3[tempObj["order"]] = (
                                        <li className="cart_agree_item cart_agree_item_new" key={key}>
                                          <h1 className="cart_agree_item_title">
                                            {t(tempObj["title"])}&nbsp;
                                          </h1>
                                          <h2 className="cart_agree_item_desc">{objLabel}</h2>
                                        </li>
                                      );
                                      resolve();
                                    } else {
                                      resolve();
                                    }
                                  } else {
                                    resolve();
                                  }
                                }
                              });
                            });
                            Promise.all([...promiseArr3, ...promiseArr4]).then(() => {
                              desc[40] = (
                                <div className="basket_item_title_desc basket_item_title_desc_new 35" key="basket-customize">
                                  {/*<h3>{t("Measurements")}&nbsp;</h3>*/}
                                  <h3 className="basket_measurement_accordion_container">
                                    <Accordion>
                                      <Accordion.Item eventKey="0">
                                        <ContextAwareToggleViewDetails
                                          eventKey="0"
                                          textOnHide={t("View Details")}
                                          textOnShow={t("Hide Details")}
                                          textOnHide2={t("Customize")}
                                          textOnShow2={t("Customize")}
                                          type={2}
                                        />
                                        <Accordion.Body className="basket_item_title_dropdown dk_curtain_preview_dropdown">
                                          <div className="basket_item_title_container 15">
                                            <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_general">
                                              <h1 className="cart_agree_item_fabrics_sorted_title 5">
                                                {t("General Details")}
                                              </h1>
                                              <ul>
                                                {cartValues["WindowName"] === "Draperyonly" ? (
                                                  <>{temp5}</>
                                                ) : (
                                                  <>
                                                    {temp5.filter(
                                                      (item) =>
                                                        item !== null &&
                                                        !item.props?.children?.[1]?.props?.children?.includes?.(
                                                          "Slight Puddle"
                                                        ) &&
                                                        !item.props?.children?.[1]?.props?.children?.includes?.(
                                                          "تا روی زمین"
                                                        )
                                                    )}
                                                  </>
                                                )}
                                              </ul>
                                            </li>
                                            {cartValues["FabricId"] && (
                                              <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_drapery">
                                                <h1 className="cart_agree_item_fabrics_sorted_title 3">
                                                  {t("Drapery")}
                                                </h1>
                                                <ul>
                                                  <li className="cart_agree_item cart_agree_item_new">
                                                    <h1 className="cart_agree_item_title">
                                                      {t("Fabric & Color")}
                                                      &nbsp;
                                                    </h1>
                                                    <h2 className="cart_agree_item_desc">
                                                      {pageLanguage === "fa"
                                                        ? cartValues["FabricDesignFa"] +
                                                          " / " +
                                                          cartValues["FabricColorFa"]
                                                        : CapitalizeAllWords(
                                                            cartValues["FabricDesignEn"] +
                                                              " / " +
                                                              cartValues["FabricColorEn"]
                                                          )}
                                                    </h2>
                                                  </li>
                                                  {cartValues["BorderOrTrimId"] &&
                                                    cartValues["borderPosition"] && (
                                                      <li className="cart_agree_item cart_agree_item_new">
                                                        <h1 className="cart_agree_item_title">
                                                          {t("Decorative Border")}
                                                          &nbsp;
                                                        </h1>
                                                        <h2 className="cart_agree_item_desc">
                                                          {pageLanguage === "fa"
                                                            ? cartValues["BorderOrTrimDesignFa"] +
                                                              " / " +
                                                              cartValues["BorderOrTrimColorFa"] +
                                                              " \n " +
                                                              t(cartValues["borderPosition"])
                                                            : CapitalizeAllWords(
                                                                cartValues["BorderOrTrimDesignEn"] +
                                                                  " / " +
                                                                  cartValues[
                                                                    "BorderOrTrimColorEn"
                                                                  ] +
                                                                  " \n " +
                                                                  t(cartValues["borderPosition"])
                                                              )}
                                                        </h2>
                                                      </li>
                                                    )}
                                                  {cartValues["BorderOrTrimId"] &&
                                                    !cartValues["borderPosition"] && (
                                                      <li className="cart_agree_item cart_agree_item_new">
                                                        <h1 className="cart_agree_item_title">
                                                          {t("Decorative Trim")}
                                                          &nbsp;
                                                        </h1>
                                                        <h2 className="cart_agree_item_desc">
                                                          {pageLanguage === "fa"
                                                            ? cartValues["BorderOrTrimDesignFa"] +
                                                              " / " +
                                                              cartValues["BorderOrTrimColorFa"]
                                                            : CapitalizeAllWords(
                                                                cartValues["BorderOrTrimDesignEn"] +
                                                                  " / " +
                                                                  cartValues["BorderOrTrimColorEn"]
                                                              )}
                                                        </h2>
                                                      </li>
                                                    )}
                                                  <ul>
                                                    {temp1.filter(
                                                      (item) =>
                                                        item !== null &&
                                                        !item.props?.children?.[0]?.props?.children?.some(
                                                          (x) =>
                                                            x?.includes?.("Matching Tieback") ||
                                                            x?.includes?.("کمرپرده پارچه ای")
                                                        )
                                                    )}
                                                  </ul>
                                                  {cartValues["RailDesignEnA"] ===
                                                    "Motorized Track" &&
                                                    cartValues["Hardware"] !==
                                                      "I Have My Own Hardware" && (
                                                      <>
                                                        {cartValues["RemoteNameA"] &&
                                                          cartValues["RemoteNameA"] !== "" && (
                                                            <>
                                                              {cartValues["MotorPositionA"]
                                                                ?.length > 0 && (
                                                                <li className="cart_agree_item cart_agree_item_new">
                                                                  <h1 className="cart_agree_item_title">
                                                                    {t("Motor Position")}&nbsp;
                                                                  </h1>
                                                                  <h2 className="cart_agree_item_desc 6">
                                                                    {cartValues[
                                                                      "MotorPositionA"
                                                                    ][0]?.["label"]
                                                                      ? t(
                                                                          cartValues[
                                                                            "MotorPositionA"
                                                                          ][0]?.["label"]
                                                                        )
                                                                      : t(
                                                                          cartValues[
                                                                            "MotorPositionA"
                                                                          ]
                                                                        )}
                                                                  </h2>
                                                                </li>
                                                              )}
                                                              <li className="cart_agree_item cart_agree_item_new">
                                                                <h1 className="cart_agree_item_title">
                                                                  {t("Remote Name")}&nbsp;
                                                                </h1>
                                                                <h2 className="cart_agree_item_desc 6">
                                                                  {cartValues["RemoteNameA"]}
                                                                </h2>
                                                              </li>
                                                              <li className="cart_agree_item cart_agree_item_new">
                                                                <h1 className="cart_agree_item_title">
                                                                  {t("Motor Channels")}&nbsp;
                                                                </h1>
                                                                <h2 className="cart_agree_item_desc 6">
                                                                  {cartValues[
                                                                    "MotorChannelsA"
                                                                  ]?.join(", ")}
                                                                </h2>
                                                              </li>
                                                            </>
                                                          )}
                                                      </>
                                                    )}
                                                  {(cartValues["WindowName"] ?? "") !==
                                                    "Draperyonly" &&
                                                    cartValues["FinishedLengthType"] ===
                                                      "Slight Puddle" && (
                                                      <li className="cart_agree_item cart_agree_item_new">
                                                        <h1 className="cart_agree_item_title">
                                                          {t("dk_step2A")}&nbsp;
                                                        </h1>
                                                        <h2 className="cart_agree_item_desc 6">
                                                          {cartValues["FinishedLengthType"]}
                                                        </h2>
                                                      </li>
                                                    )}
                                                  {cartValues["HandCurtainNum"] && (
                                                    <li className="cart_agree_item cart_agree_item_new">
                                                      <h1 className="cart_agree_item_title">
                                                        {t("Matching Tieback")}&nbsp;
                                                      </h1>
                                                      <h2 className="cart_agree_item_desc 6">
                                                        {t("agree_Qty") +
                                                          NumToFa(
                                                            cartValues["HandCurtainNum"],
                                                            pageLanguage
                                                          )}
                                                      </h2>
                                                    </li>
                                                  )}
                                                </ul>
                                              </li>
                                            )}
                                            {cartValues["FabricId2"] && (
                                              <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_sheer">
                                                <h1 className="cart_agree_item_fabrics_sorted_title 2">
                                                  {t("Sheer")}
                                                </h1>
                                                <ul>
                                                  <li className="cart_agree_item cart_agree_item_new">
                                                    <h1 className="cart_agree_item_title">
                                                      {t("Fabric & Color")}
                                                      &nbsp;
                                                    </h1>
                                                    <h2 className="cart_agree_item_desc">
                                                      {pageLanguage === "fa"
                                                        ? cartValues["FabricDesignFa2"] +
                                                          " / " +
                                                          cartValues["FabricColorFa2"]
                                                        : CapitalizeAllWords(
                                                            cartValues["FabricDesignEn2"] +
                                                              " / " +
                                                              cartValues["FabricColorEn2"]
                                                          )}
                                                    </h2>
                                                  </li>
                                                  {cartValues["BorderOrTrimId2"] &&
                                                    cartValues["borderPosition2"] && (
                                                      <li className="cart_agree_item cart_agree_item_new">
                                                        <h1 className="cart_agree_item_title">
                                                          {t("Decorative Border")}
                                                          &nbsp;
                                                        </h1>
                                                        <h2 className="cart_agree_item_desc">
                                                          {pageLanguage === "fa"
                                                            ? cartValues["BorderOrTrimDesignFa2"] +
                                                              " / " +
                                                              cartValues["BorderOrTrimColorFa2"] +
                                                              " \n " +
                                                              t(cartValues["borderPosition2"])
                                                            : CapitalizeAllWords(
                                                                cartValues[
                                                                  "BorderOrTrimDesignEn2"
                                                                ] +
                                                                  " / " +
                                                                  cartValues[
                                                                    "BorderOrTrimColorEn2"
                                                                  ] +
                                                                  " \n " +
                                                                  t(cartValues["borderPosition2"])
                                                              )}
                                                        </h2>
                                                      </li>
                                                    )}
                                                  {cartValues["BorderOrTrimId2"] &&
                                                    !cartValues["borderPosition2"] && (
                                                      <li className="cart_agree_item cart_agree_item_new">
                                                        <h1 className="cart_agree_item_title">
                                                          {t("Decorative Trim")}
                                                          &nbsp;
                                                        </h1>
                                                        <h2 className="cart_agree_item_desc">
                                                          {pageLanguage === "fa"
                                                            ? cartValues["BorderOrTrimDesignFa2"] +
                                                              " / " +
                                                              cartValues["BorderOrTrimColorFa2"]
                                                            : CapitalizeAllWords(
                                                                cartValues[
                                                                  "BorderOrTrimDesignEn2"
                                                                ] +
                                                                  " / " +
                                                                  cartValues["BorderOrTrimColorEn2"]
                                                              )}
                                                        </h2>
                                                      </li>
                                                    )}

                                                  <ul>
                                                    {cartValues["SheerHardware"] !== "None"
                                                      ? temp2.filter(
                                                          (item) =>
                                                            item !== null &&
                                                            !item.props?.children?.[0]?.props?.children?.some(
                                                              (x) =>
                                                                x?.includes?.("Matching Tieback") ||
                                                                x?.includes?.("کمرپرده پارچه ای")
                                                            )
                                                        )
                                                      : temp2.filter(
                                                          (item) =>
                                                            item !== null &&
                                                            !item.props?.children?.[0]?.props?.children?.some(
                                                              (x) =>
                                                                x?.includes?.("Matching Tieback") ||
                                                                x?.includes?.("کمرپرده پارچه ای") ||
                                                                x?.includes?.("Motor Position") ||
                                                                x?.includes?.("Motor Channels")
                                                            )
                                                        )}
                                                  </ul>
                                                  {cartValues["FinishedLengthType"] &&
                                                    cartValues["FinishedLengthType"] ===
                                                      "Slight Puddle" && (
                                                      <li className="cart_agree_item cart_agree_item_new">
                                                        <h1 className="cart_agree_item_title">
                                                          {t("dk_step2A")}&nbsp;
                                                        </h1>
                                                        <h2 className="cart_agree_item_desc 6">
                                                          {cartValues["PageType"] === "SheersOnly"
                                                            ? cartValues["FinishedLengthType"]
                                                            : t("Floor")}
                                                        </h2>
                                                      </li>
                                                    )}
                                                  {cartValues["HandCurtainNum2"] && (
                                                    <li className="cart_agree_item cart_agree_item_new">
                                                      <h1 className="cart_agree_item_title">
                                                        {t("Matching Tieback")}&nbsp;
                                                      </h1>
                                                      <h2 className="cart_agree_item_desc 6">
                                                        {t("agree_Qty") +
                                                          NumToFa(
                                                            cartValues["HandCurtainNum2"],
                                                            pageLanguage
                                                          )}
                                                      </h2>
                                                    </li>
                                                  )}
                                                </ul>
                                              </li>
                                            )}
                                            {cartValues["PrivacyLayer"] &&
                                              cartValues["PrivacyLayer"] !== "none" &&
                                              cartValues["SheersDesignEn"] &&
                                              cartValues["SheersColorEn"] && (
                                                <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_pl">
                                                  <h1 className="cart_agree_item_fabrics_sorted_title 98">
                                                    {t("Privacy Layer")}
                                                  </h1>
                                                  <ul>
                                                    <li className="cart_agree_item cart_agree_item_new">
                                                      <h1 className="cart_agree_item_title">
                                                        {t("Fabric & Color")}
                                                        &nbsp;
                                                      </h1>
                                                      <h2 className="cart_agree_item_desc">
                                                        {pageLanguage === "fa"
                                                          ? cartValues["SheersDesignFa"] +
                                                            " / " +
                                                            cartValues["SheersColorFa"]
                                                          : CapitalizeAllWords(
                                                              cartValues["SheersDesignEn"] +
                                                                " / " +
                                                                cartValues["SheersColorEn"]
                                                            )}
                                                      </h2>
                                                    </li>
                                                    {temp3}
                                                    {cartValues["FinishedLengthType"] &&
                                                      cartValues["FinishedLengthType"] ===
                                                        "Slight Puddle" && (
                                                        <li className="cart_agree_item">
                                                          <h1 className="cart_agree_item_title">
                                                            {t("dk_step2A")}&nbsp;
                                                          </h1>
                                                          <h2 className="cart_agree_item_desc 6">
                                                            {t("Floor")}
                                                          </h2>
                                                        </li>
                                                      )}
                                                  </ul>
                                                </li>
                                              )}
                                            {!!temp4.length && (
                                              <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_acc">
                                                <h1 className="cart_agree_item_fabrics_sorted_title 4">
                                                  {t("Accessories")}
                                                </h1>
                                                <ul>{temp4}</ul>
                                              </li>
                                            )}
                                            <li className="cart_agree_item cart_agree_item_new cart_agree_item_fabrics_sorted cart_agree_item_label"
                                             style={{padding: "0.9rem 0"}}
                                            >
                                              <h1 className="cart_agree_item_title 3">
                                                {pageLanguage === "fa" ? "نام اتاق" : "Room Label"}
                                                &nbsp;
                                              </h1>
                                              <h2 className="cart_agree_item_desc">
                                                {pageLanguage === "fa"
                                                  ? roomNameFa +
                                                    (WindowDescription === "" ? "" : " / " + WindowDescription)
                                                  : roomName +
                                                    (WindowDescription === "" ? "" : " / " + WindowDescription)}
                                              </h2>
                                            </li>
                                            {moreInfoInput !== "" && (
                                              <li className="basket_item_title_desc basket_item_title_desc_new 36" style={{marginTop: "0.8rem"}}>
                                                <h1 className="cart_agree_item_title">
                                                  {t("Order Notes")}&nbsp;
                                                </h1>
                                                <ShowMoreLineLimited
                                                  moreInfoInput={moreInfoInput}
                                                  lines={3}
                                                />
                                              </li>
                                            )}
                                          </div>
                                        </Accordion.Body>
                                      </Accordion.Item>
                                    </Accordion>
                                  </h3>
                                </div>
                              );
                              resolve();
                            });
                          })
                          .catch((err) => {
                            console.log(err);
                            resolve();
                          });
                      });
                    } else {
                      promiseArr0[0] = new Promise((resolve, reject) => {
                        let keysToProcess = Object.keys(obj).filter((key) => {
                          console.log(`obj`, obj);
                          if (key === "IsWalled") return false;
                          return true;
                        });
                        let promiseArr3 = [];
                        keysToProcess.forEach((key, i) => {
                          promiseArr3[i] = new Promise((resolve, reject) => {
                            let tempObj = userProjects.find((obj) => obj["apiLabel"] === key);
                            if (tempObj === undefined || obj[key] === undefined) {
                              // delArr.push(index);
                              resolve();
                            } else if (
                              tempObj["displayWhen"] &&
                              !Object.keys(tempObj["displayWhen"]).every(
                                (conditionKey) =>
                                  obj[conditionKey] === tempObj["displayWhen"][conditionKey]
                              )
                            ) {
                              resolve();
                            } else if (
                              tempObj["apiLabel"] === "WindowWidth" &&
                              tempObj["measurements"]
                            ) {
                              if (firstMeasurements) {
                                firstMeasurements = false;
                                if (obj["CalcWindowSize"]) {
                                  GetUserProjectData(obj1, false)
                                    .then((temp) => {
                                      desc[tempObj["order"]] = (
                                        <div className="basket_item_title_desc basket_item_title_desc_new 37" key="basket-measurements">
                                          <h3 className="basket_measurement_accordion_container">
                                            <Accordion>
                                              <Accordion.Item eventKey="0">
                                                <ContextAwareToggleViewDetails
                                                  eventKey="0"
                                                  textOnHide={
                                                    <>
                                                      {NumToFa(
                                                        obj["WindowWidth"] + t("Measurements CM"),
                                                        pageLanguage
                                                      )}
                                                      <span dir="ltr"> x </span>
                                                      {NumToFa(
                                                        obj["WindowHeight"] + t("Measurements CM"),
                                                        pageLanguage
                                                      )}
                                                    </>
                                                  }
                                                  textOnShow={t("Hide Details")}
                                                  textOnHide2={t("Measurements")}
                                                  textOnShow2={t("Measurements")}
                                                  type={2}
                                                />
                                                <Accordion.Body className="basket_item_title_dropdown dk_curtain_preview_dropdown">
                                                  <div className="basket_item_title_container 16">
                                                    <GetMeasurementArray
                                                      modelId={`${SewingModelId}`}
                                                      cartValues={temp}
                                                    />
                                                  </div>
                                                </Accordion.Body>
                                              </Accordion.Item>
                                            </Accordion>
                                          </h3>
                                        </div>
                                      );
                                      resolve();
                                    })
                                    .catch((err) => {
                                      console.log(err);
                                      resolve();
                                    });
                                } else {
                                  desc[tempObj["order"]] = (
                                    <div className="basket_item_title_desc basket_item_title_desc_new 38" key="basket-measurements">
                                      <h3>{t("Measurements")}&nbsp;</h3>

                                      <h4>
                                        {NumToFa(
                                          obj["WindowWidth"] + t("Measurements CM"),
                                          pageLanguage
                                        )}
                                        <span dir="ltr"> x </span>
                                        {NumToFa(
                                          obj["WindowHeight"] + t("Measurements CM"),
                                          pageLanguage
                                        )}
                                      </h4>
                                    </div>
                                  );
                                  resolve();
                                }
                              } else {
                                resolve();
                              }
                            } else if (
                              tempObj["apiLabel"] === "WindowHeight" &&
                              tempObj["measurements"]
                            ) {
                              resolve();
                            } else {
                              if (
                                tempObj["title"] !== "" &&
                                tempObj["lang"].indexOf(pageLanguage) > -1
                              ) {
                                let objLabel = "";
                                let border = t(obj["borderPosition"]);
                                let apiValue =
                                  obj[tempObj["apiLabel"]] === null
                                    ? "null"
                                    : obj[tempObj["apiLabel"]].toString();
                                if (
                                  tempObj["apiLabel"] === "MountPositionId" &&
                                  Number(obj.MountPositionId) === 4802
                                ) {
                                  const isWalledRaw = normalizeOutsideMountSubType(
                                    obj.IsWalled,
                                    obj.installationLocation
                                  );
                                  objLabel =
                                    formatCombinedOutsideMountLabel(isWalledRaw, pageLanguage, t) ||
                                    t("Outside Mount");
                                } else if (
                                  tempObj["apiLabel"] === "ControlType" &&
                                  obj["ControlType"] === "Motorized"
                                ) {
                                  const keyValue = obj[key] != null ? obj[key].toString() : "";
                                  const motorTypeValue =
                                    obj["MotorType"] != null ? obj["MotorType"].toString() : "";
                                  objLabel =
                                    pageLanguage === "fa"
                                      ? NumberToPersianWord.convertEnToPe(
                                          `${t(keyValue)} / ${t(motorTypeValue)}`
                                        ).toString()
                                      : `${t(keyValue)} / ${t(motorTypeValue)}`;
                                } else if (tempObj["titleValue"] === null) {
                                  if (tempObj["titlePostfix"] === "") {
                                    objLabel =
                                      pageLanguage === "fa"
                                        ? NumberToPersianWord.convertEnToPe(
                                            `${t(apiValue.toString())}`
                                          ).toString()
                                        : t(apiValue.toString());
                                  } else {
                                    objLabel =
                                      pageLanguage === "fa"
                                        ? NumberToPersianWord.convertEnToPe(
                                            `${apiValue}`
                                          ).toString() + t(tempObj["titlePostfix"])
                                        : apiValue.toString() + t(tempObj["titlePostfix"]);
                                  }
                                } else {
                                  if (tempObj["titleValue"][apiValue.toString()] === null) {
                                    if (tempObj["titlePostfix"] === "") {
                                      objLabel = t(apiValue.toString());
                                    } else {
                                      objLabel =
                                        pageLanguage === "fa"
                                          ? NumberToPersianWord.convertEnToPe(
                                              `${apiValue}`
                                            ).toString() + t(tempObj["titlePostfix"])
                                          : apiValue.toString() + t(tempObj["titlePostfix"]);
                                    }
                                  } else {
                                    objLabel = t(tempObj["titleValue"][apiValue.toString()]);
                                  }
                                }
                                temp5[getDkBasketDetailOrder(SewingModelId, tempObj, userProjects)] = (
                                  <li className="cart_agree_item cart_agree_item_new" key={key}>
                                    <h1 className="cart_agree_item_title">
                                      {t(tempObj["title"])}&nbsp;
                                    </h1>
                                    <h2 className="cart_agree_item_desc">{objLabel}</h2>
                                  </li>
                                );

                                resolve();
                              } else {
                                resolve();
                              }
                            }
                          });
                        });
                        Promise.all(promiseArr3).then(() => {
                          desc[40] = (
                            <div className="basket_item_title_desc basket_item_title_desc_new 39" key="basket-customize">
                              {/*<h3>{t("Measurements")}&nbsp;</h3>*/}
                              <h3 className="basket_measurement_accordion_container">
                                <Accordion>
                                  <Accordion.Item eventKey="0">
                                    <ContextAwareToggleViewDetails
                                      eventKey="0"
                                      textOnHide={t("View Details")}
                                      textOnShow={t("Hide Details")}
                                      textOnHide2={t("Customize")}
                                      textOnShow2={t("Customize")}
                                      type={2}
                                    />
                                    <Accordion.Body className="basket_item_title_dropdown dk_curtain_preview_dropdown">
                                      <div className="basket_item_title_container 17">
                                        <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_general">
                                          <h1 className="cart_agree_item_fabrics_sorted_title 6">
                                            {t("General Details")}
                                          </h1>
                                          <ul>
                                            {obj["FabricDesignEn"] !== "" &&
                                              obj["BorderOrTrimColorEn"] !== "" &&
                                              obj["BorderOrTrimColorEn"] && (
                                                <li className="cart_agree_item cart_agree_item_new 12">
                                                  <h1 className="cart_agree_item_title">
                                                    {t("Decorative Border")}&nbsp;
                                                  </h1>
                                                  <h2 className="cart_agree_item_desc">
                                                    {pageLanguage === "fa"
                                                      ? obj["BorderOrTrimDesignFa"] +
                                                        " / " +
                                                        obj["BorderOrTrimColorFa"]
                                                      : CapitalizeAllWords(
                                                          obj["BorderOrTrimDesignEn"] +
                                                            " / " +
                                                            obj["BorderOrTrimColorEn"]
                                                        )}
                                                    <p>{t(obj["borderPosition"])}</p>
                                                  </h2>
                                                </li>
                                              )}

                                            {temp5.filter(
                                              (item) =>
                                                item !== null &&
                                                !item.props?.children?.[1]?.props?.children?.includes?.(
                                                  "Slight Puddle"
                                                ) &&
                                                !item.props?.children?.[1]?.props?.children?.includes?.(
                                                  "تا روی زمین"
                                                )
                                            )}
                                            {obj["RemoteName"] &&
                                              obj["MotorChannels"] &&
                                              obj["RemoteName"] !== "" &&
                                              obj["MotorChannels"] !== "" &&
                                              obj["SewingModelId"] === "0326" && (
                                                <>
                                                  <li className="cart_agree_item cart_agree_item_new">
                                                    <h1 className="cart_agree_item_title">
                                                      {t("Remote Name")}&nbsp;
                                                    </h1>
                                                    <h2 className="cart_agree_item_desc 6">
                                                      {obj["RemoteName"]}
                                                    </h2>
                                                  </li>
                                                  <li className="cart_agree_item cart_agree_item_new">
                                                    <h1 className="cart_agree_item_title">
                                                      {t("Motor Channels")}&nbsp;
                                                    </h1>
                                                    <h2 className="cart_agree_item_desc 6">
                                                      {obj["MotorChannels"]?.join(", ")}
                                                    </h2>
                                                  </li>
                                                </>
                                              )}
                                          </ul>
                                        </li>

                                        <li className="cart_agree_item cart_agree_item_new cart_agree_item_fabrics_sorted cart_agree_item_label"
                                         style={{padding: "0.9rem 0"}}
                                        >
                                          <h1 className="cart_agree_item_title 4">
                                            {pageLanguage === "fa" ? "نام اتاق" : "Room Label"}
                                            &nbsp;
                                          </h1>
                                          <h2 className="cart_agree_item_desc">
                                            {pageLanguage === "fa"
                                              ? roomNameFa +
                                                (obj["WindowDescription"] === "" ? "" : " / " + obj["WindowDescription"])
                                              : roomName +
                                                (obj["WindowDescription"] === "" ? "" : " / " + obj["WindowDescription"])}
                                          </h2>
                                        </li>
                                        {moreInfoInput !== "" && (
                                          <li className="basket_item_title_desc basket_item_title_desc_new 40" style={{marginTop: "0.8rem"}}>
                                            <h1 className="cart_agree_item_title">
                                              {t("Order Notes")}&nbsp;
                                            </h1>
                                            <ShowMoreLineLimited
                                              moreInfoInput={moreInfoInput}
                                              lines={3}
                                            />
                                          </li>
                                        )}
                                      </div>
                                    </Accordion.Body>
                                  </Accordion.Item>
                                </Accordion>
                              </h3>
                            </div>
                          );
                          resolve();
                        });
                      });
                    }

                    Promise.all(promiseArr0).then(() => {
                      temp[bagLength - index - 1] = (
                        <li
                          className="drapery_basket_item 4"
                          key={index}
                          ref={(ref) => (draperyRef.current[index] = ref)}
                        >
                          <span className="basket_item_title">
                            <div className="basket_item_image_container 4">
                              <img src={imgUrl(photoUrl)} alt="" className="basket_item_img" />
                            </div>
                            <div className="basket_item_title_container 18">
                              {(isBasketItemUnavailable(obj1) || hasBasketItemPriceChanged(obj1)) && (
                                <div className="basket_item_status_alerts">
                                  {isBasketItemUnavailable(obj1) && (
                                    <div className="basket_item_availability_alert">
                                      <p className="basket_item_availability_alert_text">
                                        {t("basket_item_unavailable")}
                                      </p>
                                      <div className="basket_item_availability_alert_actions">
                                        <button
                                          type="button"
                                          className="btn basket_desc_button"
                                          onClick={() =>
                                            setBasketNumber(getGuestCartRemoveId(obj1), 1, 5)
                                          }
                                        >
                                          {t("REMOVE")}
                                        </button>
                                        {obj["SewingModelId"] === "0321" ||
                                        obj["SewingModelId"] === "0099" ? (
                                          <button
                                            type="button"
                                            className="btn basket_desc_button"
                                            onClick={() => showEditUnderConstructionMessage(index)}
                                          >
                                            {t("EDIT")}
                                          </button>
                                        ) : (
                                          <Link
                                            className="btn basket_desc_button"
                                            to={
                                              "/" +
                                              pageLanguage +
                                              JSON.parse(JSON.stringify(UserProjects))[
                                                obj["SewingModelId"]
                                              ]["route"] +
                                              (obj["PageType"] ? "/" + obj["PageType"] : "") +
                                              "/Bag-Projects/" +
                                              index +
                                              "/Page-ID/" +
                                              obj["PageId"]
                                            }
                                          >
                                            {t("EDIT")}
                                          </Link>
                                        )}
                                      </div>
                                    </div>
                                  )}
                                  {hasBasketItemPriceChanged(obj1) && (
                                    <div className="basket_item_price_change_alert">
                                      <p className="basket_item_price_change_alert_text">
                                        {t("basket_item_price_changed")}
                                      </p>
                                    </div>
                                  )}
                                </div>
                              )}
                              <div className="basket_item_title_name desktop_only 4">
                                {pageLanguage === "fa"
                                  ? convertToPersian(defaultModelNameFa) + " سفارشی "
                                  : "Custom " + capitalizeWordsText(defaultModelName)}
                                <h5>
                                  {/* &nbsp;  */}
                                  {pageLanguage === "fa"
                                    ? obj["RoomNameFa"] +
                                      (!obj["WindowName"] ? "" : " / " + obj["WindowDescription"])
                                    : obj["RoomNameEn"] +
                                      (!obj["WindowName"] ? "" : " / " + obj["WindowDescription"])}
                                </h5>
                              </div>
                              <div className="basket_item_title_name mobile_only">
                                <span className="basket_item_title_mob_container">
                                  <h5>
                                    <h4>
                                      {pageLanguage === "fa"
                                        ? convertToPersian(defaultModelNameFa) + " سفارشی "
                                        : "Custom " + defaultModelName}
                                      &nbsp;&nbsp;
                                    </h4>
                                    {pageLanguage === "fa"
                                      ? obj["RoomNameFa"] +
                                        (!obj["WindowName"] ? "" : " / " + obj["WindowName"])
                                      : obj["RoomNameEn"] +
                                        (!obj["WindowName"] ? "" : " / " + obj["WindowName"])}
                                  </h5>
                                </span>
                                <span className="basket_item_title_mob_price_container">
                                  {GetPrice(
                                    obj["Price"],
                                    pageLanguage,
                                    t("TOMANS"),
                                    isTabletOrMobile
                                  )}
                                </span>
                              </div>
                              {SewingModelId === "0326" && (
                                <div className="basket_item_title_desc basket_item_title_desc_new 41">
                                  <h3>
                                    {pageLanguage === "fa" ? "پارچه/رنگ" : "Fabric/Color"}
                                    &nbsp;
                                  </h3>
                                  <h4>
                                    {obj["statusFabricItem"] === "mono" ? (
                                      resolveDkMonoFabricLabel(dkFabricObj, pageLanguage, t)
                                    ) : (
                                      <DkMultiFabricAccordion
                                        obj={dkFabricObj}
                                        pageLanguage={pageLanguage}
                                        t={t}
                                        containerClassName="dk_curtain_preview_container 2"
                                        detailContainerClassName="dk_curtain_preview_detail_container 6"
                                        ToggleComponent={ContextAwareToggleViewDetails}
                                      />
                                    )}
                                  </h4>
                                </div>
                              )}
                              {SewingModelId === "0325" && (
                                <>
                                  <div className="basket_item_title_desc basket_item_title_desc_new 42">
                                    <h3>{t("dualRoller_step1")}&nbsp;</h3>
                                    <h4>
                                      {pageLanguage === "fa"
                                        ? obj["FabricDesignFa"] + " / " + obj["FabricColorFa"]
                                        : CapitalizeAllWords(
                                            obj["FabricDesignEn"] + " / " + obj["FabricColorEn"]
                                          )}
                                    </h4>
                                  </div>
                                  <div className="basket_item_title_desc basket_item_title_desc_new 43">
                                    <h3>{t("dualRoller_step2")}&nbsp;</h3>
                                    <h4>
                                      {pageLanguage === "fa"
                                        ? obj["FabricDesignFa2"] + " / " + obj["FabricColorFa2"]
                                        : CapitalizeAllWords(
                                            obj["FabricDesignEn2"] + " / " + obj["FabricColorEn2"]
                                          )}
                                    </h4>
                                  </div>
                                </>
                              )}

                              {(SewingModelId === "0303" ||
                                SewingModelId === "0324" ||
                                SewingModelId === "0097" ||
                                SewingModelId === "0327" ||
                                SewingModelId === "0328") && (
                                <>
                                  {obj["FabricId"] && (
                                    <div className="basket_item_title_desc basket_item_title_desc_new 44">
                                      <h3>{t("Fabric & Color")}&nbsp;</h3>
                                      <h4>
                                        {pageLanguage === "fa"
                                          ? obj["FabricDesignFa"] + " / " + obj["FabricColorFa"]
                                          : CapitalizeAllWords(
                                              obj["FabricDesignEn"] + " / " + obj["FabricColorEn"]
                                            )}
                                      </h4>
                                    </div>
                                  )}
                                </>
                              )}
                              {desc}

                              <div className="basket_item_qty_mob_container mobile_only">
                                <div className="basket_item_qty_numbers">
                                  <button
                                    type="text"
                                    className="basket_qty_minus"
                                    onClick={() => setBasketNumber(index, 0, 0, -1)}
                                  >
                                    <img
                                      src={require("../Images/public/minus.svg").default}
                                      alt=""
                                      className="qty_math_icon"
                                    />
                                  </button>
                                  <input
                                    type="text"
                                    className="basket_qty_num 7"
                                    value={
                                      pageLanguage === "fa"
                                        ? NumberToPersianWord.convertEnToPe(
                                            `${obj1["WindowCount"]}`
                                          )
                                        : obj1["WindowCount"]
                                    }
                                    onChange={(e) =>
                                      setBasketNumber(
                                        index,
                                        NumberToPersianWord.convertPeToEn(`${e.target.value}`),
                                        0
                                      )
                                    }
                                    readOnly
                                  />
                                  <button
                                    type="text"
                                    className="basket_qty_plus"
                                    onClick={() => setBasketNumber(index, 0, 0, 1)}
                                  >
                                    <img
                                      src={require("../Images/public/plus.svg").default}
                                      alt=""
                                      className="qty_math_icon"
                                    />
                                  </button>
                                </div>
                                <div className="basket_item_qty_mob_price">
                                  {GetPrice(
                                    obj1["Price"] * obj1["WindowCount"],
                                    pageLanguage,
                                    t("TOMANS"),
                                    isTabletOrMobile
                                  )}
                                </div>
                              </div>
                              {zipcode && (
                                <div className="basket_zipcode_container 4">
                                  <div className="basket_zipcode_left">
                                    <h1 className="basket_zipcode_title">
                                      {t("basket_zipcode_text1")}
                                    </h1>
                                    {(zipcodeId === -1 || zipcodeId !== index) && (
                                      <div className="basket_zipcode_change_container">
                                        <h2 className="basket_zipcode_title2">
                                          {t("basket_zipcode_text3")}
                                          {zipcode}&nbsp;|&nbsp;
                                        </h2>
                                        <h2
                                          className="basket_zipcode_title3 text_underline"
                                          onClick={() => {
                                            setOriginalZipcode(zipcode);
                                            setZipcodeAll("");
                                            setZipcodeId(index);
                                          }}
                                        >
                                          {t("Change")}
                                        </h2>
                                      </div>
                                    )}
                                    {zipcodeId === index && (
                                      <div className="basket_zipcode_change_input_container">
                                        <input
                                          className="zipcode_input form-control"
                                          type="text"
                                          name="zipcode_input"
                                          defaultValue={zipcodeAll}
                                          placeholder={t("Enter Zip Code")}
                                          onChange={(e) => {
                                            setZipcodeAll(e.target.value.replace(/\D+/g, ""));
                                          }}
                                          onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                              setZipcodeButton(true);
                                            }
                                          }}
                                        />
                                        <button
                                          className="zipcode_input_button white_btn 4"
                                          onClick={() => {
                                            console.log(`zipcode`, zipcode);
                                            console.log(`zipcodeAll`, zipcodeAll);
                                            setZipcodeButton(true);
                                          }}
                                        >
                                          {t("Update")}
                                        </button>
                                      </div>
                                    )}
                                    {zipcodeId === index && hasInstall === false && (
                                      <h3 className="basket_zipcode_err">
                                        {t("basket_zipcode_err")}
                                      </h3>
                                    )}
                                    <button
                                      className="basket_zipcode_btn text_underline 4"
                                      onClick={() => removeZipcode(index)}
                                    >
                                      {t("Remove")}
                                    </button>
                                  </div>
                                  <div className="basket_zipcode_right">
                                    <h2 className="basket_zipcode_price 4">
                                      {GetPrice(
                                        // obj["InstallAmount"],
                                        obj["InstallAmount"] * obj1["WindowCount"],
                                        pageLanguage,
                                        t("TOMANS"),
                                        isTabletOrMobile
                                      )}
                                    </h2>
                                  </div>
                                </div>
                              )}
                              <div className="basket_item_delivery_section">
                                <div className="basket_item_delivery_avail">
                                  <h2 className="basket_item_delivery_desc 3">
                                    {zipcode && zipcode !== ""
                                      ? t("AVAILABILITY_desc")
                                      : t("AVAILABILITY_desc2")}
                                  </h2>
                                </div>
                                <div className="basket_item_delivery_return">
                                  <h2 className="basket_item_delivery_desc 4">
                                    {t("RETURNS_desc")}
                                  </h2>
                                </div>
                              </div>
                              <div className="basket_item_desc_button 4">
                                {obj["SewingModelId"] === "0321" ||
                                obj["SewingModelId"] === "0099" ? (
                                  <div className="basket_edit_action_wrapper">
                                    <button
                                      type="button"
                                      className="btn basket_desc_button"
                                      onClick={() => showEditUnderConstructionMessage(index)}
                                    >
                                      {t("EDIT")}
                                    </button>
                                    {String(editUnderConstructionId) === String(index) && (
                                      <span className="basket_edit_under_construction_msg">
                                        {pageLanguage === "fa"
                                          ? "صفحه در حال ساخت می باشد."
                                          : "This page is under construction."}
                                      </span>
                                    )}
                                  </div>
                                ) : (
                                  <Link
                                    className="btn basket_desc_button"
                                    to={
                                      "/" +
                                      pageLanguage +
                                      JSON.parse(JSON.stringify(UserProjects))[
                                        obj["SewingModelId"]
                                      ]["route"] +
                                      (obj["PageType"] ? "/" + obj["PageType"] : "") +
                                      "/Bag-Projects/" +
                                      index +
                                      "/Page-ID/" +
                                      obj["PageId"]
                                    }
                                  >
                                    {t("EDIT")}
                                  </Link>
                                )}
                                <button
                                  className="btn basket_desc_button"
                                  onClick={() => copyItem(index, obj["PageId"], obj["PageType"])}
                                >
                                  {t("Add Similar")}
                                </button>
                                <button
                                  className="btn basket_desc_button"
                                  onClick={() =>
                                    setBasketNumber(getGuestCartRemoveId(obj1), 1, 5)
                                  }
                                >
                                  {t("REMOVE")}
                                </button>
                                <button
                                  className="btn basket_desc_button"
                                  onClick={() => saveForLaterBasketProject(index, obj1)}
                                >
                                  {t("SAVE TO MY ACCOUNT")}
                                </button>
                              </div>
                            </div>
                          </span>
                          <span className="basket_item_price desktop_only 4">
                            {getPriceBasket(obj1["Price"], pageLanguage, t("T"), isTabletOrMobile)}
                          </span>
                          <span className="basket_item_qty desktop_only">
                            <div className="basket_item_qty_numbers 8">
                              <button
                                type="text"
                                className="basket_qty_minus"
                                onClick={() => setBasketNumber(fabricItemId, 0, 0, -1)}
                              >
                                <img
                                  src={require("../Images/public/minus.svg").default}
                                  alt=""
                                  className="qty_math_icon"
                                />
                              </button>
                              <input
                                type="text"
                                className="basket_qty_num 8"
                                value={
                                  pageLanguage === "fa"
                                    ? NumberToPersianWord.convertEnToPe(`${obj1["WindowCount"]}`)
                                    : obj1["WindowCount"]
                                }
                                onChange={(e) =>
                                  setBasketNumber(
                                    index,
                                    NumberToPersianWord.convertPeToEn(`${e.target.value}`),
                                    0
                                  )
                                }
                                readOnly
                              />
                              <button
                                type="text"
                                className="basket_qty_plus"
                                // onClick={() => setBasketNumber(index, 0, 0, 1)}
                                onClick={() => {
                                  setBasketNumber(fabricItemId, 0, 0, 1);
                                }}
                              >
                                <img
                                  src={require("../Images/public/plus.svg").default}
                                  alt=""
                                  className="qty_math_icon"
                                />
                              </button>
                            </div>
                          </span>
                          <span className="basket_item_total desktop_only 4">
                            {getPriceBasket(
                              obj1["Price"] * obj1["WindowCount"],
                              pageLanguage,
                              t("T"),
                              isTabletOrMobile
                            )}
                          </span>
                          <span
                            className={
                              uploadedFiles && uploadedFiles.length > 0
                                ? "basket_item_visible1"
                                : "basket_item_hidden1"
                            }
                          >
                            {uploadedFiles && uploadedFiles.length > 0 && (
                              <div className="select_container">
                                <Select
                                  className="select"
                                  placeholder={t("UPLOADED IMAGES/PDF")}
                                  portal={document.body}
                                  dropdownPosition="bottom"
                                  dropdownHandle={false}
                                  dropdownGap={0}
                                  dropdownRenderer={({ props, state, methods }) => (
                                    <CustomDropdownFiles
                                      props={props}
                                      state={state}
                                      methods={methods}
                                      fabricItemId={fabricItemId}
                                      obj1={obj1}
                                    />
                                  )}
                                  contentRenderer={({ props, state, methods }) => (
                                    <CustomControlFiles
                                      props={props}
                                      state={state}
                                      methods={methods}
                                    />
                                  )}
                                  onChange={(selected) => {
                                    if (selected[0] !== undefined) {
                                      console.log("6743");
                                      deleteFileFromProject(selected[0], projectId, fabricItemId);
                                    }
                                  }}
                                  options={tempSelectArr}
                                />
                              </div>
                            )}
                          </span>
                        </li>
                      );
                      resolve();
                    });
                  }
                }
              });
            });

            Promise.all(promiseArr).then(() => {
              setDraperyProductList(temp);
              if (localStorage.getItem("cart") !== null) {
              } else {
                setCart({});
              }
              setSubTotalPrice(draperiesTotalPrice + productsTotalPrice);
              setInstallPrice(draperiesTotalInstall);
              setTransportPrice(draperiesTotalTransport);
              setTotalPrice(
                draperiesTotalPrice +
                  productsTotalPrice +
                  draperiesTotalInstall +
                  draperiesTotalTransport
              );
              setNoShipping(tempNoShip);
            });
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        setDraperyProductList([]);
        setSubTotalPrice(0);
        setInstallPrice(0);
        setTransportPrice(0);
        setTotalPrice(0);
        setNoShipping(true);
      }
    }
  }

  useEffect(() => {
    if (isLoggedIn && Object.keys(loginAwaiting).length) {
      let projectObj = JSON.parse(JSON.stringify(loginAwaiting));
      setLoginAwaiting({});
      axios
        .post(baseURLAddProject, projectObj, {
          headers: authHeader(),
        })
        .then((response) => {
          setCartChanged(cartChanged + 1);
        })
        .catch((err) => {
          console.log(err);
          if (err.response && err.response.status === 401) {
            refreshToken().then((response2) => {
              if (response2 !== false) {
                setLoginAwaiting(projectObj);
              } else {
                setCartChanged(cartChanged + 1);
              }
            });
          } else {
            setCartChanged(cartChanged + 1);
          }
        });
    }
  }, [isLoggedIn]);

  useEffect(() => {
    if (!isLoggedIn && !showLogin2 && Object.keys(loginAwaiting).length) {
      if (localStorage.getItem("cart") !== null) {
        let cartObj = JSON.parse(localStorage.getItem("cart"));
        let temp = cartObj["drapery"];
        temp.push(loginAwaiting);
        cartObj["drapery"] = temp;
        localStorage.setItem("cart", JSON.stringify(cartObj));
        setLoginAwaiting({});
      } else {
        let newCartObj = {};
        let newCartArr = [];
        newCartArr[0] = loginAwaiting;
        newCartObj["drapery"] = newCartArr;
        newCartObj["product"] = [];
        newCartObj["swatches"] = [];
        localStorage.setItem("cart", JSON.stringify(newCartObj));
        setLoginAwaiting({});
      }
      setCartChanged(cartChanged + 1);
    }
  }, [showLogin2]);

  useEffect(() => {
    getCart();
  }, [cartChanged, location.pathname]);

  useEffect(() => {
    if (Object.keys(cart).length !== 0) {
      if (isLoggedIn) {
        if (swatchOnly === undefined) {
          let draperies = cart["CartDetails"]
            .filter((object1) => {
              return object1["TypeId"] === 6403;
            })
            .filter((object1) => object1["SewingOrder"])
            .filter((object1) => object1["SewingOrder"]["PreorderText"]);

          let products = cart["CartDetails"].filter((object1) => {
            return object1["TypeId"] === 6401;
          });

          let swatches = cart["CartDetails"].filter((object1) => {
            return object1["TypeId"] === 6402;
          });
          setSubTotalPrice(cart["TotalAmount"]);
          console.log(`cart["InstallAmount"]`, cart["InstallAmount"]);
          setInstallPrice(cart["InstallAmount"]);
          setTransportPrice(cart["TransportationAmount"]);
          setTotalPrice(cart["PayableAmount"]);
          setDrapery(draperies);
          setDraperyCount(draperies.length);
          setProduct(products);
          setProductCount(products.length);
          setDraperyProduct([...draperies, ...products]);
          setDraperyProductCount([...draperies, ...products].length);
          setSwatches(swatches);
          setSwatchesCount(swatches.length);
        } else if (swatchOnly && swatchOnly === "Swatches") {
          let swatches = cart["CartDetails"].filter((object1) => {
            return object1["TypeId"] === 6402;
          });
          setSwatches(swatches);
          setSwatchesCount(swatches.length);
        } else {
          navigate("/" + pageLanguage);
        }
      } else {
        let drapery = [];
        let product = [];
        if (cart["drapery"] === undefined || cart["drapery"].length === 0) {
          setDrapery([]);
          setDraperyCount(0);
        } else {
          drapery = cart["drapery"];
          setDrapery(cart["drapery"]);
          setDraperyCount(cart["drapery"].length);
        }
        if (cart["product"] === undefined || cart["product"] === []) {
          setProduct([]);
          setProductCount(0);
        } else {
          product = cart["product"];
          setProduct(cart["product"]);
          setProductCount(cart["product"].length);
        }
        setDraperyProduct([...drapery, ...product]);
        setDraperyProductCount([...drapery, ...product].length);
        if (cart["swatches"] === undefined || cart["swatches"] === []) {
          setSwatches([]);
          setSwatchesCount(0);
        } else {
          setSwatches(cart["swatches"]);
          setSwatchesCount(cart["swatches"].length);
        }
      }
    } else {
      setDrapery([]);
      setProduct([]);
      setSwatches([]);
    }
    if (firstRender.current) {
      firstRender.current = false;
    } else {
      dispatch({
        type: CartUpdatedTrue,
        payload: { mainCart: cart },
      });
    }
  }, [JSON.stringify(cart)]);

  useEffect(() => {
    if (draperyProduct.length) {
      renderDraperies();
    }
  }, [draperyProduct, editUnderConstructionId]);

  useEffect(() => {
    renderDraperies();
  }, [zipcodeId, pageLanguage]);

  useEffect(() => {
    if (zipcodeButton) {
      setZipcodeButton(false);
      if (zipcodeId !== -1) {
        // اگر input خالی باشد یا کدپستی جدید با کدپستی اصلی یکسان باشد، فقط فرم رو ببند
        if (zipcodeAll === "" || zipcodeAll === originalZipcode) {
          console.log("Zipcode is empty or same — just closing the form");
          setZipcodeId(-1);
          return;
        }
        changeZipcode();
      }
    }
  }, [zipcodeButton]);

  useEffect(() => {
    if (hasInstall === false) {
      renderDraperies();
      setHasInstall(null);
    }
  }, [hasInstall]);
  useEffect(() => {
    if (isLoggedIn) {
      if (swatches.length) {
        let temp = [];
        let tempTotal = 0;
        let promise2 = new Promise((resolve, reject) => {
          for (let i = 0; i < swatches.length; i++) {
            let obj = swatches[i];
            let CartDetailId = obj["CartDetailId"];
            let ProductEnName = obj["DesignEnName"];
            let ProductName = obj["DesignName"];
            let ProductColorEnName = obj["ColorEnName"];
            let ProductColorName = obj["ColorName"];
            let photoUrl = obj["PhotoUrl"];
            let price = obj["PayableAmount"];
            tempTotal += price;
            temp[i] = (
              <li
                className="swatches_basket_item"
                key={i}
                ref={(ref) => (draperyRef.current[CartDetailId] = ref)}
              >
                <div className="swatches_item_image_container 1">
                  <img src={imgUrl(photoUrl)} alt="" className="swatches_item_img img-fluid" />
                </div>
                <div className="swatches_item_title_container">
                  <div className="swatches_item_title_name 1">
                    {pageLanguage === "fa" ? ProductName : capitalizeWordsText(ProductEnName)}
                  </div>
                  <div className="swatches_item_remove">
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => deleteBasketProject(CartDetailId)}
                    />
                  </div>
                </div>
                <div className="swatches_item_title_name 2">
                  {pageLanguage === "fa" ? ProductColorName : ProductColorEnName}
                </div>
                <div className="swatches_item_title_price">
                  {price === 0
                    ? t("Free")
                    : GetPrice(price, pageLanguage, t("T"), isTabletOrMobile)}
                </div>
              </li>
            );
            if (i === swatches.length - 1) {
              resolve();
            }
          }
        });
        promise2.then(() => {
          setSwatchesTotalPrice(tempTotal);
          setSwatchesList(temp);
          if (swatchOnly && swatchOnly === "Swatches") {
            setTotalPrice(tempTotal);
          }
        });
      } else {
        setSwatchesList([]);
      }
    }
  }, [swatches]);

  useEffect(() => {
    if (
      pageLanguage !==
      location.pathname
        .split("")
        .slice(1, 3)
        .join("")
    ) {
      const tempLang = location.pathname.split("");
      setPageLanguage(tempLang.slice(1, 3).join(""));
      setCart({});
    }
  }, [location.pathname]);

  useEffect(() => {
    const cartData = localStorage.getItem("cart");
    if (cartData) {
      const cart = JSON.parse(cartData);
      setDraperyProduct(cart.drapery || []);
      renderDraperies();
    }
  }, [cartVersion]);

  return (
    <div className={`basket_page_container ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}>
      {draperyCount + productCount + swatchesCount > 0 && (
        <div className="basket_container">
          <div className="basket_title_container">
            <h1 className="basket_title">
              {t("Shopping Bag")} (
              {pageLanguage === "fa"
                ? NumberToPersianWord.convertEnToPe(
                    `${draperyCount + productCount + swatchesCount}`
                  )
                : draperyCount + productCount + swatchesCount}
              )
            </h1>
            {/* <h3 className="basket_title_link" onClick={() => navigate("/" + pageLanguage)}>
              {t("CONTINUE SHOPPING")}
            </h3> */}
          </div>
          <div className="basket_flex">
            <div className="basket_section">
              {draperyProductCount > 0 && (
                <div className="drapery_basket">
                  <div className="drapery_basket_header basket_header desktop_only">
                    <span className="basket_header_title">{t("MADE TO ORDER")}</span>
                    <span className="basket_header_price">{t("PRICE")}</span>
                    <span className="basket_header_qty">{t("QTY")}</span>
                    <span className="basket_header_total">{t("TOTAL PRICE")}</span>
                  </div>
                  <ul className="drapery_basket_items">{draperyProductList}</ul>
                </div>
              )}

              {swatchesCount > 0 && (
                <div className="swatches_basket">
                  <div className="swatches_basket_header basket_header">
                    <span className="basket_header_title">{t("SWATCHES")}</span>
                    <span className="basket_header_price" />
                    <span className="basket_header_qty" />
                    {/* <span className="basket_header_swatches_only">
                      <div
                        className="arrow_container"
                        onClick={() => navigate("/" + pageLanguage + "/Checkout/Swatches")}
                      >
                        <span className="swatches_only">{t("Order Swatches Only")}</span>
                        <span className="arrow_body">
                          <span className="head" />
                        </span>
                      </div>
                    </span> */}
                  </div>
                  <div className="swatch_list_container">
                    <div className="swatch_price_section mobile_only">
                      <span className="total_swatch_price">
                        {swatchesTotalPrice > 0
                          ? GetPrice(
                              swatchesTotalPrice,
                              pageLanguage,
                              t("TOMANS"),
                              isTabletOrMobile
                            )
                          : t("Free")}
                      </span>
                    </div>
                    <ul className="swatches_basket_items">{swatchesList}</ul>
                    <div className="swatch_price_section desktop_only">
                      <span className="total_swatch_price">
                        {swatchesTotalPrice > 0
                          ? GetPrice(
                              swatchesTotalPrice,
                              pageLanguage,
                              t("TOMANS"),
                              isTabletOrMobile
                            )
                          : t("Free")}
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="go_to_checkout big_basket">
              <div className="checkout_button_section">
                <span className="checkout_payment_price_detail payment_price_detail 1">
                  <h3>{t("PRODUCT TOTAL")}</h3>
                  <h4>
                    {isLoggedIn
                      ? GetPrice(subTotalPrice, pageLanguage, t("TOMANS"), isTabletOrMobile)
                      : GetPrice(projectDataPrice, pageLanguage, t("TOMANS"), isTabletOrMobile)}
                  </h4>
                </span>
                {installPrice > 0 && (
                  <span className="checkout_payment_price_detail payment_price_detail 2">
                    <h3>{t("INSTALLATION SERVICES")}</h3>
                    <h4>{GetPrice(installPrice, pageLanguage, t("TOMANS"), isTabletOrMobile)}</h4>
                  </span>
                )}
                {transportPrice > 0 && (
                  <span className="checkout_payment_price_detail payment_price_detail 3">
                    <h3>{t("TRANSPORTATION FEE")}</h3>
                    <h4>{GetPrice(transportPrice, pageLanguage, t("TOMANS"), isTabletOrMobile)}</h4>
                  </span>
                )}

                {(totalPrice > 0 || subTotalPrice > 0 || swatches.length > 0) && (
                  <span className="checkout_payment_price_detail payment_price_detail 4">
                    <h3>{t("SHIPPING")}</h3>
                    <h4>
                      {freeShipPrice > 0 &&
                      (isLoggedIn ? totalPrice : projectDataPrice ?? 0) >= freeShipPrice
                        ? t("FREE")
                        : t("CALCULATED AT CHECKOUT")}
                    </h4>
                  </span>
                )}
                <span className="checkout_payment_price_detail payment_price_detail 5">
                  <h3>
                    {freeShipPrice > 0 &&
                    (isLoggedIn ? totalPrice : projectDataPrice ?? 0) >= freeShipPrice
                      ? t("TOTAL")
                      : t("SUBTOTAL")}
                  </h3>
                  <h4>
                    {isLoggedIn
                      ? GetPrice(totalPrice, pageLanguage, t("TOMANS"), isTabletOrMobile)
                      : GetPrice(
                          projectDataPrice + installPrice + transportPrice,
                          pageLanguage,
                          t("TOMANS"),
                          isTabletOrMobile
                        )}
                  </h4>
                </span>
                <Link to={"/" + pageLanguage + "/Checkout"} className="basket_checkout">
                  {t("CHECKOUT NOW")}
                </Link>
                <button
                  className="btn white_btn"
                  onClick={() => modalHandleShow("order_quotation")}
                >
                  {t("ORDER QUOTATION")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {draperyCount + productCount + swatchesCount === 0 && !firstFetch && (
        <div className="basket_container">
          <div className="basket_title_container2">
            <h1 className="basket_title">{t("basket_empty1")}</h1>
            <h2 className="basket_title2">{t("basket_empty2")}</h2>
          </div>
        </div>
      )}
      <Modal dialogClassName="zoomModal" show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>{zoomModalHeader}</Modal.Header>
        <Modal.Body>{zoomModalBody}</Modal.Body>
        <Modal.Footer>
          <button className=" btn btn-new-dark" onClick={() => setShow(false)}>
            {t("CONTINUE")}
          </button>
        </Modal.Footer>
      </Modal>
      <Modal
        dialogClassName={`bigSizeModal ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}
        show={modals["order_quotation"] === undefined ? false : modals["order_quotation"]}
        onHide={() => modalHandleClose("order_quotation")}
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body></Modal.Body>
        <Modal.Footer>
          <button className=" btn btn-new-dark" onClick={() => modalHandleClose("order_quotation")}>
            {t("CONTINUE")}
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default Basket;
